{
  "translation": {
    "ADD_COMPANY.CODE.LABEL": "Código de la Empresa",
    "ADD_COMPANY.COUNTRY.LABEL": "País",
    "ADD_COMPANY.COUNTRY.PLACEHOLDER": "Seleccione un país",
    "ADD_COMPANY.CURRENCY.LABEL": "Moneda",
    "ADD_COMPANY.CURRENCY.PLACEHOLDER": "Seleccione una moneda",
    "ADD_COMPANY.LANGUAGE.LABEL": "Idioma",
    "ADD_COMPANY.LOGO.LABEL": "Seleccionar Logo",
    "ADD_COMPANY.MEASUREMENT_TYPE.LABEL": "Tipo de Medición",
    "ADD_COMPANY.MEASUREMENT_TYPE.PLACEHOLDER": "Seleccione un tipo de medida",
    "ADD_COMPANY.NAME.LABEL": "Nombre",
    "ADD_COMPANY.PARTNER.LABEL": "Socio",
    "ADD_COMPANY.PARTNER.PLACEHOLDER": "Seleccione un socio",
    "ADD_COMPANY.RESPONSE.SUCCESS": "La Compañía ha sido creada exitosamente",
    "ADD_COMPANY.SUBMIT": "Agregar Nueva Empresa",
    "ADD_COMPANY.TITLE": "Agregar Nueva Empresa",
    "ADD_COMPANY.VALIDATION.CODE": "Se requiere el código de la empresa",
    "ADD_COMPANY.VALIDATION.COUNTRY": "Se requiere país",
    "ADD_COMPANY.VALIDATION.CURRENCY": "Se requiere moneda",
    "ADD_COMPANY.VALIDATION.IMAGE": "Se requiere el logotipo de la empresa",
    "ADD_COMPANY.VALIDATION.LANGUAGE": "Se requiere idioma",
    "ADD_COMPANY.VALIDATION.MEASUREMENT_TYPE": "Se requiere el tipo de medida",
    "ADD_COMPANY.VALIDATION.NAME": "Se requiere nombre",
    "ADD_COMPANY.VALIDATION.PARTNER": "Se requiere socio",
    "ADD_FLOW_DATA.BTN.FLOW_DATA": "Agregar Datos de Flujo",
    "ADD_FLOW_DATA.BTN.SUBMIT": "Enviar",
    "ADD_FLOW_DATA.INPUT.DATE_TIME.LABEL": "Fecha y Hora de los Datos de Flujo",
    "ADD_FLOW_DATA.INPUT.DATE_TIME.PLACEHOLDER": "Haz clic aquí para seleccionar la fecha y la hora",
    "ADD_FLOW_DATA.INPUT.FLOW_DATA.LABEL": "Valor",
    "ADD_FLOW_DATA.INPUT.FLOW_DATA.PLACEHOLDER": "Valor de Datos de Flujo",
    "ADD_FLOW_DATA.MODAL.ERROR.DESC": "Por favor, intente de nuevo, los datos de flujo no se han actualizado",
    "ADD_FLOW_DATA.MODAL.ERROR.TITLE": "¡Inténtalo de nuevo!",
    "ADD_FLOW_DATA.MODAL.SUCCESS.DESC": "Los datos de flujo han sido actualizados",
    "ADD_FLOW_DATA.MODAL.SUCCESS.TITLE": "¡Genial!",
    "ADD_PARTNER.ADDRESS.LABEL": "Dirección",
    "ADD_PARTNER.CODE.LABEL": "Código",
    "ADD_PARTNER.COUNTRY.LABEL": "País",
    "ADD_PARTNER.COUNTRY.PLACEHOLDER": "Seleccione un país",
    "ADD_PARTNER.CURRENCY.LABEL": "Moneda",
    "ADD_PARTNER.CURRENCY.PLACEHOLDER": "Seleccione una Moneda",
    "ADD_PARTNER.LOGO.LABEL": "Seleccionar Logo",
    "ADD_PARTNER.NAME.LABEL": "Nombre",
    "ADD_PARTNER.RESPONSE.SUCCESS": "El socio ha sido creado con éxito",
    "ADD_PARTNER.SUBMIT": "Agregar Nuevo Socio",
    "ADD_PARTNER.TITLE": "Agregar Nuevo Socio",
    "ADD_PARTNER.VALIDATION.ADDRESS": "Se requiere dirección",
    "ADD_PARTNER.VALIDATION.CODE": "Se requiere código",
    "ADD_PARTNER.VALIDATION.COUNTRY": "Se requiere país",
    "ADD_PARTNER.VALIDATION.CURRENCY": "Se requiere moneda",
    "ADD_PARTNER.VALIDATION.IMAGE": "Se requiere imagen del socio",
    "ADD_PARTNER.VALIDATION.NAME": "Se requiere nombre",
    "ADD_PROJECT.COMPANY.LABEL": "Empresa",
    "ADD_PROJECT.COMPANY.PLACEHOLDER": "Seleccione una empresa",
    "ADD_PROJECT.COST_PER_KM.LABEL": "Costo por KM($)",
    "ADD_PROJECT.CURRENCY.LABEL": "Moneda",
    "ADD_PROJECT.CURRENCY.PLACEHOLDER": "Seleccione una moneda",
    "ADD_PROJECT.DMAS.LABEL": "DMAs",
    "ADD_PROJECT.DMAS.NO_MATCHING": "No hay DMAs coincidentes",
    "ADD_PROJECT.DMAS.PLACEHOLDER": "Seleccionar DMAs",
    "ADD_PROJECT.END_DATE.LABEL": "Fecha de finalización",
    "ADD_PROJECT.MEASUREMENT_TYPE.LABEL": "Tipo de Medición",
    "ADD_PROJECT.MEASUREMENT_TYPE.PLACEHOLDER": "Seleccione un tipo de medida",
    "ADD_PROJECT.NAME.LABEL": "Agregar Nuevo Proyecto",
    "ADD_PROJECT.RESPONSE.SUCCESS": "El proyecto ha sido creado con éxito",
    "ADD_PROJECT.START_DATE.LABEL": "Fecha de inicio",
    "ADD_PROJECT.SUBMIT": "Crear Nuevo Proyecto",
    "ADD_PROJECT.TITLE": "Agregar Nuevo Proyecto",
    "ADD_PROJECT.VALIDATION.COMPANY": "Se requiere empresa",
    "ADD_PROJECT.VALIDATION.COST_PER_KM": "Se requiere el costo por KM",
    "ADD_PROJECT.VALIDATION.CURRENCY": "Se requiere moneda",
    "ADD_PROJECT.VALIDATION.END_DATE": "Se requiere fecha de finalización",
    "ADD_PROJECT.VALIDATION.MEASUREMENT_TYPE": "Se requiere el tipo de medida",
    "ADD_PROJECT.VALIDATION.NAME": "Se requiere nombre",
    "ADD_PROJECT.VALIDATION.START_DATE": "Se requiere fecha de inicio",
    "ADD_USER.MODAL.BTN.CLOSE": "Cerrar modal",
    "ADD_USER.RESPONSE.SUCCESS": "El usuario ha sido creado exitosamente",
    "ADD_USER.SUBMIT": "Agregar Nuevo Usuario",
    "ADD_USER.TITLE": "Agregar Nuevo Usuario",
    "ASSET_TOOLTIP.DESC_TITLE.ASSET_ID": "ID de activo",
    "ASSET_TOOLTIP.DESC_TITLE.ASSET_TYPE": "Tipo de Activo Estandarizado",
    "ASSET_TOOLTIP.ERROR": "No se pudo recuperar la información del activo",
    "ASSET_TOOLTIP.NO_DATA": "No hay información de sesión disponible",
    "ASSET_TOOLTIP.TABLE.HEADER.1": "ID de sesión",
    "ASSET_TOOLTIP.TABLE.HEADER.2": "ID de error",
    "ASSET_TOOLTIP.TABLE.HEADER.3": "Marca de tiempo",
    "ASSET_TOOLTIP.TABLE.HEADER.4": "Resultado",
    "ASSET_TOOLTIP.TITLE.ASSET": "Información del Activo",
    "ASSET_TOOLTIP.TITLE.SESSION": "Información de la sesión",
    "BREADCRUMB.FILTERS.COMPANY": "Empresa",
    "BREADCRUMB.FILTERS.DATE_FROM": "Fecha de",
    "BREADCRUMB.FILTERS.DATE_TO": "Fecha hasta",
    "BREADCRUMB.FILTERS.DATEFROM": "Fecha de",
    "BREADCRUMB.FILTERS.DATETO": "Fecha hasta",
    "BREADCRUMB.FILTERS.DAY": "Día",
    "BREADCRUMB.FILTERS.ENGINEER": "Ingeniero",
    "BREADCRUMB.FILTERS.PARTNER": "Socio",
    "BREADCRUMB.FILTERS.PROJECT": "Proyecto",
    "BROWSE_HOME_PAGE.TITLE": "Seleccione un tipo de datos para comenzar a navegar.",
    "BROWSE_VIEW.BACK_TO_LIST": "Volver a la lista",
    "BROWSE_VIEW.MEDIA_SECTION.EMPTY_MSG": "No hay medios para este punto de referencia",
    "BROWSE_VIEW.MEDIA_SECTION.LABEL": "Medios de comunicación",
    "BROWSE_VIEW.RELAY.ADDRESS": "DIRECCIÓN",
    "BROWSE_VIEW.RELAY.DEPLOYED_BY": "Desplegado por",
    "BROWSE_VIEW.RELAY.LAST_CONTACT": "Último contacto",
    "BROWSE_VIEW.RELAY.LAST_UPLOADED": "Última subida",
    "BROWSE_VIEW.RELAY.NO_NAME_PLACEHOLDER": "Relé",
    "BROWSE_VIEW.RELAY.SESSION": "Sesión",
    "BROWSE_VIEW.RELAY.UPDATED": "Actualizado",
    "BROWSE_VIEW.RELAY.W3W": "¿Qué 3 palabras?",
    "BROWSE_VIEW.SENSOR.BATTERY_VOLTAGE": "Voltaje de la batería",
    "BROWSE_VIEW.SENSOR.COLLECTED_BY": "Recopilado por",
    "BROWSE_VIEW.SENSOR.DEPLOYED_BY": "Desplegado por",
    "BROWSE_VIEW.SENSOR.END_TIME": "Fin de los tiempos",
    "BROWSE_VIEW.SENSOR.FIRMWARE_VERSION": "Versión",
    "BROWSE_VIEW.SENSOR.LAST_UPLOADED": "Última subida",
    "BROWSE_VIEW.SENSOR.LATEST_SESSION": "Última sesión",
    "BROWSE_VIEW.SENSOR.SESSION": "Sesión",
    "BROWSE_VIEW.SENSOR.SESSION_TYPE": "Tipo de sesión",
    "BROWSE_VIEW.SENSOR.START_TIME": "Hora de inicio",
    "BROWSE_VIEW.SESSION.LAST_UPLOADED": "Última subida",
    "BROWSE_VIEW.WAYPOINT.ADD_JOB": "Agregar trabajo",
    "BROWSE_VIEW.WAYPOINT.ADDRESS": "DIRECCIÓN",
    "BROWSE_VIEW.WAYPOINT.CREATED": "Creado",
    "BROWSE_VIEW.WAYPOINT.DIAMETER": "Diámetro",
    "BROWSE_VIEW.WAYPOINT.ENG_NOTES": "Notas de ingeniería",
    "BROWSE_VIEW.WAYPOINT.ENGINEER": "Ingeniero asignado",
    "BROWSE_VIEW.WAYPOINT.ENV_NOTES": "Notas ambientales",
    "BROWSE_VIEW.WAYPOINT.MATERIAL": "Material de la tubería",
    "BROWSE_VIEW.WAYPOINT.MERGE_WP": "Fusionar punto de referencia",
    "BROWSE_VIEW.WAYPOINT.NO_NAME_PLACEHOLDER": "Punto de referencia sin nombre",
    "BROWSE_VIEW.WAYPOINT.SECTION.ACTIVITIES": "Actividades",
    "BROWSE_VIEW.WAYPOINT.SECTION.CONSUMPTION_PROFILES": "Perfiles de consumo",
    "BROWSE_VIEW.WAYPOINT.SECTION.CONSUMPTION_PROFILES_EMTPY": "No hay perfiles de consumo para este punto de referencia",
    "BROWSE_VIEW.WAYPOINT.SECTION.CORRELATIONS": "Correlaciones",
    "BROWSE_VIEW.WAYPOINT.SECTION.CORRELATIONS_EMPTY": "No hay correlaciones para este punto de referencia",
    "BROWSE_VIEW.WAYPOINT.SECTION.HISTORY": "Historia",
    "BROWSE_VIEW.WAYPOINT.SECTION.HISTORY_EMPTY": "No hay historial para este punto de referencia",
    "BROWSE_VIEW.WAYPOINT.SECTION.JOBS": "Empleos",
    "BROWSE_VIEW.WAYPOINT.SECTION.JOBS_EMPTY": "No hay trabajos para este punto de referencia",
    "BROWSE_VIEW.WAYPOINT.SECTION.NOTES": "Notas",
    "BROWSE_VIEW.WAYPOINT.SECTION.NOTES_EMPTY": "No hay notas para este punto de referencia",
    "BROWSE_VIEW.WAYPOINT.SECTION.SESSIONS": "Sesiones",
    "BROWSE_VIEW.WAYPOINT.SECTION.SESSIONS_EMPTY": "No hay sesiones para este punto de referencia",
    "BROWSE_VIEW.WAYPOINT.SECTION.SOUNDINGS": "Sondeos",
    "BROWSE_VIEW.WAYPOINT.SECTION.SOUNDINGS_EMPTY": "No hay sondeos para este punto de referencia",
    "BROWSE_VIEW.WAYPOINT.SECTION.TOP_SOUNDINGS": "Sondeos principales",
    "BROWSE_VIEW.WAYPOINT.SECTION.TOP_SOUNDINGS_EMPTY": "No hay sondeos superiores para este punto de referencia",
    "BROWSE_VIEW.WAYPOINT.UPDATED": "Actualizado",
    "BROWSE_VIEW.WAYPOINT.W3W": "¿Qué 3 palabras?",
    "BROWSE.FILTERS.COLLECTED_BY": "Recopilado por",
    "BROWSE.FILTERS.COLLECTED_BY_PLACEHOLDER": "Seleccionar recopilados por el usuario",
    "BROWSE.FILTERS.COMPANY": "Compañía",
    "BROWSE.FILTERS.COMPANY_NAME": "nombre de empresa",
    "BROWSE.FILTERS.COMPANY_PLACEHOLDER": "Seleccionar empresas",
    "BROWSE.FILTERS.DEPLOYED_BY": "Desplegado por",
    "BROWSE.FILTERS.DEPLOYED_BY_PLACEHOLDER": "Seleccionar implementado por el usuario",
    "BROWSE.FILTERS.DMA": "DMA",
    "BROWSE.FILTERS.DMA_KEY": "Clave DMA",
    "BROWSE.FILTERS.DMA_PLACEHOLDER": "Seleccionar DMA",
    "BROWSE.FILTERS.FILTER": "Filtrar",
    "BROWSE.FILTERS.FROM": "De",
    "BROWSE.FILTERS.ID": "IDENTIFICACIÓN",
    "BROWSE.FILTERS.JOB_TYPE": "Tipo de trabajo",
    "BROWSE.FILTERS.JOB_TYPE_PLACEHOLDER": "Seleccionar códigos de tipo de trabajo",
    "BROWSE.FILTERS.LAST_SCHEDULED_ENGINEER": "Último ingeniero programado",
    "BROWSE.FILTERS.LAST_SCHEDULED_ENGINEER_PLACEHOLDER": "Seleccionar los últimos ingenieros programados",
    "BROWSE.FILTERS.LEAK_RESULTS": "Resultados de fugas",
    "BROWSE.FILTERS.LEAK_RESULTS_PLACEHOLDER": "Seleccionar resultados de fugas",
    "BROWSE.FILTERS.MOST_RECENT_AUTHOR_OF_MODIFICATION": "Autor más reciente de la modificación",
    "BROWSE.FILTERS.MOST_RECENT_AUTHOR_OF_MODIFICATION_PLACEHOLDER": "Seleccionar usuarios de la última acción",
    "BROWSE.FILTERS.NAME": "Nombre",
    "BROWSE.FILTERS.OTHERS": "Otros",
    "BROWSE.FILTERS.PARTNER": "Pareja",
    "BROWSE.FILTERS.PARTNER_NAME": "Nombre del socio",
    "BROWSE.FILTERS.PARTNER_PLACEHOLDER": "Seleccionar socios",
    "BROWSE.FILTERS.PREDICTED_LEAK_TYPE": "Tipo de fuga prevista",
    "BROWSE.FILTERS.PREDICTED_LEAK_TYPE_PLACEHOLDER": "Seleccionar los tipos de fugas previstos",
    "BROWSE.FILTERS.PREDICTED_SIZE": "Tamaño previsto",
    "BROWSE.FILTERS.PREDICTED_SIZE_PLACEHOLDER": "Seleccionar tamaños previstos",
    "BROWSE.FILTERS.PREDICTED_SIZE.CORRELATION": "Correlación",
    "BROWSE.FILTERS.PREDICTED_SIZE.ERROR": "Error",
    "BROWSE.FILTERS.PREDICTED_SIZE.LARGE": "Grande",
    "BROWSE.FILTERS.PREDICTED_SIZE.MEDIUM": "Medio",
    "BROWSE.FILTERS.PREDICTED_SIZE.NA": "N / A",
    "BROWSE.FILTERS.PREDICTED_SIZE.NOT_ENOUGH_FILES": "No hay suficientes archivos",
    "BROWSE.FILTERS.PREDICTED_SIZE.SMALL": "Pequeño",
    "BROWSE.FILTERS.PROJECT": "Proyecto",
    "BROWSE.FILTERS.PROJECT_PLACEHOLDER": "Seleccionar proyectos",
    "BROWSE.FILTERS.RELAY_CONNECTED": "Relé conectado",
    "BROWSE.FILTERS.RELAYS": "Relés",
    "BROWSE.FILTERS.SELECT_FIELD": "Seleccionar campo",
    "BROWSE.FILTERS.SENSORS": "Sensores",
    "BROWSE.FILTERS.SESSION_STATUS.AWAITING_UPLOAD": "Esperando carga",
    "BROWSE.FILTERS.SESSION_STATUS.COMPLETED": "Terminado",
    "BROWSE.FILTERS.SESSION_STATUS.DELETED": "Eliminado",
    "BROWSE.FILTERS.SESSION_STATUS.IN_PROGRESS": "En curso",
    "BROWSE.FILTERS.SESSION_TYPE.CONTINUOUS": "Continuo",
    "BROWSE.FILTERS.SESSION_TYPE.CORRELATION": "Correlación",
    "BROWSE.FILTERS.SESSION_TYPE.CORRELATION_1_MIN_DELAY": "Correlación: retraso de 1 minuto",
    "BROWSE.FILTERS.SESSION_TYPE.CORRELATION_12_MIN_DELAY": "Correlación: retraso de 12 minutos",
    "BROWSE.FILTERS.SESSION_TYPE.CORRELATION_15_MIN_DELAY": "Correlación: retraso de 15 minutos",
    "BROWSE.FILTERS.SESSION_TYPE.CORRELATION_5_MIN_DELAY": "Correlación: retraso de 5 minutos",
    "BROWSE.FILTERS.SESSION_TYPE.CORRELATION_8_MIN_DELAY": "Correlación: retraso de 8 minutos",
    "BROWSE.FILTERS.SESSION_TYPE.CORRELATION_CHILD": "Correlación infantil",
    "BROWSE.FILTERS.SESSION_TYPE.CORRELATION_PARENT": "Correlación Padre",
    "BROWSE.FILTERS.SESSION_TYPE.FCC_3_MIN_DAY": "FCC: Día de 3 minutos",
    "BROWSE.FILTERS.SESSION_TYPE.FCC_3_MIN_NIGHT": "FCC: Noche de 3 minutos",
    "BROWSE.FILTERS.SESSION_TYPE.FCC_5_MIN_DAY": "FCC: Jornada de 5 minutos",
    "BROWSE.FILTERS.SESSION_TYPE.FCC_5_MIN_NIGHT": "FCC: Noche de 5 minutos",
    "BROWSE.FILTERS.SESSION_TYPE.FCC_8_MIN_DAY": "FCC: jornada de 8 minutos",
    "BROWSE.FILTERS.SESSION_TYPE.FCC_8_MIN_NIGHT": "FCC: Noche de 8 minutos",
    "BROWSE.FILTERS.SESSION_TYPE.FIVE_MINUTES": "5 minutos",
    "BROWSE.FILTERS.SESSION_TYPE.ONE_HOUR": "1 hora",
    "BROWSE.FILTERS.SESSION_TYPE.OVERNIGHT": "Durante la noche",
    "BROWSE.FILTERS.SESSION_TYPE.RELAY": "Relé",
    "BROWSE.FILTERS.SESSION_TYPE.SYSTEM_MODE": "Modo de sistema",
    "BROWSE.FILTERS.SESSION_TYPE.TEST": "Prueba",
    "BROWSE.FILTERS.SESSION_TYPE.THIRTY_MINUTES": "30 minutos",
    "BROWSE.FILTERS.SESSION_TYPE.TWENTY_FOUR_HOURS": "24 horas",
    "BROWSE.FILTERS.SESSION_TYPE.TYPE": "Tipo",
    "BROWSE.FILTERS.SESSION_TYPES": "Tipos de sesión",
    "BROWSE.FILTERS.SESSION_TYPES_PLACEHOLDER": "Seleccionar tipos de sesión",
    "BROWSE.FILTERS.SESSIONS": "Sesiones",
    "BROWSE.FILTERS.SORTING": "Clasificación",
    "BROWSE.FILTERS.STATUS": "Estado",
    "BROWSE.FILTERS.STATUS_PLACEHOLDER": "Seleccionar estados",
    "BROWSE.FILTERS.STATUS.MAINTENANCE_ALERT": "Alerta de mantenimiento",
    "BROWSE.FILTERS.STATUS.OFFLINE": "Desconectado",
    "BROWSE.FILTERS.STATUS.OK": "DE ACUERDO",
    "BROWSE.FILTERS.STATUS.ONLINE": "En línea",
    "BROWSE.FILTERS.STATUS.WARNING": "Advertencia",
    "BROWSE.FILTERS.TO": "A",
    "BROWSE.FILTERS.TYPES": "Tipos",
    "BROWSE.FILTERS.TYPES_PLACEHOLDER": "Seleccionar tipos de sesión",
    "BROWSE.FILTERS.WAYPOINTS": "Puntos de referencia",
    "BROWSE.LABELS.TYPE": "Tipo",
    "BROWSE.LAYOUT.LOADING_MAP": "Cargando mapa",
    "BROWSE.LAYOUT.LOADING_MAP_DESCRIPTION": "Por favor espere mientras inicializamos el mapa interactivo...",
    "BROWSE.LAYOUT.LOADING_PREVIEW": "Vista previa de carga",
    "BROWSE.LAYOUT.LOADING_PREVIEW_DESCRIPTION": "Por favor espere mientras cargamos su vista previa compartida...",
    "BROWSE.LIST.BACK_TO_LIST": "Volver a la lista",
    "BROWSE.LIST.JOBS_VIEW_ACTIVE": "Vista de trabajos activos",
    "BROWSE.LIST.JOBS_VIEW_DESCRIPTION": "Los datos del trabajo se muestran en el mapa.",
    "BROWSE.PANEL.COLLAPSE": "Contraer panel",
    "BROWSE.PANEL.EXPAND": "Expandir panel",
    "BROWSE.PREDEFINED_VIEWS.LEAKS_FOUND_LAST_7_DAYS": "Fugas encontradas en los últimos 7 días",
    "BROWSE.PREDEFINED_VIEWS.LEAKS_MARKED_UP_LAST_7_DAYS": "Fugas marcadas en los últimos 7 días",
    "BROWSE.PREDEFINED_VIEWS.RELAY_NEEDS_MAINTENANCE": "Relé que necesita mantenimiento",
    "BROWSE.PREDEFINED_VIEWS.RELAY_WARNINGS_LAST_7_DAYS": "Advertencias de retransmisión en los últimos 7 días",
    "BROWSE.PREVIEW.CHANGE_WAYPOINT": "cambiar punto de referencia",
    "BROWSE.SHARE.ADD_EMAIL": "Agregar correo electrónico",
    "BROWSE.SHARE.ADD_MESSAGE": "Añadir un mensaje",
    "BROWSE.SHARE.COPY_LINK": "Copiar enlace",
    "BROWSE.SHARE.ERROR.COPY_CLIPBOARD_FAILED": "No se pudo copiar el enlace al portapapeles",
    "BROWSE.SHARE.ERROR.GENERATE_LINK_FAILED": "No se pudo generar el enlace para compartir",
    "BROWSE.SHARE.REMOVE_EMAIL": "Eliminar %1$s",
    "BROWSE.SHARE.SEND": "Enviar",
    "BROWSE.SHARE.SUCCESS.EMAIL_SENT_AND_LINK_COPIED": "¡Correo electrónico enviado y enlace copiado al portapapeles!",
    "BROWSE.SHARE.SUCCESS.LINK_COPIED": "¡Enlace copiado al portapapeles!",
    "BROWSE.TABLE.COLUMNS.ADDRESS": "DIRECCIÓN",
    "BROWSE.TABLE.COLUMNS.ASSET": "Activo",
    "BROWSE.TABLE.COLUMNS.BATTERY_VOLTAGE": "Voltaje de la batería",
    "BROWSE.TABLE.COLUMNS.COLLECTED_BY": "Recopilado por",
    "BROWSE.TABLE.COLUMNS.COMMENT": "Comentario",
    "BROWSE.TABLE.COLUMNS.COMPANY": "Compañía",
    "BROWSE.TABLE.COLUMNS.COMPANY_NAME": "nombre de empresa",
    "BROWSE.TABLE.COLUMNS.CREATED_AT": "Creado en",
    "BROWSE.TABLE.COLUMNS.CREATED_DATE": "Fecha de creación",
    "BROWSE.TABLE.COLUMNS.DEPLOYED_BY": "Desplegado por",
    "BROWSE.TABLE.COLUMNS.DMA": "DMA",
    "BROWSE.TABLE.COLUMNS.END_DATE": "Fecha de finalización",
    "BROWSE.TABLE.COLUMNS.END_TIME": "Fin de los tiempos",
    "BROWSE.TABLE.COLUMNS.ENVIRONMENTAL_NOTES": "Notas ambientales",
    "BROWSE.TABLE.COLUMNS.EST_SIZE_ENG": "Tamaño estimado (Ing.)",
    "BROWSE.TABLE.COLUMNS.EXPECTED_FINISH": "Final esperado",
    "BROWSE.TABLE.COLUMNS.FIRMWARE": "Firmware",
    "BROWSE.TABLE.COLUMNS.FLOW_REDUCTION": "Reducción de flujo",
    "BROWSE.TABLE.COLUMNS.ID": "IDENTIFICACIÓN",
    "BROWSE.TABLE.COLUMNS.JOB_COUNT": "Recuento de trabajos",
    "BROWSE.TABLE.COLUMNS.JOB_TYPE_CODE": "Código de tipo de trabajo",
    "BROWSE.TABLE.COLUMNS.JOBS": "Empleos",
    "BROWSE.TABLE.COLUMNS.LAST_ACTION_BY": "Última acción de",
    "BROWSE.TABLE.COLUMNS.LAST_CONTACT": "Último contacto",
    "BROWSE.TABLE.COLUMNS.LAST_SCHEDULED_ENGINEER": "Último ingeniero programado",
    "BROWSE.TABLE.COLUMNS.LAST_UPDATE": "Última actualización",
    "BROWSE.TABLE.COLUMNS.LAST_UPDATED": "Última actualización",
    "BROWSE.TABLE.COLUMNS.LATITUDE": "Latitud",
    "BROWSE.TABLE.COLUMNS.LEAK_RESULT": "Resultado de la fuga",
    "BROWSE.TABLE.COLUMNS.LEAK_SIZE": "Tamaño de la fuga",
    "BROWSE.TABLE.COLUMNS.LONGITUDE": "Longitud",
    "BROWSE.TABLE.COLUMNS.MAC_ADDRESS": "Dirección MAC",
    "BROWSE.TABLE.COLUMNS.NAME": "Nombre",
    "BROWSE.TABLE.COLUMNS.PARTNER": "Pareja",
    "BROWSE.TABLE.COLUMNS.PARTNER_NAME": "Nombre del socio",
    "BROWSE.TABLE.COLUMNS.PIPE_DIAMETER": "Diámetro de la tubería",
    "BROWSE.TABLE.COLUMNS.PIPE_DIAMETER_UNITS": "Unidades de diámetro de tubería",
    "BROWSE.TABLE.COLUMNS.PIPE_MATERIAL": "Material de la tubería",
    "BROWSE.TABLE.COLUMNS.PREDICTED_LEAK_TYPE": "Tipo de fuga prevista",
    "BROWSE.TABLE.COLUMNS.PREDICTED_SIZE": "Tamaño previsto",
    "BROWSE.TABLE.COLUMNS.PROJECT": "Proyecto",
    "BROWSE.TABLE.COLUMNS.RELAY_CONNECTED": "Relé conectado",
    "BROWSE.TABLE.COLUMNS.RELAY_ID": "ID de retransmisión",
    "BROWSE.TABLE.COLUMNS.RELAY_NAME": "Nombre del relé",
    "BROWSE.TABLE.COLUMNS.SENSOR_ID": "Identificación del sensor",
    "BROWSE.TABLE.COLUMNS.SENSOR_MAC": "Sensor MAC",
    "BROWSE.TABLE.COLUMNS.SENSOR_NAME": "Nombre del sensor",
    "BROWSE.TABLE.COLUMNS.SESSION": "Sesión",
    "BROWSE.TABLE.COLUMNS.SESSION_COUNT": "Recuento de sesiones",
    "BROWSE.TABLE.COLUMNS.SESSION_ID": "ID de sesión",
    "BROWSE.TABLE.COLUMNS.SESSION_TYPE": "Tipo de sesión",
    "BROWSE.TABLE.COLUMNS.SESSIONS": "Sesiones",
    "BROWSE.TABLE.COLUMNS.SIZE": "Tamaño",
    "BROWSE.TABLE.COLUMNS.START_DATE": "Fecha de inicio",
    "BROWSE.TABLE.COLUMNS.START_TIME": "Hora de inicio",
    "BROWSE.TABLE.COLUMNS.STATUS": "Estado",
    "BROWSE.TABLE.COLUMNS.SURFACE_TYPE": "Tipo de superficie",
    "BROWSE.TABLE.COLUMNS.UPDATE_DATE": "Fecha de actualización",
    "BROWSE.TABLE.COLUMNS.WAYPOINT_NAME": "Nombre del punto de referencia",
    "BROWSE.TABLE.COLUMNS.WHAT3WORDS": "Qué3Palabras",
    "BROWSE.TABLE.ID_PREFIX": "IDENTIFICACIÓN:",
    "BROWSE.TABLE.SORT_BY": "Ordenar por %1$s",
    "BROWSE.TABS.RELAYS": "Relés",
    "BROWSE.TABS.SENSORS": "Sensores",
    "BROWSE.TABS.SESSIONS": "Sesiones",
    "BROWSE.TABS.WAYPOINTS": "Puntos de referencia",
    "BROWSE.VIEWS.CREATED_SUCCESS": "Vista personalizada creada exitosamente",
    "BROWSE.VIEWS.DELETE_CONFIRM": "¿Eliminar vista guardada?",
    "BROWSE.VIEWS.DELETE_DESCRIPTION": "Esto eliminará permanentemente \"%1$s\".",
    "BROWSE.VIEWS.EMPTY": "Aún no hay vistas guardadas",
    "BROWSE.VIEWS.LOAD_ERROR": "No se pudieron cargar las vistas",
    "BROWSE.VIEWS.LOADING": "Cargando vistas...",
    "BROWSE.VIEWS.POPOVER_DESCRIPTION": "Puede guardar sus filtros favoritos y acceder a ellos con un clic desde aquí",
    "BROWSE.VIEWS.SAVE_BUTTON": "Guardar vista",
    "BROWSE.VIEWS.SAVE_DESCRIPTION": "Dale un nombre a tu vista personalizada para guardar tus filtros actuales.",
    "BROWSE.VIEWS.SAVE_TITLE": "Guardar vista personalizada",
    "BROWSE.VIEWS.VIEW_NAME_LABEL": "Ver nombre",
    "BROWSE.VIEWS.VIEW_NAME_PLACEHOLDER": "Introduzca el nombre de la vista",
    "BROWSE.VIEWS.YOUR_SAVED_VIEWS": "Tus vistas guardadas",
    "BROWSE.VIEWS.YOUR_VIEWS_SHORT": "Tus opiniones",
    "CHANGE_LOG.ACTIONS.CREATE_BRANCH": "Crear Proyecto",
    "CHANGE_LOG.ACTIONS.CREATE_COMPANY": "crear empresa",
    "CHANGE_LOG.ACTIONS.CREATE_USER": "Crear invitación de usuario",
    "CHANGE_LOG.ACTIONS.DELETE_BRANCH": "Eliminar Proyecto",
    "CHANGE_LOG.ACTIONS.DELETE_COMPANY": "Eliminar empresa",
    "CHANGE_LOG.ACTIONS.DELETE_USER": "Borrar usuario",
    "CHANGE_LOG.ACTIONS.EDIT_COMPANY": "Editar empresa",
    "CHANGE_LOG.ACTIONS.FORGOT_PASSWORD": "Enviar correo electrónico con enlace de recuperación",
    "CHANGE_LOG.ACTIONS.GET_COMPANY": "Obtener compañía",
    "CHANGE_LOG.ACTIONS.LOGIN": "Acceso",
    "CHANGE_LOG.ACTIONS.SET_PASSWORD": "Establecer contraseña de perfil",
    "CHANGE_LOG.ACTIONS.TOKEN_DECODE": "Decodificar token de correo electrónico",
    "CHANGE_LOG.ACTIONS.UPDATE_BRANCH": "El proyecto fue actualizado",
    "CHANGE_LOG.ACTIONS.UPDATE_USER": "Se actualizó el perfil de usuario",
    "CHANGE_LOG.FILTERS.ACTION.LABEL": "Acción",
    "CHANGE_LOG.FILTERS.ACTION.PLACEHOLDER": "Seleccione una acción",
    "CHANGE_LOG.FILTERS.BRANCH.LABEL": "Proyecto",
    "CHANGE_LOG.FILTERS.BRANCH.PLACEHOLDER": "Seleccione un Proyecto",
    "CHANGE_LOG.FILTERS.CLEAR": "Desechar",
    "CHANGE_LOG.FILTERS.COMPANY.LABEL": "Compañía",
    "CHANGE_LOG.FILTERS.COMPANY.PLACEHOLDER": "Seleccione una empresa",
    "CHANGE_LOG.FILTERS.DATE.LABEL": "Fecha",
    "CHANGE_LOG.FILTERS.DATE.PLACEHOLDER": "Seleccione una fecha",
    "CHANGE_LOG.FILTERS.EMAIL.LABEL": "Correo electrónico",
    "CHANGE_LOG.FILTERS.EMAIL.PLACEHOLDER": "Introduce un correo electrónico",
    "CHANGE_LOG.FILTERS.ERASE": "Claro",
    "CHANGE_LOG.FILTERS.STATUS.LABEL": "Estado",
    "CHANGE_LOG.FILTERS.STATUS.PLACEHOLDER": "Seleccione un estado",
    "CHANGE_LOG.FILTERS.SUBMIT": "Filtrar",
    "CHANGE_LOG.FILTERS.TITLE": "filtros",
    "CHANGE_LOG.STATUSES.FAILURE": "Falla",
    "CHANGE_LOG.STATUSES.SUCCESS": "Éxito",
    "CHANGE_LOG.TABLE.ACTION": "Acción",
    "CHANGE_LOG.TABLE.BRANCH": "Proyecto",
    "CHANGE_LOG.TABLE.COMPANY": "Compañía",
    "CHANGE_LOG.TABLE.DATE": "Fecha",
    "CHANGE_LOG.TABLE.EMAIL": "Correo electrónico",
    "CHANGE_LOG.TABLE.NAME": "Nombre",
    "CHANGE_LOG.TABLE.NUMBER": "№",
    "CHANGE_LOG.TABLE.ROLE": "Role",
    "CHANGE_LOG.TABLE.STATUS": "Estado",
    "CHANGE_LOG.TABLE.TIME": "Tiempo",
    "CHANGE_LOG.TITLE.NO_LOGS": "no hay registros",
    "CHANGE_LOG.TITLE.TOTAL_COUNT": "Registros totales:",
    "CHATBOT.DEFAULT_ASSISTANT_MSG": "¿Cómo puedo ayudarte?",
    "CHATBOT.INPUT.PLACEHOLDER": "Escribe un mensaje",
    "CHATBOT.OFFLINE_MSG": "askFIDO no está disponible actualmente. Por favor, inténtelo de nuevo más tarde.",
    "CHATBOT.RATING.RESPONSE": "Gracias por los comentarios",
    "CHATBOT.SUBHEADING": "En línea",
    "CHATBOT.SUBHEADING_ERROR": "Desconectado",
    "CHATBOT.YOU": "Tú",
    "COMMON.ACTION.CANCEL": "Cancelar",
    "COMMON.ACTION.CLEAR": "Claro",
    "COMMON.ACTION.CLEAR_SEARCH": "Borrar búsqueda",
    "COMMON.ACTION.CLOSE": "Cerca",
    "COMMON.ACTION.COPY_COORDINATES": "Copiar coordenadas",
    "COMMON.ACTION.COPY_COORDINATES_TO_CLIPBOARD": "Copiar coordenadas al portapapeles",
    "COMMON.ACTION.DELETE": "Borrar",
    "COMMON.ACTION.LOAD_MORE": "Cargar más",
    "COMMON.ACTION.RESET": "Reiniciar",
    "COMMON.ACTION.SAVING": "Ahorro...",
    "COMMON.ACTION.SEARCH": "Buscar",
    "COMMON.ACTION.SHARE": "Compartir",
    "COMMON.BOOLEAN.NO": "No",
    "COMMON.BOOLEAN.YES": "Sí",
    "COMMON.BUTTON.EDIT": "editar",
    "COMMON.BUTTON.OPEN": "abierto",
    "COMMON.BUTTON.SHARE": "compartir",
    "COMMON.DATE.PLACEHOLDER.DDMMYYYY": "dd/mm/aaaa",
    "COMMON.EMPTY.ADJUST_FILTERS_OR_SEARCH": "Intente ajustar sus filtros o criterios de búsqueda",
    "COMMON.EMPTY.ADJUST_SEARCH_TERMS": "Intente ajustar sus términos de búsqueda o verifique si hay errores tipográficos.",
    "COMMON.EMPTY.NO_DATA": "No hay datos.",
    "COMMON.EMPTY.NO_RESULTS_FOUND": "No se encontraron resultados",
    "COMMON.ERROR.FAILED_TO_LOAD_DATA": "No se pudieron cargar los datos",
    "COMMON.ERROR.GENERIC_TRY_AGAIN_LATER": "Se produjo un error al obtener los datos. Inténtelo de nuevo más tarde.",
    "COMMON.ERROR.SUGGESTIONS_FETCH": "Se produjo un error al obtener las sugerencias. Inténtalo de nuevo más tarde.",
    "COMMON.FILTERS.APPLY_FILTERS": "Aplicar filtros",
    "COMMON.FILTERS.EMAILS_PLACEHOLDER": "Filtrar correos electrónicos...",
    "COMMON.FILTERS.SAVE_FILTERS": "Guardar filtros",
    "COMMON.FILTERS.TOGGLE_FILTERS": "alternar filtros",
    "COMMON.FORM.PLACEHOLDER.ZERO": "0",
    "COMMON.LOADING.GENERIC": "Cargando...",
    "COMMON.LOADING.SUGGESTIONS": "Cargando sugerencias...",
    "COMMON.MEDIA.PAUSE_VIDEO": "Pausar el vídeo",
    "COMMON.MEDIA.PLAY_AUDIO": "Reproducir audio",
    "COMMON.MEDIA.PLAY_VIDEO": "Reproducir vídeo",
    "COMMON.MEDIA.UPLOAD_ALT": "Medios subidos",
    "COMMON.MEDIA.VIDEO_LOAD_ERROR": "Se produjo un error al cargar el video. Inténtalo de nuevo más tarde.",
    "COMMON.PAGINATION.NEXT_PAGE": "Ir a la página siguiente",
    "COMMON.PAGINATION.OF": "de",
    "COMMON.PAGINATION.PAGE_TITLE": "Página %1$s",
    "COMMON.PAGINATION.PREVIOUS_PAGE": "Ir a la página anterior",
    "COMMON.PAGINATION.ROWS_PER_PAGE": "Filas por página",
    "COMMON.SEARCH.RESULTS": "Resultados",
    "COMMON.SEARCH.SUGGESTIONS": "Sugerencias",
    "COMMON.SEARCH.WAITING_FOR_TYPING": "Esperando que termines de escribir...",
    "COMMON.SORT.ASC": "Ascendente",
    "COMMON.SORT.DESC": "Descendiendo",
    "COMMON.TABLE.COLUMNS_SETTINGS": "Configuración de columnas",
    "COMMON.TABLE.CUSTOMIZE_TABLE": "Personalizar tabla",
    "COMMON.TABLE.CUSTOMIZE_TABLE_DESCRIPTION": "Reordenar, fijar y alternar la visibilidad de las columnas",
    "COMMON.TABLE.DRAG_TO_PIN": "Arrastre las columnas aquí para fijarlas",
    "COMMON.TABLE.DRAG_TO_REORDER": "Arrastre para reordenar",
    "COMMON.TABLE.DRAG_TO_UNPIN": "Arrastre las columnas aquí para desanclarlas",
    "COMMON.TABLE.MANAGE_COLUMNS": "Administrar columnas",
    "COMMON.TABLE.MAX_PINNED_COLUMNS_REACHED": "Se alcanzó el máximo de columnas ancladas",
    "COMMON.TABLE.OTHER_COLUMNS": "Otras columnas",
    "COMMON.TABLE.PIN_COLUMN": "Columna de pines",
    "COMMON.TABLE.PINNED_COLUMNS": "Columnas fijadas",
    "COMMON.TABLE.PINNED_COLUMNS_COUNT": "Columnas fijadas (%1$s/%1$s)",
    "COMMON.TABLE.UNPIN_COLUMN": "Desanclar columna",
    "COMMON.UPLOAD.CHOOSE_FILE": "Elegir archivo",
    "COMMON.VALIDATION.INVALID_EMAIL": "Dirección de correo electrónico no válida",
    "COMMON.VIEW.CLASSIC_VIEW": "Vista clásica",
    "COMMON.VIEW.LIST_VIEW": "Vista de lista",
    "COMPANIES_PAGE.ACCOUNT_SWITCHER.COMPANIES": "Empresas",
    "COMPANIES_PAGE.ACCOUNT_SWITCHER.DEFAULT_TITLE": "Seleccione un socio o empresa",
    "COMPANIES_PAGE.ACCOUNT_SWITCHER.PARTNERS": "Socio",
    "COMPANIES_PAGE.ADD_COMPANY.BUTTON": "Nueva compañia",
    "COMPANIES_PAGE.ADD_COMPANY.FORM.ADDRESS.LABEL": "Dirección de la empresa",
    "COMPANIES_PAGE.ADD_COMPANY.FORM.ADDRESS.PLACEHOLDER": "Ingresa la direccion",
    "COMPANIES_PAGE.ADD_COMPANY.FORM.NAME.LABEL": "nombre de empresa",
    "COMPANIES_PAGE.ADD_COMPANY.FORM.NAME.PLACEHOLDER": "Ingrese su nombre",
    "COMPANIES_PAGE.ADD_COMPANY.FORM.SUBMIT": "Agregar",
    "COMPANIES_PAGE.ADD_COMPANY.TITLE": "Añadir nueva empresa",
    "COMPANIES_PAGE.CRUMB": "Compañías",
    "COMPANIES_PAGE.DELETE_COMPANY.TITLE": "¿Estás seguro de que quieres eliminar esta Empresa?",
    "COMPANIES_PAGE.SUBTITLE": "Alguna otra información importante va aquí",
    "COMPANIES_PAGE.TABLE.ACTIONS": "Comportamiento",
    "COMPANIES_PAGE.TABLE.ADDRESS": "DIRECCIÓN",
    "COMPANIES_PAGE.TABLE.BRANCHES": "Proyectos",
    "COMPANIES_PAGE.TABLE.ID": "IDENTIFICACIÓN",
    "COMPANIES_PAGE.TABLE.INDEX": "№",
    "COMPANIES_PAGE.TABLE.NAME": "Nombre",
    "COMPANIES_PAGE.TABLE.REPORTS": "Informes personalizados totales",
    "COMPANIES_PAGE.TABLE.USERS": "Usuarios totales",
    "COMPANIES_PAGE.TITLE.NO_COMPANIES": "no hay empresas",
    "COMPANIES_PAGE.TITLE.TOTAL_COUNT": "Empresas totales:",
    "COMPONENTS.ALLOCATE_LEAK_ENGINEER.ALLOCATE_LE": "Asignar LE",
    "COMPONENTS.ALLOCATE_LEAK_ENGINEER.API_ERROR": "Error, por favor intenta de nuevo",
    "COMPONENTS.ALLOCATE_LEAK_ENGINEER.API_SUCCESS": "Éxito, se han asignado los puntos de referencia",
    "COMPONENTS.ALLOCATE_LEAK_ENGINEER.ASSIGN_WAYPOINTS": "Asignar Puntos de Referencia Seleccionados al Ingeniero de Fugas",
    "COMPONENTS.ALLOCATE_LEAK_ENGINEER.CHANGE": "Cambio",
    "COMPONENTS.ALLOCATE_LEAK_ENGINEER.CLOSE": "Cerrar",
    "COMPONENTS.ALLOCATE_LEAK_ENGINEER.NO_WAYPOINTS": "No se seleccionaron puntos de referencia",
    "COMPONENTS.ALLOCATE_LEAK_ENGINEER.OPTION_ENGINEER": "Ingeniero:",
    "COMPONENTS.ALLOCATE_LEAK_ENGINEER.REMOVE": "eliminar",
    "COMPONENTS.ALLOCATE_LEAK_ENGINEER.SEARCH.PLACEHOLDER": "Buscar ingeniero",
    "COMPONENTS.ALLOCATE_LEAK_ENGINEER.SELECTING_ERROR": "Por favor, seleccione un ingeniero y puntos de referencia",
    "COMPONENTS.ALLOCATE_LEAK_ENGINEER.SUBMIT_BTN": "Asignar puntos de referencia",
    "COMPONENTS.COMPANY_SELECT.CHOOSE_COMPANY": "Elija una empresa/socio",
    "COMPONENTS.COMPANY_SELECT.COMPANY": "Proyecto",
    "COMPONENTS.COMPANY_SELECT.ERROR": "¡Vaya! Algo salió mal. Por favor, actualiza la página e inténtalo de nuevo.",
    "COMPONENTS.COMPANY_SELECT.FORM.SEARCH.PLACEHOLDER": "Búsqueda de empresa, socio o proyecto",
    "COMPONENTS.COMPANY_SELECT.FORM.SELECT.PLACEHOLDER": "Seleccionar el tipo de datos",
    "COMPONENTS.COMPANY_SELECT.NO_DATA": "No hay proyectos disponibles",
    "COMPONENTS.COMPANY_SELECT.NO_RESULTS": "No se encontraron resultados",
    "COMPONENTS.COMPANY_SELECT.PARTNER": "Empresa/Socio",
    "COMPONENTS.COMPANY_SELECT.VIEW": "Vista",
    "COMPONENTS.DATE_VIEWER.END_DATE": "Fecha de finalización",
    "COMPONENTS.DATE_VIEWER.START_DATE": "Fecha de inicio",
    "COMPONENTS.DELIVERY_PERFORMANCE_FITLERS.PLACEHOLDERS.COMPANIES": "Empresas",
    "COMPONENTS.DELIVERY_PERFORMANCE_FITLERS.PLACEHOLDERS.ENGINEERS": "Ingenieros",
    "COMPONENTS.DELIVERY_PERFORMANCE_FITLERS.PLACEHOLDERS.PARTNERS": "Socios",
    "COMPONENTS.DELIVERY_PERFORMANCE_FITLERS.PLACEHOLDERS.PROJECTS": "Proyectos",
    "COMPONENTS.ERROR_BOUNDARY.MESSAGE": "Se produjo un error inesperado",
    "COMPONENTS.ERROR_BOUNDARY.RELOAD": "Recargar página",
    "COMPONENTS.ERROR_BOUNDARY.SHOW_STACK": "Mostrar pila de errores (desarrollo)",
    "COMPONENTS.ERROR_BOUNDARY.TITLE": "¡Ups! Algo salió mal",
    "COMPONENTS.FILE_UPLOAD.BROWSE": "Explorar Archivo",
    "COMPONENTS.FILE_UPLOAD.DRAG_TEXT": "Arrastrar y Soltar",
    "COMPONENTS.FILE_UPLOAD.ERROR": "Se requiere archivo",
    "COMPONENTS.FILE_UPLOAD.FILES": "Archivos",
    "COMPONENTS.FILE_UPLOAD.OR": "O",
    "COMPONENTS.FILE_UPLOAD.SUPPORTED": "Soporta: ",
    "COMPONENTS.FILTER.CLOSE": "Cerrar",
    "COMPONENTS.FILTER.SELECT_A_DMA": "Seleccione un DMA",
    "COMPONENTS.FILTER.SELECT_A_PROJECT": "Seleccione un proyecto",
    "COMPONENTS.FILTER.SELECT_A_SIZE": "Seleccione un tamaño",
    "COMPONENTS.FILTER.SELECT_A_STATUS": "Seleccione un estado",
    "COMPONENTS.FILTER.SELECT_DMA": "Seleccione DMA",
    "COMPONENTS.FILTER.SELECT_PROJECT": "Seleccionar Proyecto",
    "COMPONENTS.FILTER.SELECT_SIZE": "Seleccionar Tamaño",
    "COMPONENTS.FILTER.SELECT_STATUS": "Seleccionar estado",
    "COMPONENTS.FUNNEL_CHART.ERROR_MSG": "Sin datos",
    "COMPONENTS.GRAPH_TOGGLE.SPECTRAL_PROFILE": "Perfil Espectral",
    "COMPONENTS.HISTORY_CONTAINER.ACTION": "Acción",
    "COMPONENTS.HISTORY_CONTAINER.DATETIME": "Fecha y Hora",
    "COMPONENTS.HISTORY_CONTAINER.ID": "ID",
    "COMPONENTS.HISTORY_CONTAINER.NOTES": "notas",
    "COMPONENTS.HISTORY_CONTAINER.REFERENCE_WAYPOINT": "punto de referencia",
    "COMPONENTS.HISTORY_CONTAINER.REFERENCE_WAYPOINT_ID": "id del punto de referencia",
    "COMPONENTS.HISTORY_CONTAINER.SCHEDULED_DATE": "fecha programada",
    "COMPONENTS.HISTORY_CONTAINER.STATUS_CHANGED_FROM_ID": "estado cambiado de id",
    "COMPONENTS.HISTORY_CONTAINER.STATUS_NAME": "cambiado al nombre de estado",
    "COMPONENTS.HISTORY_CONTAINER.TIME_ELAPSED": "Tiempo Transcurrido",
    "COMPONENTS.HISTORY_CONTAINER.TITLE": "Historial de registros de puntos de referencia",
    "COMPONENTS.HISTORY_CONTAINER.USER_ID": "id de usuario",
    "COMPONENTS.HISTORY_CONTAINER.USER_NAME": "Autor de la modificación",
    "COMPONENTS.HISTORY_CONTAINER.WAYPOINT_ID": "id de waypoint",
    "COMPONENTS.HISTORY_CONTAINER.WAYPOINT_NAME": "nombre del punto de referencia",
    "COMPONENTS.ICON_INSIGHT.ALT": "Icono de información",
    "COMPONENTS.IMAGE_UPLOAD_BOX.BUTTON_TEXT": "Explorar Foto",
    "COMPONENTS.IMAGE_UPLOAD_BOX.DRAG_TEXT": "Arrastrar & Soltar",
    "COMPONENTS.IMAGE_UPLOAD_BOX.IMAGE_TYPE": "Admite: *.png, *.jpg y *.jpeg",
    "COMPONENTS.IMAGE_UPLOAD_BOX.OR": "O",
    "COMPONENTS.INSERT_DATE.ADD.END_DATE": "Agregar Fecha de Finalización",
    "COMPONENTS.INSERT_DATE.ADD.START_DATE": "Agregar Fecha de Inicio",
    "COMPONENTS.INSERT_DATE.DATE.LABEL": "Fecha",
    "COMPONENTS.INSERT_DATE.DATE.PLACEHOLDER": "Seleccione una Fecha",
    "COMPONENTS.INSERT_DATE.EDIT.END_DATE": "Editar Fecha de Finalización",
    "COMPONENTS.INSERT_DATE.EDIT.START_DATE": "Editar Fecha de Inicio",
    "COMPONENTS.INSERT_DATE.FAILURE_DESC": "Por favor, intente de nuevo, la actualización no ha sido exitosa",
    "COMPONENTS.INSERT_DATE.FAILURE_TITLE": "¡Inténtalo de nuevo!",
    "COMPONENTS.INSERT_DATE.OK": "OK",
    "COMPONENTS.INSERT_DATE.SUBMIT": "Enviar",
    "COMPONENTS.INSERT_DATE.SUCCESS_DESC": "La fecha ha sido actualizada",
    "COMPONENTS.INSERT_DATE.SUCCESS_TITLE": "¡Genial!",
    "COMPONENTS.LEAK_SIZE_FUNNEL.LARGE": "Gran fuga",
    "COMPONENTS.LEAK_SIZE_FUNNEL.MEDIUM": "Fuga media",
    "COMPONENTS.LEAK_SIZE_FUNNEL.SMALL": "Pequeña fuga",
    "COMPONENTS.PAGINATION.PAGE_OF": "{{page}} de {{total}}",
    "COMPONENTS.PAGINATION.ROWS_PER_PAGE": "Filas por página",
    "COMPONENTS.POST_PROJECT_REPORT_BUTTON.FAILURE_DESC": "Por favor, intente de nuevo, el informe no ha tenido éxito",
    "COMPONENTS.POST_PROJECT_REPORT_BUTTON.FAILURE_TITLE": "¡Inténtalo de nuevo!",
    "COMPONENTS.POST_PROJECT_REPORT_BUTTON.OK": "De acuerdo",
    "COMPONENTS.POST_PROJECT_REPORT_BUTTON.POST_PROJECT_DESC": "Este informe se le enviará por correo electrónico una vez que lo envíe",
    "COMPONENTS.POST_PROJECT_REPORT_BUTTON.SELECT_FORMAT": "Seleccione el formato",
    "COMPONENTS.POST_PROJECT_REPORT_BUTTON.SUCCESS_DESC": "Su informe ha sido creado. Revise su correo electrónico para obtener detalles",
    "COMPONENTS.POST_PROJECT_REPORT_BUTTON.SUCCESS_TITLE": "¡Increíble!",
    "COMPONENTS.PROGRESS_BAR.END_DATE": "Fecha final",
    "COMPONENTS.PROGRESS_BAR.KEY.ITEM_A": "Pipeline Desplegado",
    "COMPONENTS.PROGRESS_BAR.KEY.ITEM_B": "Pipeline Recogido",
    "COMPONENTS.PROGRESS_BAR.KEY.ITEM_C": "Progreso del Objetivo",
    "COMPONENTS.PROGRESS_BAR.KEY.ITEM_D": "Subido a FIDO AI",
    "COMPONENTS.PROGRESS_BAR.KEY.ITEM_E": "Desplegado",
    "COMPONENTS.PROGRESS_BAR.KEY.ITEM_F": "Validado",
    "COMPONENTS.PROGRESS_BAR.KEY.ITEM_G": "Marcado para Reparación",
    "COMPONENTS.PROGRESS_BAR.KEY.ITEM_H": "Identificado por FIDO AI",
    "COMPONENTS.PROGRESS_BAR.LEAKAGE_REDUCTION": "Agua ahorrada de fugas previstas, fugas marcadas para reparación y fugas validadas, mostradas en relación con el objetivo de reducción.",
    "COMPONENTS.PROGRESS_BAR.LEAKAGE_TITLE": "Reducción de Fugas",
    "COMPONENTS.PROGRESS_BAR.PIPELINE_COVERAGE": "La Cobertura de la Tuberia indica la fracción del total de la tubería que ha sido cubierta, mostrada como un porcentaje.",
    "COMPONENTS.PROGRESS_BAR.PIPELINE_TITLE": "Cobertura del Pipeline",
    "COMPONENTS.PROGRESS_BAR.SESSIONS": "Sesiones",
    "COMPONENTS.PROGRESS_BAR.START_DATE": "Fecha de inicio",
    "COMPONENTS.PROGRESS_BAR.TARGET_LEAKAGE.ERROR_MSG": "Especifique su objetivo para la reducción de fugas para activar la visualización del progreso.",
    "COMPONENTS.PROGRESS_BAR.TARGET_PIPELINE.ERROR_MSG": "Especifique su distancia objetivo para la cobertura del oleoducto para activar la visualización del progreso.",
    "COMPONENTS.PROPORTIONAL_BAR.LEAK_RESULTS": "Resultados del tamaño de la fuga",
    "COMPONENTS.PROPORTIONAL_BAR.LEAK_SIZE.LARGE": "grande",
    "COMPONENTS.PROPORTIONAL_BAR.LEAK_SIZE.MEDIUM": "medio",
    "COMPONENTS.PROPORTIONAL_BAR.LEAK_SIZE.SMALL": "pequeño",
    "COMPONENTS.PROPORTIONAL_BAR.NO_LEAKS": "No se han detectado fugas.",
    "COMPONENTS.PROPORTIONAL_BAR.TITLE": "Porcentaje o Número de Fugas",
    "COMPONENTS.SEARCH_BAR.GENERIC": "Buscar",
    "COMPONENTS.SEARCH_BAR.SEARCH_COMPANIES": "Búsqueda de empresas",
    "COMPONENTS.SEARCH_BAR.SEARCH_PROJECTS": "Buscar proyectos",
    "COMPONENTS.SEARCH_BAR.SEARCH.DISABLED_TOOLTIP": "Seleccione un socio o empresa antes de utilizar la búsqueda.",
    "COMPONENTS.SEARCH.IMG.ALT": "Icono de búsqueda",
    "COMPONENTS.SELECT.DESELECT_ALL": "Deseleccionar todo",
    "COMPONENTS.SELECT.SELECT_ALL": "Seleccionar todo",
    "COMPONENTS.SESSION_INFORMATION.CONFIRMED_LEAKS": "Fugas Confirmadas",
    "COMPONENTS.SESSION_INFORMATION.NAME": "Nombre",
    "COMPONENTS.SESSION_INFORMATION.REGION": "Región",
    "COMPONENTS.SESSION_INFORMATION.TITLE": "Información sobre el ID de DMA",
    "COMPONENTS.SESSION_RELOCATION.BUTTON_CANCEL": "Cancelar",
    "COMPONENTS.SESSION_RELOCATION.BUTTON_CONFIRM": "Confirmar",
    "COMPONENTS.SESSION_RELOCATION.PARAGRAPH_A": "¿Estás seguro de que quieres este ID de sesión?",
    "COMPONENTS.SESSION_RELOCATION.PARAGRAPH_B": "para ser colocado en esta Clave de Activo",
    "COMPONENTS.SESSION_RELOCATION.SUCCESS.REQUEST": "Sesión movida exitosamente",
    "COMPONENTS.STATUS_MESSAGE.ICON.ALT.ERROR": "Icono de error",
    "COMPONENTS.STATUS_MESSAGE.ICON.ALT.SUCCESS": "Icono de éxito",
    "COMPONENTS.STATUS_MESSAGE.ICON.ALT.WARNING": "Icono de advertencia",
    "COMPONENTS.STATUS_MODAL.ICON.NEGATIVE.ALT": "Cruz indicando fallo",
    "COMPONENTS.STATUS_MODAL.ICON.POSITIVE.ALT": "Marca que indica éxito",
    "COMPONENTS.STATUS_MODAL.OK": "OK",
    "COMPONENTS.WAYPOINT_HEADINGS.CONSUMPTION_PROFILE": "Perfil de Consumo",
    "COMPONENTS.WAYPOINT_HEADINGS.CORRELATION": "Correlación",
    "COMPONENTS.WAYPOINT_HEADINGS.CORRELATION_TOOLTIP.CONTENT": "Esto muestra la lista de correlaciones con sus sesiones correspondientes en el siguiente formato:\\n{ID de Correlación}: {ID de Sesión A} - {ID de Sesión B}",
    "COMPONENTS.WAYPOINT_HEADINGS.CORRELATION_TOOLTIP.TITLE": "Desplegable de Correlación",
    "COMPONENTS.WAYPOINT_HEADINGS.JOB": "Trabajos",
    "COMPONENTS.WAYPOINT_HEADINGS.SESSION_TOOLTIP.CONTENT": "Este menú desplegable representa los ID de sesión con su estado correspondiente y la última hora de actualización en el formato:\\n{ID de sesión} : {Estado} : {Hora de última actualización}",
    "COMPONENTS.WAYPOINT_HEADINGS.SESSION_TOOLTIP.TITLE": "Desplegable de Sesión",
    "COMPONENTS.WAYPOINT_HEADINGS.SESSION.DROPDOWN.ID": "ID de sesión",
    "COMPONENTS.WAYPOINT_HEADINGS.SESSION.DROPDOWN.LAST_UPDATE": "Hora de finalización",
    "COMPONENTS.WAYPOINT_HEADINGS.SESSION.DROPDOWN.STATUS": "Estado",
    "COMPONENTS.WAYPOINT_HEADINGS.SESSION.DROPDOWN.TYPE": "Tipo",
    "COMPONENTS.WAYPOINT_HEADINGS.SESSIONS": "Sesiones",
    "COMPONENTS.WAYPOINT_HEADINGS.TOP_SOUND": "Sonido Superior",
    "COMPONENTS.WAYPOINT_HEADINGS.WAYPOINT_LINK": "Regresa a Waypoint",
    "COMPONENTS.WAYPOINT_KEY.LARGEST": "Punto de referencia más grande",
    "COMPONENTS.WAYPOINT_KEY.LATEST": "Último Punto de Referencia",
    "COMPONENTS.WAYPOINT_TABLE.NUMBER_ROWS": "Filas por página",
    "COMPONENTS.WAYPOINT_TABLE.TITLE.ROW_FIVE": "Fecha Actualizada",
    "COMPONENTS.WAYPOINT_TABLE.TITLE.ROW_FOUR": "Nombre del Ingeniero",
    "COMPONENTS.WAYPOINT_TABLE.TITLE.ROW_ONE": "Nombre",
    "COMPONENTS.WAYPOINT_TABLE.TITLE.ROW_SEVEN": "Seleccionar Punto de Referencia",
    "COMPONENTS.WAYPOINT_TABLE.TITLE.ROW_SIX": "Fecha de Creación",
    "COMPONENTS.WAYPOINT_TABLE.TITLE.ROW_THREE": "Estado",
    "COMPONENTS.WAYPOINT_TABLE.TITLE.ROW_TWO": "Tamaño",
    "COMPONENTS.WAYPOINT_TICKBOX_CONTAINER.CORRELATION": "Correlación",
    "COMPONENTS.WAYPOINT_TICKBOX_CONTAINER.MARKED_UP": "Marcado",
    "COMPONENTS.WAYPOINT_TICKBOX_CONTAINER.OVERNIGHT_SESSION": "Sesión nocturna",
    "COMPONENTS.WAYPOINT_TICKBOX_CONTAINER.REPAIR_SCHEDULED": "Reparación Programada",
    "COMPONENTS.WAYPOINT_TICKBOX_CONTAINER.REPAIRED": "Reparado",
    "COMPONENTS.WAYPOINT_TICKBOX_CONTAINER.SCHEDULED": "Programado",
    "COMPONENTS.WAYPOINT_TICKBOX_CONTAINER.TITLE": "Estado Actual",
    "COMPONENTS.WAYPOINT_TICKBOX_CONTAINER.TOP_SOUND": "Sonido superior",
    "COMPONENTS.WAYPOINT_TICKBOX_CONTAINER.VALIDATED": "Validado",
    "CONFIRM_ACCOUNT_PAGE.FORM.EMAIL.LABEL": "Correo electrónico",
    "CONFIRM_ACCOUNT_PAGE.FORM.EMAIL.PLACEHOLDER": "Ingrese correo electrónico",
    "CONFIRM_ACCOUNT_PAGE.FORM.PASSWORD.LABEL": "Contraseña",
    "CONFIRM_ACCOUNT_PAGE.FORM.PASSWORD.PLACEHOLDER": "Introducir la contraseña",
    "CONFIRM_ACCOUNT_PAGE.FORM.REPEAT_PASSWORD.LABEL": "Repita la contraseña",
    "CONFIRM_ACCOUNT_PAGE.FORM.REPEAT_PASSWORD.PLACEHOLDER": "Repita la contraseña",
    "CONFIRM_ACCOUNT_PAGE.FORM.SUBMIT": "Confirmar",
    "CONFIRM_ACCOUNT_PAGE.SUBTITLE": "Confirmar cuenta a continuación",
    "CONFIRM_ACCOUNT_PAGE.TITLE": "Confirmar cuenta",
    "CONSUMPTION_PROFILE_PAGE.CHART_LOAD_FAILED": "No se pudieron cargar los datos del gráfico de consumo. Intente actualizar la página o póngase en contacto con el servicio de asistencia si el problema persiste.",
    "CONSUMPTION_PROFILE_PAGE.CONSUMPTION_INFO.CONSUMPTION_INFO_TITLE": "Información de Consumo",
    "CONSUMPTION_PROFILE_PAGE.CONSUMPTION_INFO.CONSUMPTION_PROFILING": "ID de Perfil de Consumo",
    "CONSUMPTION_PROFILE_PAGE.CONSUMPTION_INFO.DATE_TITLE": "Fechas Horas",
    "CONSUMPTION_PROFILE_PAGE.CONSUMPTION_INFO.END_TIME": "Hora de finalización",
    "CONSUMPTION_PROFILE_PAGE.CONSUMPTION_INFO.EXPECTED_SAMPLES": "Muestras Esperadas",
    "CONSUMPTION_PROFILE_PAGE.CONSUMPTION_INFO.START_TIME": "Hora de inicio",
    "CONSUMPTION_PROFILE_PAGE.CONSUMPTION_INFO.TITLE": "Información del Perfil de Consumo",
    "CONSUMPTION_PROFILE_PAGE.CONSUMPTION_INFO.UPLOADED_SAMPLES": "Muestras Subidas",
    "CONSUMPTION_PROFILE_PAGE.LINE_GRAPH.EXPORT": "Exportar datos del rango mostrado",
    "CONSUMPTION_PROFILE_PAGE.LINE_GRAPH.TITLE": "Perfil de Consumo",
    "CONSUMPTION_PROFILE_PAGE.LOCATION_INFO.COLLECTED_ENGINEER": "Ingeniero Coleccionado",
    "CONSUMPTION_PROFILE_PAGE.LOCATION_INFO.COMPANY": "Empresa",
    "CONSUMPTION_PROFILE_PAGE.LOCATION_INFO.DEPLOYED_ENGINEER": "Ingeniero Desplegado",
    "CONSUMPTION_PROFILE_PAGE.LOCATION_INFO.LAST_UPDATED": "Días desde la última actualización",
    "CONSUMPTION_PROFILE_PAGE.LOCATION_INFO.LOCATION": "Ubicación",
    "CONSUMPTION_PROFILE_PAGE.LOCATION_INFO.POSTCODE": "Código postal",
    "CONSUMPTION_PROFILE_PAGE.LOCATION_INFO.TITLE": "Datos de Ubicación",
    "CONSUMPTION_PROFILE_PAGE.LOCATION_INFO.WHAT3WORDS": "What3Words",
    "CONSUMPTION_PROFILE_PAGE.NO_DATA": "No hay datos en el rango mostrado, por favor intenta con un rango diferente.",
    "CORRELATION_GRAPHS.CORRELATION_IMG_ALT": "Imagen de Correlación",
    "CORRELATION_GRAPHS.NO_RESULTS": "No hay audio ni gráficos disponibles para la Id de sesión:",
    "CORRELATION_GRAPHS.PAGE_TITLE": "Perfil Espectral",
    "CORRELATION_GRAPHS.PSD_IMG_ALT": "PSD para la sesión",
    "CORRELATION_GRAPHS.SESSION_ID": "Id de sesión",
    "CORRELATION_INFO_PAGE.CORRELATION_INFO.DETAILS_TITLE": "Detalles de Correlación",
    "CORRELATION_INFO_PAGE.CORRELATION_INFO.LEAK_DISTANCE": "Distancia de Fuga",
    "CORRELATION_INFO_PAGE.CORRELATION_INFO.POINT_A": "Ubicación del punto A",
    "CORRELATION_INFO_PAGE.CORRELATION_INFO.POINT_B": "Ubicación del punto B",
    "CORRELATION_INFO_PAGE.CORRELATION_INFO.SPEED_OF_SOUND": "Velocidad del sonido",
    "CORRELATION_INFO_PAGE.CORRELATION_INFO.TIMESTAMP": "Marca de tiempo",
    "CORRELATION_INFO_PAGE.CORRELATION_INFO.TITLE": "Información de Correlación",
    "CORRELATION_INFO_PAGE.CORRELATION_INFO.TOTAL_LENGTH": "Longitud Total",
    "CORRELATION_INFO_PAGE.ENGINEER_INFO.COMPANY": "Empresa",
    "CORRELATION_INFO_PAGE.ENGINEER_INFO.ENGINEER": "Ingeniero",
    "CORRELATION_INFO_PAGE.ENGINEER_INFO.TITLE": "Información del Ingeniero",
    "CORRELATION_INFO_PAGE.MATERIAL_INFO.DIAMETER": "Diámetro",
    "CORRELATION_INFO_PAGE.MATERIAL_INFO.LENGTH": "Longitud",
    "CORRELATION_INFO_PAGE.MATERIAL_INFO.MILLIMETERS": "mm",
    "CORRELATION_INFO_PAGE.MATERIAL_INFO.TITLE": "Detalles del Material",
    "CORRELATION_INFO_PAGE.STATUS.CENTRAL": "Posición central sospechada, por favor verifique manualmente",
    "CORRELATION_INFO_PAGE.STATUS.DETECTED": "La correlación ha sido exitosa",
    "CORRELATION_INFO_PAGE.STATUS.INCONCLUSIVE": "Correlación inconclusa",
    "CORRELATION_INFO_PAGE.STATUS.NOT_FOUND": "Ruido de fuga no encontrado",
    "CORRELATION_INFO_PAGE.STATUS.SUCCESS.DESCRIPTION": "Los resultados de correlación indican que no hay presencia de una fuga.",
    "CORRELATION_INFO_PAGE.STATUS.SUCCESS.TITLE": "¡Grandes noticias!",
    "CORRELATION_INFO_PAGE.STATUS.SUSPICIOUS_A": "Información sospechosa de tubería o fuera de soporte hacia el punto A",
    "CORRELATION_INFO_PAGE.STATUS.SUSPICIOUS_B": "Información sospechosa de tubería o fuera de paréntesis hacia el punto B",
    "CORRELATION_INFO_PAGE.STATUS.WARNING.DESCRIPTION": "Los resultados de correlación indican la presencia de una fuga.",
    "CORRELATION_INFO_PAGE.STATUS.WARNING.TITLE": "¡Advertencia!",
    "CURRENCY.EUR": "Euro",
    "CURRENCY.GBP": "Libra esterlina",
    "CURRENCY.USD": "dólar estadounidense",
    "DASHBOARD_PAGE.CO2.LABEL": "Ahorro de CO2",
    "DASHBOARD_PAGE.LEAKS.LABEL": "Número de fugas",
    "DASHBOARD_PAGE.LEAKS.LEGEND.LARGE": "Grande",
    "DASHBOARD_PAGE.LEAKS.LEGEND.MEDIUM": "Medio",
    "DASHBOARD_PAGE.LEAKS.LEGEND.SMALL": "Pequeño",
    "DASHBOARD_PAGE.LEAKS.SUBTITLE": "Número de fugas detectadas",
    "DASHBOARD_PAGE.LEAKS.TITLE": "Tamaño de las fugas",
    "DASHBOARD_PAGE.SUBTITLE": "Alguna otra información importante va aquí",
    "DASHBOARD_PAGE.SUMMARY.EXCEPTIONS.SUBTITLE": "Cuestiones",
    "DASHBOARD_PAGE.SUMMARY.EXCEPTIONS.TITLE": "Alertas de excepción",
    "DASHBOARD_PAGE.SUMMARY.FIDO_FUNNEL": "Embudo Fido",
    "DASHBOARD_PAGE.SUMMARY.FIDO_SCORE": "Puntuación FIDO",
    "DASHBOARD_PAGE.SUMMARY.LEAK_TITLE": "Información de fuga",
    "DASHBOARD_PAGE.SUMMARY.LEAKS_IDENTIFIED": "Fugas Predichas por FIDO AI",
    "DASHBOARD_PAGE.SUMMARY.LOCATE_DMA_BUTTON": "Ubica DMA en el Mapa",
    "DASHBOARD_PAGE.SUMMARY.NUMBER_REPAIRED": "Número marcado para reparación",
    "DASHBOARD_PAGE.SUMMARY.NUMBER_SCHEDULED": "Número previsto",
    "DASHBOARD_PAGE.SUMMARY.NUMBER_VERIFIED_REPAIRED": "Número reparado verificado por FIDO AI",
    "DASHBOARD_PAGE.SUMMARY.REPORTS.DELIVERY": "Resultados de las entregas",
    "DASHBOARD_PAGE.SUMMARY.REPORTS.HEALTH_CHECK": "Informe de chequeo de salud",
    "DASHBOARD_PAGE.SUMMARY.REPORTS.POST_PROJECT": "Informe posterior al proyecto",
    "DASHBOARD_PAGE.SUMMARY.REPORTS.PROJECT": "Estado del proyecto",
    "DASHBOARD_PAGE.SUMMARY.REPORTS.TITLE": "Informes",
    "DASHBOARD_PAGE.SUMMARY.SESSIONS_ANALISED": "Archivos analizados por FIDO AI",
    "DASHBOARD_PAGE.SUMMARY.TIMELINE.COMPANY": "Cronología de la empresa",
    "DASHBOARD_PAGE.SUMMARY.TIMELINE.PROJECT": "Calendario del proyecto",
    "DASHBOARD_PAGE.TIME_RANGE.ALL_TIME": "Todo el tiempo",
    "DASHBOARD_PAGE.TIME_RANGE.LAST_30_DAYS": "Últimos 30 días",
    "DASHBOARD_PAGE.TIME_RANGE.LAST_7_DAYS": "Los últimos 7 días",
    "DASHBOARD_PAGE.TIME_RANGE.LAST_YEAR": "El año pasado",
    "DASHBOARD_PAGE.TIME_RANGE.TODAY": "Hoy",
    "DASHBOARD_PAGE.TITLE": "Panel",
    "DASHBOARD_PAGE.TOTAL_LEAKAGE_DETECTED": "Fuga total detectada",
    "DASHBOARD_PAGE.VIEW_ALL_BTN": "Ver todos los proyectos",
    "DASHBOARD_PAGE.VOLUMETRICS.SUBTITLE": "Volumetría de fugas",
    "DASHBOARD_PAGE.WATER.ANALYSED_BY": "Sesiones analizadas por FIDO AI",
    "DASHBOARD_PAGE.WATER.COST": "Coste del agua perdida",
    "DASHBOARD_PAGE.WATER.COST_PER_YEAR": "USD al año",
    "DASHBOARD_PAGE.WATER.FIDO_AI": "FIDO AI",
    "DASHBOARD_PAGE.WELCOME": "Bienvenido",
    "DASHBOARD_PAGE.WELCOME_DESCRIPTION": "Aquí puede acceder a datos clave como cobertura, reducción de fugas, costo de pérdida de agua y seguimiento del progreso.",
    "DELETE_USER.BTN.CANCEL": "Cancelar",
    "DELETE_USER.BTN.CLOSE": "Cerrar Modal",
    "DELETE_USER.BTN.SUBMIT": "Eliminar",
    "DELETE_USER.DESC": "Eliminar este perfil eliminará todos los datos personales",
    "DELETE_USER.SUCCESS.MSG": "Usuario eliminado con éxito",
    "DELETE_USER.TITLE": "¿Eliminar perfil?",
    "DELETE_USER.VALIDATION.ERROR": "El usuario no pudo ser eliminado, por favor intente de nuevo",
    "DELIVERY_PERFORMANCE_PAGE.COLLECTIONS": "Colecciones",
    "DELIVERY_PERFORMANCE_PAGE.CONVERSION_RATE": "Tasa de conversión",
    "DELIVERY_PERFORMANCE_PAGE.COVERED": "Distancia Cubierta",
    "DELIVERY_PERFORMANCE_PAGE.DEPLOYMENT_ACCURACY": "Precisión de Despliegue",
    "DELIVERY_PERFORMANCE_PAGE.DEPLOYMENTS": "Implementaciones",
    "DELIVERY_PERFORMANCE_PAGE.END_DATE": "Fecha de finalización",
    "DELIVERY_PERFORMANCE_PAGE.HOURS_WORKED": "Horas trabajadas",
    "DELIVERY_PERFORMANCE_PAGE.IN_PROGRESS_WAYPOINTS": "Waypoints en curso",
    "DELIVERY_PERFORMANCE_PAGE.KM_COVERED": "km Cubiertos",
    "DELIVERY_PERFORMANCE_PAGE.LEAKS_MARKED_UP": "Fugas marcadas",
    "DELIVERY_PERFORMANCE_PAGE.NAME": "Nombre",
    "DELIVERY_PERFORMANCE_PAGE.NON_LEAKS_MARKED_UP": "Marcado sin fugas",
    "DELIVERY_PERFORMANCE_PAGE.NOT_FOUND_WAYPOINTS": "waypoints no encontrados",
    "DELIVERY_PERFORMANCE_PAGE.START_DATE": "fecha de inicio",
    "DELIVERY_PERFORMANCE_PAGE.WAYPOINTS_INVESTIGATED": "puntos de referencia investigados",
    "DETAIL_WIDGET.TITLE_A": "Sesiones",
    "DETAIL_WIDGET.TITLE_B": "FIDO AI Volumétrico Identificado",
    "DETAIL_WIDGET.TITLE_C": "Costo en Tiempo de Ejecución de la Pérdida de Agua",
    "DIALOG.CONFIRM_DELETE.DESCRIPTION": "¿Está seguro de que desea eliminar esta columna?",
    "DIALOG.CONFIRM_DELETE.TITLE": "Confirmar",
    "DIALOG.FORGOT_PASSWORD.CLOSE": "Cerca",
    "DIALOG.FORGOT_PASSWORD.DESCRIPTION": "Enviaremos un enlace de recuperación de contraseña a la dirección de correo electrónico del usuario.",
    "DIALOG.FORGOT_PASSWORD.SUBMIT": "Restablecer contraseña",
    "DIALOG.FORGOT_PASSWORD.TITLE": "Restablecer contraseña",
    "EDIT_COMPANY_PAGE.ADD_BRANCH.BUTTON": "Nuevo Proyecto",
    "EDIT_COMPANY_PAGE.ADD_BRANCH.FORM.NAME.LABEL": "Nombre del Proyecto",
    "EDIT_COMPANY_PAGE.ADD_BRANCH.FORM.NAME.PLACEHOLDER": "Ingrese el nombre del proyecto",
    "EDIT_COMPANY_PAGE.ADD_BRANCH.FORM.SUBMIT": "Agregar Proyecto",
    "EDIT_COMPANY_PAGE.ADD_BRANCH.TITLE": "Agregar Proyecto",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.BUTTON": "Nuevo empleado",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.FORM.BRANCH.LABEL": "Proyecto",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.FORM.BRANCH.PLACEHOLDER": "Elegir Proyecto",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.FORM.COMPANY.LABEL": "Compañía",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.FORM.COMPANY.PLACEHOLDER": "Elija empresa",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.FORM.EMAIL.LABEL": "Dirección de correo electrónico",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.FORM.EMAIL.PLACEHOLDER": "Ingrese correo electrónico",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.FORM.FIRST_NAME.LABEL": "Nombre de pila",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.FORM.FIRST_NAME.PLACEHOLDER": "Ingrese el nombre",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.FORM.LAST_NAME.LABEL": "Apellido",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.FORM.LAST_NAME.PLACEHOLDER": "Introduzca el apellido",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.FORM.ROLE.LABEL": "Role",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.FORM.ROLE.PLACEHOLDER": "Elija Rol",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.FORM.SUBMIT": "Agregar empleado",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.TITLE": "Agregar empleado",
    "EDIT_COMPANY_PAGE.BRANCHES_TABLE.ACTIONS": "Comportamiento",
    "EDIT_COMPANY_PAGE.BRANCHES_TABLE.ADD": "Agregar",
    "EDIT_COMPANY_PAGE.BRANCHES_TABLE.ADDRESS": "DIRECCIÓN",
    "EDIT_COMPANY_PAGE.BRANCHES_TABLE.BRANCHES": "Proyectos ({{ count }})",
    "EDIT_COMPANY_PAGE.BRANCHES_TABLE.INDEX": "№",
    "EDIT_COMPANY_PAGE.BRANCHES_TABLE.NAME": "Nombre del Proyecto",
    "EDIT_COMPANY_PAGE.BRANCHES_TABLE.NO_BRANCHES": "No hay proyectos",
    "EDIT_COMPANY_PAGE.BRANCHES_TABLE.TOTAL_REPORTS": "Informes totales",
    "EDIT_COMPANY_PAGE.BRANCHES_TABLE.TOTAL_USERS": "Usuarios totales",
    "EDIT_COMPANY_PAGE.CRUMB": "Administrar empresa",
    "EDIT_COMPANY_PAGE.DELETE_BRANCH.TITLE": "¿Estás seguro de que quieres eliminar este Proyecto?",
    "EDIT_COMPANY_PAGE.DELETE_COMPANY.TITLE": "¿Está seguro de que desea eliminar esta empresa?",
    "EDIT_COMPANY_PAGE.DELETE_EMPLOYEE.TITLE": "¿Está seguro de que desea eliminar este empleado?",
    "EDIT_COMPANY_PAGE.EDIT_BRANCH.BUTTON": "Editar Proyecto",
    "EDIT_COMPANY_PAGE.EDIT_BRANCH.FORM.NAME.PLACEHOLDER": "Ingrese el nombre del proyecto",
    "EDIT_COMPANY_PAGE.EDIT_BRANCH.FORM.SUBMIT": "Actualizar Proyecto",
    "EDIT_COMPANY_PAGE.EDIT_BRANCH.TITLE": "Editar Proyecto",
    "EDIT_COMPANY_PAGE.EMPLOYEES_TABLE.ACTIONS": "Comportamiento",
    "EDIT_COMPANY_PAGE.EMPLOYEES_TABLE.ADD": "Agregar",
    "EDIT_COMPANY_PAGE.EMPLOYEES_TABLE.BRANCH": "Proyecto",
    "EDIT_COMPANY_PAGE.EMPLOYEES_TABLE.EMAIL": "Correo electrónico",
    "EDIT_COMPANY_PAGE.EMPLOYEES_TABLE.EMPLOYEES": "Empleados ({{ cuenta }})",
    "EDIT_COMPANY_PAGE.EMPLOYEES_TABLE.INDEX": "№",
    "EDIT_COMPANY_PAGE.EMPLOYEES_TABLE.NAME": "Nombre de usuario",
    "EDIT_COMPANY_PAGE.EMPLOYEES_TABLE.NO_EMPLOYEES": "sin empleados",
    "EDIT_COMPANY_PAGE.EMPLOYEES_TABLE.ROLE": "Role",
    "EDIT_COMPANY_PAGE.EMPLOYEES_TABLE.STATUS": "Estado",
    "EDIT_COMPANY_PAGE.EMPLOYEES_TABLE.TOTAL_REPORTS": "Informes personalizados totales",
    "EDIT_COMPANY_PAGE.FORM.ADDRESS.LABEL": "DIRECCIÓN",
    "EDIT_COMPANY_PAGE.FORM.ADDRESS.PLACEHOLDER": "Ingresa la direccion",
    "EDIT_COMPANY_PAGE.FORM.DELETE": "Borrar",
    "EDIT_COMPANY_PAGE.FORM.DISCARD": "Desechar",
    "EDIT_COMPANY_PAGE.FORM.EDIT": "Editar",
    "EDIT_COMPANY_PAGE.FORM.NAME.LABEL": "Nombre",
    "EDIT_COMPANY_PAGE.FORM.NAME.PLACEHOLDER": "Ingrese su nombre",
    "EDIT_COMPANY_PAGE.FORM.NO_CHANGES": "Sin cambios",
    "EDIT_COMPANY_PAGE.FORM.SUBMIT": "Ahorrar",
    "EDIT_COMPANY_PAGE.TITLE": "Editar empresa",
    "EDIT_PARTNER.COUNTRY": "País",
    "EDIT_PARTNER.PARTNER_CODE": "Código de Socio",
    "EDIT_PARTNER.PARTNER_NAME": "Nombre del Socio",
    "EDIT_PARTNER.TITLE": "Editar Socio",
    "EDIT_PROJECT.COMPANY.LABEL": "Empresa",
    "EDIT_PROJECT.COMPANY.PLACEHOLDER": "Seleccione una empresa",
    "EDIT_PROJECT.COMPANY.VALIDATION": "Se requiere una empresa",
    "EDIT_PROJECT.COST_PER_DISTANCE.LABEL": "Costo por Distancia",
    "EDIT_PROJECT.COST_PER_DISTANCE.PLACEHOLDER": "Costo por Distancia",
    "EDIT_PROJECT.COST_PER_DISTANCE.VALIDATION": "Se requiere el costo por distancia",
    "EDIT_PROJECT.DISCARD": "Descartar",
    "EDIT_PROJECT.DMAS.LABEL": "DMAs",
    "EDIT_PROJECT.DMAS.NO_MATCHING": "No hay DMAs coincidentes",
    "EDIT_PROJECT.DMAS.PLACEHOLDER": "Seleccionar DMAs",
    "EDIT_PROJECT.END_DATE.LABEL": "Fecha de finalización",
    "EDIT_PROJECT.END_DATE.PLACEHOLDER": "Seleccione la Fecha Final",
    "EDIT_PROJECT.END_DATE.VALIDATION": "La fecha de finalización debe ser posterior a la fecha de inicio",
    "EDIT_PROJECT.NAME.LABEL": "Nombre del Proyecto",
    "EDIT_PROJECT.NAME.PLACEHOLDER": "Ingrese el nombre del proyecto",
    "EDIT_PROJECT.NAME.VALIDATION": "Se requiere el nombre del proyecto",
    "EDIT_PROJECT.NO_CHANGES": "No hay cambios en la información del proyecto.",
    "EDIT_PROJECT.START_DATE.LABEL": "Fecha de inicio",
    "EDIT_PROJECT.START_DATE.PLACEHOLDER": "Seleccione Fecha de Inicio",
    "EDIT_PROJECT.START_DATE.VALIDATION": "La fecha de inicio debe ser anterior a la fecha de finalización",
    "EDIT_PROJECT.SUBMIT": "Enviar",
    "EDIT_PROJECT.TARGET_DISTANCE.LABEL": "Distancia objetivo",
    "EDIT_PROJECT.TARGET_DISTANCE.PLACEHOLDER": "Introduzca la distancia objetivo",
    "EDIT_PROJECT.TARGET_DISTANCE.VALIDATION": "Se requiere la distancia objetivo",
    "EDIT_PROJECT.TARGET_LEAKAGE.LABEL": "Fuga de objetivo",
    "EDIT_PROJECT.TARGET_LEAKAGE.PLACEHOLDER": "Introduzca la fuga de objetivo",
    "EDIT_PROJECT.TARGET_LEAKAGE.VALIDATION": "Se requiere una fuga de objetivo",
    "EDIT_PROJECT.TITLE": "Editar Proyecto",
    "EDIT_USER.PAGE_TITLE": "Editar Usuario",
    "EDIT_USER.RETURN_BTN": "Descartar",
    "EDIT_USER.SUBMIT_BTN": "Guardar Usuario",
    "ERROR.DUPLICATE_EMAIL": "La dirección de correo electrónico ingresada ya existe",
    "ERROR.DUPLICATE_PROJECT": "El nombre del proyecto ya existe",
    "ERROR.NO_DATA": "Los datos para este usuario no están disponibles en este momento",
    "ERROR.REPORT.NO_DATA": "El informe no tiene datos devueltos. Por favor, intenta cambiar el rango de fechas",
    "ERROR.REQUEST": "Ocurrió un error al procesar su solicitud. Intente actualizar la página.",
    "ERROR.SESSION_EXPIRED": "La sesión ha expirado, por favor inicia sesión nuevamente",
    "EXPORT_BUTTON.ALL": "Exportar todo",
    "EXPORT_BUTTON.ALL_CSV": "Exportar todo (CSV)",
    "EXPORT_BUTTON.ALL_EXCEL": "Exportar todo (Excel)",
    "EXPORT_BUTTON.ALL_JSON": "Exportar todo (JSON)",
    "EXPORT_BUTTON.ERROR.REQUEST": "Error al exportar datos",
    "EXPORT_BUTTON.EXPORT": "Exportar",
    "EXPORT_BUTTON.FILTERED": "Exportación filtrada",
    "EXPORT_BUTTON.FILTERED_CSV": "Exportación filtrada (CSV)",
    "EXPORT_BUTTON.FILTERED_EXCEL": "Exportación filtrada (Excel)",
    "EXPORT_BUTTON.FILTERED_JSON": "Exportación filtrada (JSON)",
    "EXPORT_BUTTON.SUCCESS.REQUEST": "Deberías recibir un correo electrónico con la exportación en breve.",
    "FILTERS.DATE_RANGE.TITLE": "Rango de fechas",
    "FILTERS.DIALOG.SUBTITLE.CHANGE": "¿Se eliminarán todos los filtros?",
    "FILTERS.DIALOG.SUBTITLE.CLOSE": "¿Se eliminarán los cambios?",
    "FILTERS.DIALOG.TITLE.CHANGE": "¿Está seguro de que desea cambiar la fuente de datos?",
    "FILTERS.DIALOG.TITLE.CLOSE": "¿Seguro que quieres cerrar la configuración?",
    "FILTERS.FORM.COLUMN.LABEL": "Columna",
    "FILTERS.FORM.COLUMN.PLACEHOLDER": "Seleccionar columna",
    "FILTERS.FORM.SOURCE.LABEL": "Fuente de datos",
    "FILTERS.FORM.SOURCE.PLACEHOLDER": "Seleccionar fuente de datos",
    "FILTERS.FORM.TYPE.LABEL": "Tipo",
    "FILTERS.FORM.TYPE.PLACEHOLDER": "Seleccione tipo",
    "FILTERS.FORM.VALUE.LABEL": "Valor",
    "FILTERS.FORM.VALUE.PLACEHOLDER": "Selecciona valor",
    "FILTERS.MODAL_TITLE": "Ajustes",
    "FORGOT_PASSWORD_PAGE.FORM.EMAIL.LABEL": "Correo electrónico",
    "FORGOT_PASSWORD_PAGE.FORM.EMAIL.PLACEHOLDER": "Introduce tu correo electrónico",
    "FORGOT_PASSWORD_PAGE.FORM.SUBMIT": "Enviar enlace de reinicio",
    "FORGOT_PASSWORD_PAGE.RECOVERY_SUCCESS": "El enlace de recuperación se envió con éxito a su correo electrónico",
    "FORGOT_PASSWORD_PAGE.SUBTITLE": "Ingrese su correo electrónico a continuación",
    "FORGOT_PASSWORD_PAGE.TITLE": "Has olvidado tu contraseña",
    "FORM.LABEL.COMPANY": "Empresa",
    "FORM.LABEL.COUNTRY": "País",
    "FORM.LABEL.CURRENCY": "Moneda",
    "FORM.LABEL.DIAMETER_UNIT": "Diámetro",
    "FORM.LABEL.EMAIL": "Correo electrónico",
    "FORM.LABEL.FIRST_NAME": "Nombre",
    "FORM.LABEL.FLOW_RATE_UNIT": "Caudal",
    "FORM.LABEL.LAST_NAME": "Apellido",
    "FORM.LABEL.LONG_DISTANCE_UNIT": "Larga distancia",
    "FORM.LABEL.MEASUREMENT_SYSTEM": "Sistema de medición",
    "FORM.LABEL.PARTNER": "Socio",
    "FORM.LABEL.PHONE": "Teléfono",
    "FORM.LABEL.ROLE": "Rol",
    "FORM.LABEL.SHORT_DISTANCE_UNIT": "Distancia corta",
    "FORM.LABEL.VOLUME_UNIT": "Volumen",
    "FORM.LABEL.WEIGHT_UNIT": "Peso",
    "FORM.PLACEHOLDER.COMPANY": "Seleccione una empresa",
    "FORM.PLACEHOLDER.COUNTRY": "Seleccionar país",
    "FORM.PLACEHOLDER.CURRENCY": "Seleccionar moneda",
    "FORM.PLACEHOLDER.DIAMETER_UNIT": "Seleccionar diámetro",
    "FORM.PLACEHOLDER.FLOW_RATE_UNIT": "Seleccionar caudal",
    "FORM.PLACEHOLDER.LONG_DISTANCE_UNIT": "Seleccionar larga distancia",
    "FORM.PLACEHOLDER.MEASUREMENT_SYSTEM": "Seleccionar sistema de medida",
    "FORM.PLACEHOLDER.PARTNER": "Seleccione un socio",
    "FORM.PLACEHOLDER.PHONE": "Seleccionar teléfono",
    "FORM.PLACEHOLDER.ROLE": "Seleccione un rol",
    "FORM.PLACEHOLDER.SHORT_DISTANCE_UNIT": "Seleccionar distancia corta",
    "FORM.PLACEHOLDER.VOLUME_UNIT": "Seleccionar volumen",
    "FORM.PLACEHOLDER.WEIGHT_UNIT": "Seleccionar peso",
    "FORM.VALIDATION.COMPANY": "Se requiere empresa",
    "FORM.VALIDATION.COUNTRY": "El país es obligatorio",
    "FORM.VALIDATION.CURRENCY": "La moneda es obligatoria",
    "FORM.VALIDATION.EMAIL": "Se requiere correo electrónico",
    "FORM.VALIDATION.FIRST_NAME": "Se requiere el primer nombre",
    "FORM.VALIDATION.LAST_NAME": "Se requiere el apellido",
    "FORM.VALIDATION.MEASUREMENT_SYSTEM": "Se requiere el sistema de medición",
    "FORM.VALIDATION.PARTNER": "Se requiere socio",
    "FORM.VALIDATION.PHONE": "El teléfono es obligatorio",
    "FORM.VALIDATION.ROLE": "Se requiere un rol",
    "GIS_ADMIN.ACTION.SELECT": "Seleccionar",
    "GIS_ADMIN.DELETE_MODAL.BTN.CANCEL": "Cancelar",
    "GIS_ADMIN.DELETE_MODAL.BTN.REMOVE": "Eliminar",
    "GIS_ADMIN.DELETE_MODAL.ERROR_MSG": "Error al eliminar la carga de GIS",
    "GIS_ADMIN.DELETE_MODAL.TITLE": "Confirmar la eliminación de la carga GIS",
    "GIS_ADMIN.PREVIEW_MODAL.BTN.CLOSE": "Cerrar vista previa",
    "GIS_ADMIN.PREVIEW_MODAL.ERROR_MSG": "Error al cargar la vista previa",
    "GIS_ADMIN.PREVIEW_MODAL.NO_DATA": "No hay datos para mostrar",
    "GIS_ADMIN.PREVIEW_MODAL.TITLE": "Vista previa de GIS",
    "GIS_ADMIN.SEARCH.PLACEHOLDER": "Buscar",
    "GIS_ADMIN.SEARCH.TEXT": "Buscar",
    "GIS_ADMIN.TABLE.HEADERS.A": "Nombre de la Empresa",
    "GIS_ADMIN.TABLE.HEADERS.B": "Fecha de carga",
    "GIS_ADMIN.TABLE.HEADERS.C": "Subido por",
    "GIS_ADMIN.TABLE.HEADERS.D": "Acción",
    "GIS_ADMIN.TABLE.TITLE": "Lista de Cargas de GIS",
    "GIS_ADMIN.TITLE": "Administrador GIS",
    "GIS_UPLOAD.API.GENERIC_ERROR": "Solicitud fallida, por favor verifique el formato del archivo",
    "GIS_UPLOAD.ASSETS.COLUMN.CREATED_DATE.DESCRIPTION": "Fecha en que se instaló el activo",
    "GIS_UPLOAD.ASSETS.COLUMN.DIAMETER.DESCRIPTION": "Diámetro del activo",
    "GIS_UPLOAD.ASSETS.COLUMN.DMA_KEY.DESCRIPTION": "Referencia a la clave de área de la que forma parte el activo",
    "GIS_UPLOAD.ASSETS.COLUMN.KEY.DESCRIPTION": "Identificador distinto para cada activo en la red",
    "GIS_UPLOAD.ASSETS.COLUMN.SUBTYPE.DESCRIPTION": "Clasificación adicional que detalla las características específicas del activo",
    "GIS_UPLOAD.ASSETS.COLUMN.TYPE.DESCRIPTION": "Clasificación del activo según su función",
    "GIS_UPLOAD.BUTTON.DISCARD": "Descartar",
    "GIS_UPLOAD.BUTTON.NEXT": "Siguiente",
    "GIS_UPLOAD.DMA.COLUMN.KEY.DESCRIPTION": "Identificador único para cada Área",
    "GIS_UPLOAD.DMA.COLUMN.NAME.DESCRIPTION": "Nombre descriptivo del Área",
    "GIS_UPLOAD.ERROR_MODAL.ALT.GIF_A": "mostrando en pantalla el proceso de mapeo de columnas",
    "GIS_UPLOAD.ERROR_MODAL.ALT.GIF_B": "mostrando en pantalla el proceso de mapeo de campos del sistema",
    "GIS_UPLOAD.ERROR_MODAL.BUTTON.CLOSE": "Cerrar",
    "GIS_UPLOAD.ERROR_MODAL.DESC.A": "Asigna las columnas requeridas como se muestra a continuación",
    "GIS_UPLOAD.ERROR_MODAL.DESC.B": "Mapea los campos del sistema como se muestra a continuación",
    "GIS_UPLOAD.ERROR_MODAL.DESC.C": "TAMBIÉN",
    "GIS_UPLOAD.ERROR_MODAL.TITLE.A": "¡Ups! Algo salió mal de nuestra parte.",
    "GIS_UPLOAD.ERROR_MODAL.TITLE.B": "Parece que nuestro sistema está experimentando algunos problemas actualmente. Por favor, inténtelo de nuevo más tarde.",
    "GIS_UPLOAD.ERROR_MODAL.TITLE.C": "Si el problema persiste, no dude en contactar a nuestro equipo de soporte.",
    "GIS_UPLOAD.ERROR_MODAL.TITLE.D": "Ha ocurrido un error",
    "GIS_UPLOAD.ERROR.INVALID_FILE": "Archivo no válido",
    "GIS_UPLOAD.ERROR.MISSING_FILE": "Archivo faltante",
    "GIS_UPLOAD.FILE_HEADER.BTN.BACK_TO_PROJECT": "Volver a la creación del proyecto",
    "GIS_UPLOAD.FILE_HEADER.BTN.CLOSE_MODAL": "Cerrar Modal",
    "GIS_UPLOAD.FILE_HEADER.BTN.GIS_ADMIN": "Ver Administrador GIS",
    "GIS_UPLOAD.FILE_HEADER.BTN.LINK.GIS_ADMIN": "Ver GIS Admin",
    "GIS_UPLOAD.FILE_HEADER.BTN.UPLOAD": "Subir",
    "GIS_UPLOAD.FILE_HEADER.COUNTER": "Archivo",
    "GIS_UPLOAD.FILE_HEADER.DISCARD": "Descartar archivo",
    "GIS_UPLOAD.FILE_HEADER.ERROR.PARAGRAPH": "Error al cargar GIS, por favor intente de nuevo",
    "GIS_UPLOAD.FILE_HEADER.FINAL_STEP": "Paso Final",
    "GIS_UPLOAD.FILE_HEADER.LOADING.TEXT": "Cargando",
    "GIS_UPLOAD.FILE_HEADER.MODAL.UPLOAD_TXT": "¡Carga finalizada! Consulta la página de administración para más detalles a continuación",
    "GIS_UPLOAD.FILE_HEADER.NEXT": "Siguiente",
    "GIS_UPLOAD.FILE_HEADER.NO_FILE": "No hay archivos para seleccionar",
    "GIS_UPLOAD.FILE_HEADER.PREVIOUS": "Anterior",
    "GIS_UPLOAD.FILE_HEADER.RESET": "Volver a subir archivos",
    "GIS_UPLOAD.FILE_HEADER.SUCCESS.PARAGRAPH": "GIS cargado con éxito",
    "GIS_UPLOAD.FILE_HEADER.TEXT.PARAGRAPH": "¿Estás seguro de que deseas subir GIS?",
    "GIS_UPLOAD.FILE_HEADER.TEXT.UPLOAD_PARAGRAPH": "¿Estás seguro de que deseas subir GIS?",
    "GIS_UPLOAD.FILE_HEADER.TITLE.MAP_PREVIEW": "Vista previa del mapa",
    "GIS_UPLOAD.FILE_HEADER.TITLE.MAPPING": "Mapeo de Columnas",
    "GIS_UPLOAD.FILE_HEADER.TITLE.MAPPING_FOR": "para",
    "GIS_UPLOAD.INPUT.COMPANY.LABEL": "Seleccionar Empresa",
    "GIS_UPLOAD.INPUT.COMPANY.PLACEHOLDER": "Seleccionar Empresa",
    "GIS_UPLOAD.LOADING": "Cargando...",
    "GIS_UPLOAD.MAP_PREVIEW.API.GENERAL_ERROR": "Error al cargar el mapa",
    "GIS_UPLOAD.MAP_PREVIEW.BTN.GIS_ADMIN": "Ver Administrador GIS",
    "GIS_UPLOAD.MAP_PREVIEW.BTN.NEXT": "Siguiente",
    "GIS_UPLOAD.MAP_PREVIEW.BTN.PREVIOUS": "Anterior",
    "GIS_UPLOAD.MAP_PREVIEW.TITLE": "Vista previa del mapa",
    "GIS_UPLOAD.MAP_PREVIEW.UPLOAD_FINISHED": "¡Carga finalizada! Consulta la página de administración para más detalles a continuación",
    "GIS_UPLOAD.PAGE_TITLE": "Subir GIS",
    "GIS_UPLOAD.PIPES.COLUMN.CREATED_DATE.DESCRIPTION": "Fecha en la que se creó o instaló el registro de la tubería",
    "GIS_UPLOAD.PIPES.COLUMN.DIAMETER_UNITS.DESCRIPTION": "Unidades de medida del diámetro de la tubería",
    "GIS_UPLOAD.PIPES.COLUMN.DIAMETER.DESCRIPTION": "Diámetro de la tubería, unidades especificadas por separado",
    "GIS_UPLOAD.PIPES.COLUMN.DMA_KEY.DESCRIPTION": "Referencia a la clave de área de la que forma parte la tubería",
    "GIS_UPLOAD.PIPES.COLUMN.KEY.DESCRIPTION": "Identificador distinto para cada tubería de la red",
    "GIS_UPLOAD.PIPES.COLUMN.MATERIAL.DESCRIPTION": "Material de construcción principal de la tubería",
    "GIS_UPLOAD.PIPES.COLUMN.STATUS.DESCRIPTION": "Ya sea que la tubería esté en servicio activo, abandonada, removida, etc.",
    "GIS_UPLOAD.PIPES.COLUMN.SUBTYPE.DESCRIPTION": "Clasificación específica de tuberías según su función o estructura",
    "GIS_UPLOAD.PIPES.COLUMN.TYPE.DESCRIPTION": "Qué servicio realiza la tubería: distribución principal, línea de servicio, tubería principal, etc.",
    "GIS_UPLOAD.ROUTES.STEP_FIVE": "Vista previa del mapa",
    "GIS_UPLOAD.ROUTES.STEP_FOUR": "Procesar Activos",
    "GIS_UPLOAD.ROUTES.STEP_ONE": "Subir Shapefile",
    "GIS_UPLOAD.ROUTES.STEP_THREE": "Tuberías de Proceso",
    "GIS_UPLOAD.ROUTES.STEP_TWO": "Proceso DMA",
    "GIS_UPLOAD.STATUS.FILE_FETCHING": "Se están recuperando los datos del archivo...",
    "GIS_UPLOAD.STATUS.FILE_LOADING": "Los datos del archivo se están cargando...",
    "GIS_UPLOAD.STATUS.FILE_UPLOADING": "El archivo se está cargando...",
    "GIS_UPLOAD.STATUS.LOADING_COMPANIES_DATA": "Cargando datos de empresas...",
    "GIS_UPLOAD.STATUS.UPLOADING_FILE": "Subiendo un archivo...",
    "GIS_UPLOAD.TABLE.CREATE_COLUMN": "Crear columna",
    "GIS_UPLOAD.TABLE.CREATE_COLUMN_ERROR": "Algo salió mal: no se pudo crear la columna",
    "GIS_UPLOAD.TABLE.INVALID_MAPPING": "Esta columna no es válida para el tipo de datos seleccionado",
    "GIS_UPLOAD.TABLE.MAPPING_TITLE": "Mapeo de Columnas Seleccionadas",
    "GIS_UPLOAD.TABLE.NEW_COLUMN.DELETE": "Borrar",
    "GIS_UPLOAD.TABLE.NEW_COLUMN.SAVE": "Guardar cambios",
    "GIS_UPLOAD.TABLE.NEW_COLUMN.TYPE": "Tipo de columna",
    "GIS_UPLOAD.TABLE.NEW_COLUMN.TYPE.PLACEHOLDER": "Seleccionar el tipo de columna",
    "GIS_UPLOAD.TABLE.NEW_COLUMN.UNITS": "Unidades",
    "GIS_UPLOAD.TABLE.NEW_COLUMN.UNITS.PLACEHOLDER": "Seleccionar unidades",
    "GIS_UPLOAD.TABLE.NEW_COLUMN.VALUE": "Valor",
    "GIS_UPLOAD.TABLE.NEW_COLUMN.VALUE_MANUAL": "Valor",
    "GIS_UPLOAD.TABLE.NEW_COLUMN.VALUE_MANUAL.PLACEHOLDER": "Introduzca un valor para todas las celdas de la columna",
    "GIS_UPLOAD.TABLE.NEW_COLUMN.VALUE.PLACEHOLDER": "Seleccionar un valor para todas las celdas de la columna",
    "GIS_UPLOAD.TABLE.NO_MAPPING_OPTIONS": "No hay opciones de mapeo",
    "GIS_UPLOAD.TABLE.SELECT_COLUMN": "Por favor, seleccione una columna",
    "GIS_UPLOAD.TABLE.UPDATE_COLUMN": "Actualizar columna",
    "GIS_UPLOAD.TABLE.UPDATE_COLUMN_ERROR": "Algo salió mal: no se pudo actualizar la columna",
    "GIS_UPLOAD.UPLOAD.ERROR": "Error al cargar, inténtalo de nuevo.",
    "GIS_UPLOAD.UPLOAD.LABEL": "Subir Shapefile",
    "HEADER.BROWSE": "Navegar",
    "HEADER.COMPANIES": "Empresas",
    "HEADER.CONSUMPTION_PROFILE": "Perfil de Consumo",
    "HEADER.CORRELATION": "Correlación",
    "HEADER.DASHBOARD": "Tablero",
    "HEADER.DPLE": "Ingeniero de rendimiento de entrega de fugas",
    "HEADER.DPST": "Técnico de Sensor de Rendimiento de Entrega",
    "HEADER.GIS_ADMIN": "Administrador de SIG",
    "HEADER.GIS_UPLOAD": "Carga de GIS",
    "HEADER.HOME": "Hogar",
    "HEADER.JOB_DETAILS": "Detalles del Trabajo",
    "HEADER.LOGS": "Registros de Cambios",
    "HEADER.PROFILE": "Perfil",
    "HEADER.PROJECT_STATUS": "Estado del Proyecto",
    "HEADER.RELAY_MANAGEMENT": "Gestión de Relevos",
    "HEADER.REPORTS": "Informes",
    "HEADER.SENSOR_MANAGEMENT": "Gestión de Sensores",
    "HEADER.SESSION": "Información de la sesión",
    "HEADER.STOCK_MANAGEMENT": "Gestión de Stock",
    "HEADER.TOP_SOUND": "Sonido Superior",
    "HEADER.USERS": "Gestión de Usuarios",
    "HEADER.WAYPOINT": "Punto de referencia",
    "HISTORY_AND_OVERNIGHT_GRAPHS.ERROR_TXT.NO_GRAPHS": "No hay gráficos históricos o nocturnos disponibles",
    "HISTORY_AND_OVERNIGHT_GRAPHS.ERROR_TXT.NO_HISTORICAL_GRAPHS": "No hay gráficos históricos disponibles",
    "HISTORY_AND_OVERNIGHT_GRAPHS.ERROR_TXT.NO_OVERNIGHT_GRAPHS": "No hay gráfico nocturno disponible",
    "HISTORY_AND_OVERNIGHT_GRAPHS.IMG.ALT.HISTORICAL": "Gráfico de sesión histórica",
    "HISTORY_AND_OVERNIGHT_GRAPHS.IMG.ALT.OVERNIGHT": "Gráfico de la sesión nocturna",
    "HISTORY_AND_OVERNIGHT_GRAPHS.TITLES.HISTORY": "Historia",
    "HISTORY_AND_OVERNIGHT_GRAPHS.TITLES.OVERNIGHT": "De la noche a la mañana",
    "HOME_PAGE.DESCRIPTION": "Bienvenido al Centro donde puedes gestionar tareas, dar soporte a usuarios y consultar todos los datos de tu servicio FIDO Smart. ¿En qué podemos ayudarte hoy?",
    "HOME_PAGE.HELLO": "Hola, {{name}}",
    "HOME_PAGE.HERO_IMAGE_ALT": "Imagen de héroe",
    "HOME_PAGE.LOCATE_LEAKS.DESCRIPTION": "Explorar puntos de referencia por tamaño y supervisar las investigaciones",
    "HOME_PAGE.LOCATE_LEAKS.TITLE": "Localizar fugas",
    "HOME_PAGE.MANAGE_PROJECTS.DESCRIPTION": "Supervisar el progreso del proyecto y ver la actividad pasada",
    "HOME_PAGE.MANAGE_PROJECTS.TITLE": "Gestionar proyectos",
    "HOME_PAGE.MONITOR_NETWORK.DESCRIPTION": "Gestione sus sensores fijos y optimice la conectividad",
    "HOME_PAGE.MONITOR_NETWORK.TITLE": "Monitorea tu red",
    "HOME_PAGE.NO_ACTIVITIES_FOUND": "No se encontraron actividades",
    "HOME_PAGE.YOUR_DASHBOARDS.DESCRIPTION": "Analizar e informar sobre datos clave de rendimiento",
    "HOME_PAGE.YOUR_DASHBOARDS.TITLE": "Sus paneles de control",
    "HOME_PAGE.YOUR_LATEST_ACTIVITIES": "Tus últimas actividades",
    "INVITATIONS.ACCEPT.CONTEXT.EMAIL": "Correo electrónico",
    "INVITATIONS.ACCEPT.CONTEXT.NOT_PROVIDED": "No se proporciona",
    "INVITATIONS.ACCEPT.CONTEXT.ORGANIZATION": "Organización",
    "INVITATIONS.ACCEPT.CONTEXT.ROLE": "Role",
    "INVITATIONS.ACCEPT.ERROR.ALREADY_ACCEPTED.DESCRIPTION": "Inicia sesión con tu cuenta existente para continuar.",
    "INVITATIONS.ACCEPT.ERROR.ALREADY_ACCEPTED.TITLE": "Invitación ya aceptada",
    "INVITATIONS.ACCEPT.ERROR.CANCELLED.DESCRIPTION": "Esta invitación ya no está activa. Si aún necesita acceso, póngase en contacto con su administrador.",
    "INVITATIONS.ACCEPT.ERROR.CANCELLED.TITLE": "Invitación cancelada",
    "INVITATIONS.ACCEPT.ERROR.EXPIRED.DESCRIPTION": "Este enlace de invitación ya no está activo. Solicita una nueva invitación a tu administrador.",
    "INVITATIONS.ACCEPT.ERROR.EXPIRED.TITLE": "La invitación ha caducado.",
    "INVITATIONS.ACCEPT.ERROR.INVALID.DESCRIPTION": "Esta invitación no es válida o ha caducado. Solicita una nueva invitación a tu administrador.",
    "INVITATIONS.ACCEPT.ERROR.INVALID.TITLE": "Invitación no válida",
    "INVITATIONS.ACCEPT.ERROR.SUBMIT_FAILURE": "No aceptó la invitación.",
    "INVITATIONS.ACCEPT.FIELDS.CONFIRM_PASSWORD": "Confirmar Contraseña",
    "INVITATIONS.ACCEPT.FIELDS.COUNTRY": "País",
    "INVITATIONS.ACCEPT.FIELDS.CURRENCY": "Divisa",
    "INVITATIONS.ACCEPT.FIELDS.DIAMETER": "Diámetro",
    "INVITATIONS.ACCEPT.FIELDS.FIRST_NAME": "Nombre de pila",
    "INVITATIONS.ACCEPT.FIELDS.FLOW_RATE": "Caudal",
    "INVITATIONS.ACCEPT.FIELDS.LAST_NAME": "Apellido",
    "INVITATIONS.ACCEPT.FIELDS.LEGAL_CHECKBOX_ARIA": "Acepte la política de privacidad y los términos y condiciones.",
    "INVITATIONS.ACCEPT.FIELDS.LEGAL_CHECKBOX_CONJUNCTION": "y",
    "INVITATIONS.ACCEPT.FIELDS.LEGAL_CHECKBOX_PREFIX": "Acepto el",
    "INVITATIONS.ACCEPT.FIELDS.LONG_DISTANCE": "Larga distancia",
    "INVITATIONS.ACCEPT.FIELDS.MEASUREMENT_SYSTEM": "Sistema de medición",
    "INVITATIONS.ACCEPT.FIELDS.PASSWORD": "Contraseña",
    "INVITATIONS.ACCEPT.FIELDS.PHONE": "Teléfono",
    "INVITATIONS.ACCEPT.FIELDS.SELECT_PLACEHOLDER": "Seleccionar",
    "INVITATIONS.ACCEPT.FIELDS.SHORT_DISTANCE": "Corto alcance",
    "INVITATIONS.ACCEPT.FIELDS.VOLUME": "Volumen",
    "INVITATIONS.ACCEPT.FIELDS.WEIGHT": "Peso",
    "INVITATIONS.ACCEPT.FORM_ARIA_LABEL": "Aceptar invitación",
    "INVITATIONS.ACCEPT.LINKS.PRIVACY_POLICY": "Política de privacidad",
    "INVITATIONS.ACCEPT.LINKS.TERMS_AND_CONDITIONS": "Términos y condiciones",
    "INVITATIONS.ACCEPT.LOADING": "Cargando invitación",
    "INVITATIONS.ACCEPT.SUBMIT": "Crear una cuenta",
    "INVITATIONS.ACCEPT.SUBMITTING": "Aceptando la invitación…",
    "INVITATIONS.ACCEPT.SUCCESS.DESCRIPTION": "Tu cuenta está lista. Inicia sesión para continuar.",
    "INVITATIONS.ACCEPT.SUCCESS.SIGN_IN_CTA": "Iniciar sesión",
    "INVITATIONS.ACCEPT.SUCCESS.TITLE": "Tu cuenta está lista",
    "INVITATIONS.ACCEPT.TITLE": "Aceptar invitación",
    "INVITATIONS.ACTION.CANCEL": "Cancelar",
    "INVITATIONS.ACTION.SUBMIT": "Enviar invitación",
    "INVITATIONS.DIALOG.DESCRIPTION": "Invita a un usuario por correo electrónico. Aparecerá en la lista de usuarios después de aceptar la invitación.",
    "INVITATIONS.DIALOG.TITLE": "Invitar usuario",
    "INVITATIONS.SUCCESS.SENT": "Invitación enviada. El usuario aparecerá en la lista de usuarios después de aceptar la invitación.",
    "INVITATIONS.VALIDATION.DIAMETER": "Se requiere una unidad de diámetro.",
    "INVITATIONS.VALIDATION.FLOW_RATE": "Se requiere una unidad de caudal.",
    "INVITATIONS.VALIDATION.GENERIC": "Se produjo un problema al invitar a este usuario. Por favor, revise la información e inténtelo de nuevo.",
    "INVITATIONS.VALIDATION.LEGAL_ACCEPTANCE": "Se deben aceptar la política de privacidad y los términos.",
    "INVITATIONS.VALIDATION.LONG_DISTANCE": "Se requiere una unidad de larga distancia.",
    "INVITATIONS.VALIDATION.PASSWORD_COMPLEXITY": "La contraseña debe contener al menos tres de los siguientes caracteres: minúscula, mayúscula, numérico y especial.",
    "INVITATIONS.VALIDATION.PASSWORD_MAX": "La contraseña debe tener como máximo 64 caracteres.",
    "INVITATIONS.VALIDATION.SHORT_DISTANCE": "Se requiere una unidad de corta distancia.",
    "INVITATIONS.VALIDATION.VOLUME": "Se requiere una unidad de volumen.",
    "INVITATIONS.VALIDATION.WEIGHT": "Se requiere una unidad de peso.",
    "JOB_DETAILS.ADDRESS": "Dirección de la fuga",
    "JOB_DETAILS.AI_LEAK": "IA predijo el tamaño de la fuga",
    "JOB_DETAILS.BACK_BUTTON": "Regresa a Waypoint",
    "JOB_DETAILS.CANCEL": "Cancelar",
    "JOB_DETAILS.COMMENTS": "Notas",
    "JOB_DETAILS.DATE_INFO_TITLE": "Información de la Fecha",
    "JOB_DETAILS.DATE_SECTION.CREATED": "Fecha de Creación",
    "JOB_DETAILS.DATE_SECTION.REPAIR": "Fecha de Reparación",
    "JOB_DETAILS.DATE_SECTION.TITLE": "Fechas Horas",
    "JOB_DETAILS.DATE_SECTION.UPDATED": "Fecha Actualizada",
    "JOB_DETAILS.DMA": "Referencia DMA",
    "JOB_DETAILS.EDIT": "Editar detalles del trabajo",
    "JOB_DETAILS.ENGINEER": "Ingeniero Asignado",
    "JOB_DETAILS.ENVIRONMENTAL_NOTE": "Nota Ambiental",
    "JOB_DETAILS.ERROR": "Error al actualizar el trabajo",
    "JOB_DETAILS.FLOW": "Reducción de Flujo",
    "JOB_DETAILS.FLOW_REDUCTION": "Reducción de Flujo Acordada",
    "JOB_DETAILS.ID": "ID de trabajo",
    "JOB_DETAILS.JOB_IMAGES_TITLE": "Imágenes de trabajo",
    "JOB_DETAILS.JOB_INFO_TITLE": "Información del trabajo",
    "JOB_DETAILS.LEAK": "Estimación del Tamaño de la Fuga del Cliente",
    "JOB_DETAILS.LEAK_SIZE": "Tamaño estimado de la fuga",
    "JOB_DETAILS.LEAK_TYPE": "Estimación del Tipo de Fuga en el Sitio",
    "JOB_DETAILS.LOCATION_INFO_TITLE": "Información de Ubicación",
    "JOB_DETAILS.MATERIAL": "Material de tubería",
    "JOB_DETAILS.NO_IMAGES": "No hay imágenes",
    "JOB_DETAILS.NO_JOB": "Trabajo no encontrado con identificación",
    "JOB_DETAILS.NOMINAL": "Estimación del Tamaño de la Fuga del Cliente/ Volumen Nominal",
    "JOB_DETAILS.NOTES": "Notas Ambientales",
    "JOB_DETAILS.PROJECT": "Proyecto",
    "JOB_DETAILS.ROAD_SPEED": "Velocidad de la Carretera",
    "JOB_DETAILS.SAVE": "Guardar",
    "JOB_DETAILS.SIZE": "Tamaño de la tubería",
    "JOB_DETAILS.STATUS": "Estado del trabajo",
    "JOB_DETAILS.SURFACE": "Tipo de superficie",
    "JOB_DETAILS.TITLE": "Detalles del Trabajo",
    "JOB_DETAILS.TYPE": "Tipo de trabajo",
    "JOB_DETAILS.W3W": "What3Words",
    "JOB_DETAILS.WAYPOINT": "ID del punto de referencia",
    "JOB_DETAILS.WAYPOINT_STATUS": "Estado del Punto de Referencia",
    "JOB_DETAILS.WORK_ORDER": "Referencia de la Orden de Trabajo del Cliente/Utilidad",
    "LANGUAGE.ENGLISH": "Inglés",
    "LANGUAGE.FRENCH": "Francés",
    "LANGUAGE.ITALIAN": "italiano",
    "LANGUAGE.POLISH": "Polaco",
    "LANGUAGE.SPANISH": "Español",
    "LIST_VIEW.CONSUMPTION_PROFILE": "Perfiles de consumo",
    "LIST_VIEW.CONSUMPTION_PROFILE.DATE_FROM": "Fecha desde",
    "LIST_VIEW.CONSUMPTION_PROFILE.DATE_TO": "Fecha hasta",
    "LIST_VIEW.CONSUMPTION_PROFILE.DATE_TYPE": "Tipo de fecha",
    "LIST_VIEW.CONSUMPTION_PROFILE.DISTINCT.awaiting_upload": "Esperando carga",
    "LIST_VIEW.CONSUMPTION_PROFILE.DISTINCT.completed": "Terminado",
    "LIST_VIEW.CONSUMPTION_PROFILE.DISTINCT.deleted": "Eliminado",
    "LIST_VIEW.CONSUMPTION_PROFILE.DISTINCT.in_progress": "En curso",
    "LIST_VIEW.CONSUMPTION_PROFILE.EDIT_VIEW.BUTTON_LABEL": "Personalizar vista",
    "LIST_VIEW.CONSUMPTION_PROFILE.EDIT_VIEW.DESCRIPTION": "Arrastre los encabezados de las columnas para reorganizar el orden, marque o desmarque para mostrar u ocultar las columnas de la tabla.",
    "LIST_VIEW.CONSUMPTION_PROFILE.EDIT_VIEW.RESET_BUTTON_LABEL": "Restablecer la vista predeterminada",
    "LIST_VIEW.CONSUMPTION_PROFILE.FILTER_SECTION": "Filtrar",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.address": "DIRECCIÓN",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.collected_by": "Recopilado por",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.company": "Compañía",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.deployed_by": "Desplegado por",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.dma_key": "DMA",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.end_date": "Fecha de finalización",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.end_time": "Fin del tiempo",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.id": "IDENTIFICACIÓN",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.latitude": "Latitud",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.longitude": "Longitud",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.partner": "Pareja",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.project": "Proyecto",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.start_date": "Fecha de inicio",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.start_time": "Hora de inicio",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.waypoint_id": "ID de punto de referencia",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.waypoint_name": "Nombre del punto de referencia",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.what3words": "Qué3Palabras",
    "LIST_VIEW.CONSUMPTION_PROFILE.NO_DATA": "No hay datos disponibles",
    "LIST_VIEW.CONSUMPTION_PROFILE.SEARCH_BAR.APPLY.FILTER": "Aplicar filtros",
    "LIST_VIEW.CONSUMPTION_PROFILE.SEARCH_BAR.RESET": "Restablecer todos los filtros",
    "LIST_VIEW.CONSUMPTION_PROFILE.SEARCH.PLACEHOLDER": "Buscar...",
    "LIST_VIEW.CONSUMPTION_PROFILE.TITLE": "Explorar todos los perfiles de consumo",
    "LIST_VIEW.JOBS": "Empleos",
    "LIST_VIEW.JOBS.HEADERS.address": "DIRECCIÓN",
    "LIST_VIEW.JOBS.HEADERS.agreed_flow_reduction": "Reducción de Flujo Acordada",
    "LIST_VIEW.JOBS.HEADERS.branch_id": "Proyecto",
    "LIST_VIEW.JOBS.HEADERS.client_leak_size_estimate": "Estimación del Tamaño de Fuga del Cliente",
    "LIST_VIEW.JOBS.HEADERS.comment": "Comentario",
    "LIST_VIEW.JOBS.HEADERS.created_at": "Creado",
    "LIST_VIEW.JOBS.HEADERS.date_raised_externally": "Fecha planteada externamente",
    "LIST_VIEW.JOBS.HEADERS.date_raised_internally": "Fecha Elevada Internamente",
    "LIST_VIEW.JOBS.HEADERS.dma_key": "DMA",
    "LIST_VIEW.JOBS.HEADERS.environmental_notes": "Notas Ambientales",
    "LIST_VIEW.JOBS.HEADERS.estimate_leak_size": "Tamaño Estimado de la Fuga",
    "LIST_VIEW.JOBS.HEADERS.id": "ID",
    "LIST_VIEW.JOBS.HEADERS.job_status": "Estado del trabajo",
    "LIST_VIEW.JOBS.HEADERS.last_scheduled_engineer_id": "Ingeniero",
    "LIST_VIEW.JOBS.HEADERS.leak_type": "Código de trabajo",
    "LIST_VIEW.JOBS.HEADERS.material": "Material",
    "LIST_VIEW.JOBS.HEADERS.pipe_diameter": "Tamaño de la tubería",
    "LIST_VIEW.JOBS.HEADERS.pipe_diameter_unit": "Unidad de tamaño de tubería",
    "LIST_VIEW.JOBS.HEADERS.repair_date": "Fecha de reparación",
    "LIST_VIEW.JOBS.HEADERS.road_speed": "Velocidad de la carretera",
    "LIST_VIEW.JOBS.HEADERS.updated_at": "Actualizado",
    "LIST_VIEW.JOBS.HEADERS.waypoint_id": "Punto de referencia",
    "LIST_VIEW.JOBS.HEADERS.work_order": "Orden de trabajo",
    "LIST_VIEW.JOBS.SUMMARY.JOB_TYPE": "Tipo de trabajo",
    "LIST_VIEW.JOBS.SUMMARY.SESSION_TYPE": "Tipo de sesión",
    "LIST_VIEW.JOBS.TITLE": "Explorar todos los trabajos",
    "LIST_VIEW.RELAYS": "Dispositivos de retransmisión",
    "LIST_VIEW.RELAYS.HEADERS.address": "DIRECCIÓN",
    "LIST_VIEW.RELAYS.HEADERS.bug_id": "Dirección MAC",
    "LIST_VIEW.RELAYS.HEADERS.bug_mac": "Dirección MAC",
    "LIST_VIEW.RELAYS.HEADERS.company": "Compañía",
    "LIST_VIEW.RELAYS.HEADERS.company_name": "Empresa",
    "LIST_VIEW.RELAYS.HEADERS.create_time": "Hora de creación",
    "LIST_VIEW.RELAYS.HEADERS.dma_name": "DMA",
    "LIST_VIEW.RELAYS.HEADERS.last_contact": "Último contacto",
    "LIST_VIEW.RELAYS.HEADERS.last_update": "Última carga",
    "LIST_VIEW.RELAYS.HEADERS.latitude": "Latitud",
    "LIST_VIEW.RELAYS.HEADERS.longitude": "Longitud",
    "LIST_VIEW.RELAYS.HEADERS.partner": "Socio",
    "LIST_VIEW.RELAYS.HEADERS.partner_name": "Socio",
    "LIST_VIEW.RELAYS.HEADERS.project": "Proyecto",
    "LIST_VIEW.RELAYS.HEADERS.project_name": "Proyecto",
    "LIST_VIEW.RELAYS.HEADERS.relay_id": "ID de retransmisión",
    "LIST_VIEW.RELAYS.HEADERS.relay_name": "Nombre del relé",
    "LIST_VIEW.RELAYS.HEADERS.relay_status": "Estado del relé",
    "LIST_VIEW.RELAYS.HEADERS.relay_uptime": "Tiempo de actividad del relé",
    "LIST_VIEW.RELAYS.HEADERS.session_id": "Sesión",
    "LIST_VIEW.RELAYS.HEADERS.session_leak_size": "Tamaño previsto de la sesión por IA",
    "LIST_VIEW.RELAYS.HEADERS.update_time": "Hora de actualización",
    "LIST_VIEW.RELAYS.HEADERS.what3words": "Qué3Palabras",
    "LIST_VIEW.RELAYS.TITLE": "Explorar todos los dispositivos de Relay",
    "LIST_VIEW.SELECT_DATA_TYPE.LABEL": "Tipo de datos",
    "LIST_VIEW.SELECT_DATA_TYPE.PLACEHOLDER": "Seleccionar el tipo de datos",
    "LIST_VIEW.SESSIONS": "Sesiones",
    "LIST_VIEW.SESSIONS.DATE_FROM": "Fecha Desde",
    "LIST_VIEW.SESSIONS.DATE_TO": "Fecha Hasta",
    "LIST_VIEW.SESSIONS.DATE_TYPE": "Tipo de Fecha",
    "LIST_VIEW.SESSIONS.DISTINCT.awaiting_upload": "Esperando la carga",
    "LIST_VIEW.SESSIONS.DISTINCT.completed": "Completado",
    "LIST_VIEW.SESSIONS.DISTINCT.deleted": "Eliminado",
    "LIST_VIEW.SESSIONS.DISTINCT.in_progress": "En progreso",
    "LIST_VIEW.SESSIONS.EDIT_VIEW.BUTTON_LABEL": "Personalizar vista",
    "LIST_VIEW.SESSIONS.EDIT_VIEW.DESCRIPTION": "Arrastra los encabezados de las columnas para reorganizar el orden, marca/desmarca para mostrar/ocultar las columnas de la tabla.",
    "LIST_VIEW.SESSIONS.EDIT_VIEW.RESET_BUTTON_LABEL": "Restablecer a la vista predeterminada",
    "LIST_VIEW.SESSIONS.FILTER_SECTION": "Filtro",
    "LIST_VIEW.SESSIONS.HEADERS.address": "DIRECCIÓN",
    "LIST_VIEW.SESSIONS.HEADERS.asset_id": "Activo",
    "LIST_VIEW.SESSIONS.HEADERS.collected_by": "Recogido por",
    "LIST_VIEW.SESSIONS.HEADERS.company_id": "Empresa",
    "LIST_VIEW.SESSIONS.HEADERS.created": "Fecha de creación",
    "LIST_VIEW.SESSIONS.HEADERS.deployed_by": "Desplegado por",
    "LIST_VIEW.SESSIONS.HEADERS.dma_id": "DMA",
    "LIST_VIEW.SESSIONS.HEADERS.end_time": "Fecha de finalización",
    "LIST_VIEW.SESSIONS.HEADERS.expected_finish": "Finalización Esperada",
    "LIST_VIEW.SESSIONS.HEADERS.last_update": "Última actualización",
    "LIST_VIEW.SESSIONS.HEADERS.latitude": "Latitud",
    "LIST_VIEW.SESSIONS.HEADERS.leak_size": "Tamaño Predicho",
    "LIST_VIEW.SESSIONS.HEADERS.longitude": "Longitud",
    "LIST_VIEW.SESSIONS.HEADERS.partner_id": "Socio",
    "LIST_VIEW.SESSIONS.HEADERS.project_id": "Proyecto",
    "LIST_VIEW.SESSIONS.HEADERS.relay_connected": "Relé Conectado",
    "LIST_VIEW.SESSIONS.HEADERS.sensor-id": "ID del sensor",
    "LIST_VIEW.SESSIONS.HEADERS.session_id": "ID de sesión",
    "LIST_VIEW.SESSIONS.HEADERS.start_time": "Fecha de inicio",
    "LIST_VIEW.SESSIONS.HEADERS.status_id": "Estado",
    "LIST_VIEW.SESSIONS.HEADERS.type": "Tipo de sesión",
    "LIST_VIEW.SESSIONS.HEADERS.what3words": "W3W",
    "LIST_VIEW.SESSIONS.NO_DATA": "No hay datos disponibles",
    "LIST_VIEW.SESSIONS.SEARCH_BAR.APPLY.FILTER": "Aplicar filtros",
    "LIST_VIEW.SESSIONS.SEARCH_BAR.RESET": "Restablecer todos los filtros",
    "LIST_VIEW.SESSIONS.SEARCH.PLACEHOLDER": "Buscar...",
    "LIST_VIEW.SESSIONS.SUMMARY.LEAK_SIZE": "Tamaño de la fuga",
    "LIST_VIEW.SESSIONS.SUMMARY.SESSION_TYPE": "Tipo de sesión",
    "LIST_VIEW.SESSIONS.SUMMARY.TITLE": "Resumen",
    "LIST_VIEW.SESSIONS.SUMMARY.TOOLTIP.DESC": "Para ajustar los datos mostrados aquí, use los filtros de la tabla de arriba.",
    "LIST_VIEW.SESSIONS.SUMMARY.TOOLTIP.TITLE": "Resumen de los datos resultantes",
    "LIST_VIEW.SESSIONS.SUMMARY.WAYPOINT_STATUS": "Estado del Punto de Referencia",
    "LIST_VIEW.SESSIONS.TITLE": "Explorar todas las sesiones",
    "LIST_VIEW.WAYPOINT_LOGS": "Registros de Puntos de Referencia",
    "LIST_VIEW.WAYPOINT_LOGS.HEADERS.changed_from_status_name": "Estado anterior",
    "LIST_VIEW.WAYPOINT_LOGS.HEADERS.changed_to_status_name": "Estado actual",
    "LIST_VIEW.WAYPOINT_LOGS.HEADERS.company": "Empresa",
    "LIST_VIEW.WAYPOINT_LOGS.HEADERS.datetime": "Fecha de actualización",
    "LIST_VIEW.WAYPOINT_LOGS.HEADERS.dma_key": "DMA",
    "LIST_VIEW.WAYPOINT_LOGS.HEADERS.id": "ID",
    "LIST_VIEW.WAYPOINT_LOGS.HEADERS.notes": "Notas",
    "LIST_VIEW.WAYPOINT_LOGS.HEADERS.partner": "Socio",
    "LIST_VIEW.WAYPOINT_LOGS.HEADERS.project": "Proyecto",
    "LIST_VIEW.WAYPOINT_LOGS.HEADERS.user_name": "Nombre de usuario",
    "LIST_VIEW.WAYPOINT_LOGS.HEADERS.waypoint_id": "Punto de referencia",
    "LIST_VIEW.WAYPOINT_LOGS.TITLE": "Explorar todos los registros de Waypoint",
    "LIST_VIEW.WAYPOINTS": "Puntos de referencia",
    "LIST_VIEW.WAYPOINTS.HEADERS.address": "DIRECCIÓN",
    "LIST_VIEW.WAYPOINTS.HEADERS.agreed_flow_reduction": "Reducción de flujo acordada",
    "LIST_VIEW.WAYPOINTS.HEADERS.branch_name": "Proyecto",
    "LIST_VIEW.WAYPOINTS.HEADERS.comment": "Comentario",
    "LIST_VIEW.WAYPOINTS.HEADERS.company_id": "Empresa",
    "LIST_VIEW.WAYPOINTS.HEADERS.created_at": "Creado En",
    "LIST_VIEW.WAYPOINTS.HEADERS.date_time": "Fecha de actualización",
    "LIST_VIEW.WAYPOINTS.HEADERS.diameter": "Diámetro",
    "LIST_VIEW.WAYPOINTS.HEADERS.diameter_unit": "Unidad de diámetro",
    "LIST_VIEW.WAYPOINTS.HEADERS.dma_key": "DMA",
    "LIST_VIEW.WAYPOINTS.HEADERS.environmental_notes": "Notas ambientales",
    "LIST_VIEW.WAYPOINTS.HEADERS.estimated_size": "Tamaño estimado",
    "LIST_VIEW.WAYPOINTS.HEADERS.job_type_code": "Código de tipo de trabajo",
    "LIST_VIEW.WAYPOINTS.HEADERS.jobs": "Empleos",
    "LIST_VIEW.WAYPOINTS.HEADERS.last_action_by": "Última acción de",
    "LIST_VIEW.WAYPOINTS.HEADERS.last_scheduled_engineer_id": "Último ingeniero programado",
    "LIST_VIEW.WAYPOINTS.HEADERS.latitude": "Latitud",
    "LIST_VIEW.WAYPOINTS.HEADERS.longitude": "Longitud",
    "LIST_VIEW.WAYPOINTS.HEADERS.material": "Material",
    "LIST_VIEW.WAYPOINTS.HEADERS.name": "Nombre",
    "LIST_VIEW.WAYPOINTS.HEADERS.partner_id": "Socio",
    "LIST_VIEW.WAYPOINTS.HEADERS.predicted_leak_type_id": "Tipo de fuga predicha",
    "LIST_VIEW.WAYPOINTS.HEADERS.predicted_size": "Tamaño Predicho",
    "LIST_VIEW.WAYPOINTS.HEADERS.sessions": "Sesiones",
    "LIST_VIEW.WAYPOINTS.HEADERS.status_id": "Estado",
    "LIST_VIEW.WAYPOINTS.HEADERS.surface_type": "Tipo de superficie",
    "LIST_VIEW.WAYPOINTS.HEADERS.w3w": "What3Words",
    "LIST_VIEW.WAYPOINTS.TITLE": "Explorar todos los puntos de referencia",
    "LOGIN_PAGE.ENTRA_TITLE": "Iniciar sesión en el portal",
    "LOGIN_PAGE.ERROR.MSG": "Correo electrónico o contraseña incorrectos",
    "LOGIN_PAGE.FORGOT_PASSWORD": "¿Has olvidado tu contraseña?",
    "LOGIN_PAGE.FORM.EMAIL.LABEL": "Correo electrónico",
    "LOGIN_PAGE.FORM.EMAIL.PLACEHOLDER": "Introduce tu correo electrónico",
    "LOGIN_PAGE.FORM.OKTA_SUBMIT": "Iniciar sesión con Okta",
    "LOGIN_PAGE.FORM.PASSWORD.LABEL": "Contraseña",
    "LOGIN_PAGE.FORM.PASSWORD.PLACEHOLDER": "Ingresa tu contraseña",
    "LOGIN_PAGE.FORM.SUBMIT": "Iniciar sesión",
    "LOGIN_PAGE.SIGNING_IN": "Registrandote…",
    "LOGIN_PAGE.SIGNING_IN_SUBTITLE": "Si no es redirigido automáticamente en unos segundos, actualice la página.",
    "LOGIN_PAGE.SUBTITLE": "Ingrese su correo electrónico y contraseña a continuación",
    "LOGIN_PAGE.TITLE": "Iniciar sesión en el panel de administración",
    "LOGS.ACTION.ASSIGN_DMAs": "Asignar DMA",
    "LOGS.ACTION.CHANGE DATES": "Cambiar fechas",
    "LOGS.ACTION.Change project 1 dates": "Cambiar las fechas del Proyecto 1",
    "LOGS.ACTION.CHANGE_DATES": "Cambiar fechas",
    "LOGS.ACTION.CHANGE_PASSWORD": "Cambiar la contraseña",
    "LOGS.ACTION.CREATE PROJECT": "Crear proyecto",
    "LOGS.ACTION.CREATE_BRANCH": "Crear rama",
    "LOGS.ACTION.CREATE_COMPANY": "Crear empresa",
    "LOGS.ACTION.CREATE_MULTI_USER": "Crear múltiples usuarios",
    "LOGS.ACTION.CREATE_PARTNER": "Crear socio",
    "LOGS.ACTION.CREATE_PROJECT": "Crear proyecto",
    "LOGS.ACTION.CREATE_USER": "Crear usuario",
    "LOGS.ACTION.DELETE_BRANCH": "Eliminar rama",
    "LOGS.ACTION.DELETE_COMPANY": "Eliminar empresa",
    "LOGS.ACTION.DELETE_DMAs": "Eliminar DMA",
    "LOGS.ACTION.DELETE_PARTNER": "Eliminar socio",
    "LOGS.ACTION.DELETE_PROJECT": "Eliminar proyecto",
    "LOGS.ACTION.DELETE_USER": "Eliminar usuario",
    "LOGS.ACTION.EDIT_COMPANY": "Editar empresa",
    "LOGS.ACTION.FORGOT_PASSWORD": "Has olvidado tu contraseña",
    "LOGS.ACTION.GET_COMPANY": "Conseguir empresa",
    "LOGS.ACTION.LOGIN": "Acceso",
    "LOGS.ACTION.MODIFY_COMPANY": "Modificar empresa",
    "LOGS.ACTION.MODIFY_PARTNER": "Modificar socio",
    "LOGS.ACTION.MODIFY_USER": "Modificar usuario",
    "LOGS.ACTION.REACTIVATE_COMPANY": "Reactivar la empresa",
    "LOGS.ACTION.REACTIVATE_PARTNER": "Reactivar socio",
    "LOGS.ACTION.RESTORE_COMPANY": "Restaurar empresa",
    "LOGS.ACTION.SET_PASSWORD": "Establecer contraseña",
    "LOGS.ACTION.TOGGLE OFF RELAY DEVICE": "Desactivar dispositivo de relé",
    "LOGS.ACTION.TRIGGER RELAY DEVICE": "Dispositivo de relé de activación",
    "LOGS.ACTION.UPDATE WAYPOINT": "Actualizar punto de referencia",
    "LOGS.ACTION.UPDATE_BRANCH": "Actualizar rama",
    "LOGS.ACTION.UPDATE_LOGGER_SESSION": "Actualizar sesión del registrador",
    "LOGS.DESCRIPTION.ASSIGN_DMAs": "DMA asignados {{dma_keys}} a {{project_name}}",
    "LOGS.DESCRIPTION.CHANGE_DATES": "Fechas modificadas para {{project_name}}. Fecha de inicio: {{start_date}}. Fecha de finalización: {{end_date}}",
    "LOGS.DESCRIPTION.COMMON.BY_USER_EMAIL": "por {{by_email}}",
    "LOGS.DESCRIPTION.CREATE_BRANCH": "Proyecto creado {{project_name}}",
    "LOGS.DESCRIPTION.CREATE_COMPANY": "Empresa creada {{company_name}}",
    "LOGS.DESCRIPTION.CREATE_PROJECT": "Proyecto creado {{project_name}}",
    "LOGS.DESCRIPTION.CREATE_USER": "Usuario creado {{user_name}} : {{user_email}}",
    "LOGS.DESCRIPTION.DELETE_PROJECT": "Proyecto eliminado {{project_name}}",
    "LOGS.DESCRIPTION.DELETE_USER": "Usuario eliminado {{user_name}} : {{user_email}}",
    "LOGS.DESCRIPTION.MODIFY_COMPANY": "Empresa modificada {{company_name}}",
    "LOGS.DESCRIPTION.MODIFY_PARTNER": "Socio modificado {{partner_name}}",
    "LOGS.DESCRIPTION.MODIFY_USER": "Usuario modificado {{user_name}} : {{user_email}}",
    "LOGS.DESCRIPTION.UPDATE_LOGGER_SESSION": "Sesión de registrador actualizada {{session_id}}",
    "MAP_UNITS.TITLE.COLUMN": "Columna de mapa",
    "MAP_UNITS.TITLE.UNITS": "Valores de unidad de mapa",
    "MAP_VIEW.DIALOG.SUBTITLE.CHANGE": "¿Se eliminarán todos los filtros?",
    "MAP_VIEW.DIALOG.SUBTITLE.CLOSE": "¿Se eliminarán los cambios?",
    "MAP_VIEW.DIALOG.TITLE.CHANGE": "¿Está seguro de que desea cambiar la fuente de datos?",
    "MAP_VIEW.DIALOG.TITLE.CLOSE": "¿Seguro que quieres cerrar la configuración?",
    "MAP_VIEW.FILTERS.BUTTONTITLE": "Opciones de mapa",
    "MAP_VIEW.FILTERS.SUBMIT": "Entregar",
    "MAP_VIEW.FILTERS.TITLES.ASSETS": "Activos",
    "MAP_VIEW.FILTERS.TITLES.AWAITING_UPLOAD_SESSION": "Esperando la sesión de carga",
    "MAP_VIEW.FILTERS.TITLES.DELETED_SESSION": "Sesión Eliminada",
    "MAP_VIEW.FILTERS.TITLES.DMAS": "DMA",
    "MAP_VIEW.FILTERS.TITLES.IN_PROGRESS_SESSION": "Sesión en Progreso",
    "MAP_VIEW.FILTERS.TITLES.INVESTIGATION_SESSION": "Sesión de investigación",
    "MAP_VIEW.FILTERS.TITLES.LARGE_LEAK_SESSION": "Sesión de Fuga Grande",
    "MAP_VIEW.FILTERS.TITLES.MEDIUM_LEAK_SESSION": "Sesión de fuga media",
    "MAP_VIEW.FILTERS.TITLES.NON_LEAK_SESSION": "Sesión Sin Fugas",
    "MAP_VIEW.FILTERS.TITLES.ODL": "ODL",
    "MAP_VIEW.FILTERS.TITLES.PIPES": "Tubería",
    "MAP_VIEW.FILTERS.TITLES.SMALL_LEAK_SESSION": "Sesión de pequeña fuga",
    "MAP_VIEW.FILTERS.TITLES.WAYPOINTS": "Puntos de ruta",
    "MAP_VIEW.FORM.SOURCE.LABEL": "Fuente de datos",
    "MAP_VIEW.FORM.SOURCE.PLACEHOLDER": "Seleccionar fuente de datos",
    "MAP_VIEW.LOADING": "Cargando mapa",
    "MAP_VIEW.MODAL_TITLE": "Ajustes",
    "MAP.HUD.FETCH_BOUNDARIES": "Límites de búsqueda",
    "MAP.HUD.LAT": "Latitud:",
    "MAP.HUD.LNG": "Largo:",
    "MAP.HUD.SOURCES": "Fuentes:",
    "MAP.HUD.TOGGLE_FETCH_BOUNDARY_VISUALIZATION": "Activar o desactivar la visualización del límite de búsqueda",
    "MAP.HUD.ZOOM_IN_TO_LOAD": "Acercar para cargar",
    "MAP.STYLE.SATELLITE": "Vista satelital",
    "MAP.STYLE.STREET": "Vista de la calle",
    "MEASUREMENT_TYPE.IMPERIAL": "Imperial",
    "MEASUREMENT_TYPE.METRIC": "Métrico",
    "MERGE_WAYPOINT.FORM.SUBMIT": "Enviar",
    "MERGE_WAYPOINT.FORM.SUCCESS": "Puntos de referencia fusionados con éxito",
    "MERGE_WAYPOINT.INPUT.MERGE_DROPDOWN.LABEL": "Fusionar el punto de referencia seleccionado con el punto de referencia actual",
    "MERGE_WAYPOINT.INPUT.MERGE_DROPDOWN.LABEL_SHORT": "Punto de referencia",
    "MERGE_WAYPOINT.INPUT.MERGE_DROPDOWN.PLACEHOLDER": "Seleccione un Punto de Referencia",
    "MERGE_WAYPOINT.INPUT.NOTES.LABEL": "Notas",
    "MERGE_WAYPOINT.INPUT.NOTES.PLACEHOLDER": "Ingrese Notas",
    "MERGE_WAYPOINT.NO_DATA": "No hay puntos de referencia disponibles para fusionar",
    "METRIC_WIDGET.DESCRIPTION": "por día",
    "METRIC_WIDGET.TITLE_A": "IA Identificado",
    "METRIC_WIDGET.TITLE_B": "Para Reparación",
    "METRIC_WIDGET.TITLE_C": "Entregado",
    "NOT_FOUND_PAGE.ACTION.GO_HOME": "Llévame a casa",
    "NOT_FOUND_PAGE.DESCRIPTION": "¡Uy! Parece que la página que buscas se ha perdido en el vacío digital. No te preocupes, nos pasa a todos.",
    "NOT_FOUND_PAGE.TITLE": "Página no encontrada",
    "PIE_CHART.SUMMARY_DETAILS": "Detalles del Resumen",
    "PIE_CHART.SUMMARY_TOTAL": "Total de resultados",
    "PROCESS_FILES.BUTTON.DISCARD": "Descartar",
    "PROCESS_FILES.BUTTON.NEXT": "Siguiente",
    "PROCESS_FILES.BUTTON.PREVIOUS": "Anterior",
    "PROCESS_FILES.BUTTON.RESET": "Restablecer",
    "PROCESS_FILES.COLUMNS_SELECT": "Columnas requeridas aún por seleccionar",
    "PROCESS_FILES.COLUMNS_SELECTED": "todas las columnas seleccionadas",
    "PROCESS_FILES.DESC.DIAMETER": "Por favor, seleccione: una unidad que coincida con sus valores de diámetro O una columna para asignar valores de unidad",
    "PROCESS_FILES.ERROR.INSUFFICIENT_COLUMNS": "No hay suficientes columnas para mapear los datos proporcionados. Para continuar, descarte o suba un nuevo archivo.",
    "PROCESS_FILES.ERROR.NO_FILE_TO_MAP": "No hay archivo para mapear para {{type}} por favor continúe haciendo clic en siguiente",
    "PROCESS_FILES.ERROR.SELECT_ALL": "Por favor, seleccione todas las columnas",
    "PROCESS_FILES.FILENAME": "Nombre de archivo",
    "PROCESS_FILES.INSTRUCTIONS": "Por favor, asocie las columnas a los encabezados sugeridos en los desplegables. Solo se puede asociar una columna a un encabezado.",
    "PROCESS_FILES.MAP_FIELD_TITLE": "Mapear el campo {{title}}",
    "PROCESS_FILES.OPTION_COLUMNS_SELECT": "Columnas opcionales aún por seleccionar",
    "PROCESS_FILES.OPTIONAL_COLUMNS_SELECTED": "Todas las columnas opcionales han sido seleccionadas",
    "PROCESS_FILES.TITLE.DIAMETER": "Campo de diámetro del mapa",
    "PROFILE_PAGE.BRANCH": "Proyecto:",
    "PROFILE_PAGE.COMPANY": "Compañía:",
    "PROFILE_PAGE.COMPANY_ADDRESS": "DIRECCIÓN:",
    "PROFILE_PAGE.COMPANY_NAME": "Nombre:",
    "PROFILE_PAGE.DISCARD": "Desechar",
    "PROFILE_PAGE.EDIT": "Editar",
    "PROFILE_PAGE.EMAIL": "Correo electrónico:",
    "PROFILE_PAGE.ERROR.FAILED_LOADING_USER_DATA": "Error al cargar los datos del usuario.",
    "PROFILE_PAGE.FORM.CHANGE_PASSWORD.BAD_AUTH": "Contraseña Incorrecta Ingresada",
    "PROFILE_PAGE.FORM.CHANGE_PASSWORD.ERROR": "Contraseña Actual Incorrecta",
    "PROFILE_PAGE.FORM.CHANGE_PASSWORD.LOADING": "Cargando",
    "PROFILE_PAGE.FORM.CHANGE_PASSWORD.SUBMIT": "Enviar Nueva Contraseña",
    "PROFILE_PAGE.FORM.CHANGE_PASSWORD.SUCCESS": "¡Éxito! Tu contraseña ha sido cambiada.",
    "PROFILE_PAGE.FORM.EMAIL.LABEL": "Correo electrónico",
    "PROFILE_PAGE.FORM.EMAIL.PLACEHOLDER": "Ingrese correo electrónico",
    "PROFILE_PAGE.FORM.FIRST_NAME.LABEL": "Nombre de pila",
    "PROFILE_PAGE.FORM.FIRST_NAME.PLACEHOLDER": "Ingrese el nombre",
    "PROFILE_PAGE.FORM.LAST_NAME.LABEL": "Apellido",
    "PROFILE_PAGE.FORM.LAST_NAME.PLACEHOLDER": "Introduzca el apellido",
    "PROFILE_PAGE.FORM.MEASUREMENT_TYPE.LABEL": "Tipo de Medición",
    "PROFILE_PAGE.FORM.MEASUREMENT_TYPE.PLACEHOLDER": "Seleccione un tipo de medida",
    "PROFILE_PAGE.FORM.NEW_PASSWORD.LABEL": "Nueva Contraseña",
    "PROFILE_PAGE.FORM.NEW_PASSWORD.PLACEHOLDER": "Ingrese Nueva Contraseña",
    "PROFILE_PAGE.FORM.PASSWORD.LABEL": "Contraseña",
    "PROFILE_PAGE.FORM.PASSWORD.PLACEHOLDER": "Ingrese la contraseña",
    "PROFILE_PAGE.ROLE": "Role:",
    "PROFILE_PAGE.SUBMIT": "Ahorrar",
    "PROFILE_PAGE.TABS.ACCOUNT_SETTINGS": "Configuraciones de la cuenta",
    "PROFILE_PAGE.TABS.CHANGE_PASSWORD": "Cambiar Contraseña",
    "PROFILE_PAGE.TABS.COMPANY_SETTINGS": "Configuración de la empresa",
    "PROFILE_PAGE.TABS.DOCUMENTS": "Documentos",
    "PROFILE_PAGE.TITLE": "Editar perfil",
    "PROJECT_ADMIN.TITLE": "Administrador del proyecto",
    "PROJECT_CREATE.ERROR.PROJECT_CREATION": "Algo salió mal: no se pudo crear el proyecto",
    "PROJECT_CREATE.FOOTER.CREATE_DRAFT": "Crear un borrador",
    "PROJECT_CREATE.SUCCESS.DESCRIPTION_1": "Puedes acceder a él en tu sección “Ver proyectos”.",
    "PROJECT_CREATE.SUCCESS.DESCRIPTION_2": "Antes de enviarlo para aprobación, agregue todos los detalles requeridos.",
    "PROJECT_CREATE.SUCCESS.LINK_PROJECT": "Añadir detalles",
    "PROJECT_CREATE.SUCCESS.LINK_PROJECTS": "Ver proyectos",
    "PROJECT_CREATE.SUCCESS.TITLE": "Se ha creado un borrador de proyecto.",
    "PROJECT_STATUS.INCOMPLETE_PROJECT_SETUP": "La configuración del proyecto está incompleta",
    "PROJECT_STATUS.SUMMARY.TITLES.CONFIRMEDLEAKS": "# de fugas confirmadas",
    "PROJECT_STATUS.SUMMARY.TITLES.LEAKSMARKEDUP": "# de fugas marcadas",
    "PROJECT_STATUS.SUMMARY.TITLES.SESSIONS": "# de sesiones",
    "PROJECT_STATUS.SUMMARY.TITLES.WAYPOINTS": "# de puntos de ruta",
    "PROJECT_STATUS.TITLE": "Estado del proyecto",
    "PROJECT_UPDATE.DELETE_DIALOG.BUTTON_CANCEL": "Cancelar",
    "PROJECT_UPDATE.DELETE_DIALOG.BUTTON_CONFIRM": "Confirmar eliminación de borrador",
    "PROJECT_UPDATE.DELETE_DIALOG.DESCRIPTION": "¿Estás seguro que deseas eliminar este borrador?",
    "PROJECT_UPDATE.DELETE_DIALOG.TITLE": "Eliminar borrador",
    "PROJECT_UPDATE.DELETE_DRAFT": "Eliminar borrador",
    "PROJECT_UPDATE.DELETE_PROJECT": "Eliminar proyecto",
    "PROJECT_UPDATE.ERROR.DELETE_DRAFT": "Algo salió mal: no se pudo eliminar el borrador",
    "PROJECT_UPDATE.ERROR.PROJECT_DRAFT": "Algo salió mal: no se pudo guardar el borrador",
    "PROJECT_UPDATE.ERROR.PROJECT_STATUS_UPDATE": "Algo salió mal: no se pudo actualizar el estado del proyecto",
    "PROJECT_UPDATE.ERROR.PROJECT_UPDATE": "Algo salió mal: no se pudo actualizar el proyecto",
    "PROJECT_UPDATE.FOOTER.CONTINUE": "Continuar",
    "PROJECT_UPDATE.FOOTER.DONE": "Hecho",
    "PROJECT_UPDATE.FOOTER.PREVIOUS": "Anterior",
    "PROJECT_UPDATE.FOOTER.SAVE_DRAFT": "Guardar borrador",
    "PROJECT_UPDATE.FOOTER.SUBMIT": "Entregar",
    "PROJECT_UPDATE.SUCCESS.DRAFT_DELETED": "Borrador eliminado",
    "PROJECT_UPDATE.SUCCESS.PROJECT_DRAFT": "Borrador del proyecto guardado",
    "PROJECT_UPDATE.SUCCESS.PROJECT_STATUS_UPDATE": "Estado del proyecto actualizado",
    "PROJECT_UPDATE.SUCCESS.PROJECT_UPDATE": "Proyecto actualizado",
    "PROJECT_UPDATE.TITLE_EDIT": "Editar proyecto",
    "PROJECT_UPDATE.TITLE_VIEW": "Ver proyecto",
    "PROJECT.FORM.ERROR.MAP_PREVIEW_GENERAL": "Error al cargar el mapa",
    "PROJECT.FORM.ERROR.MAP_PREVIEW_NO_GIS": "No se encontró ningún SIG.",
    "PROJECT.FORM.ERROR.ODL_LOADING": "Error al cargar ODL",
    "PROJECT.FORM.GIS_DATA.DESCRIPTION": "Cargue nuevos datos SIG o seleccione uno existente",
    "PROJECT.FORM.GIS_DATA.EXISTING_GIS_UPLOADS": "Cargas SIG existentes",
    "PROJECT.FORM.GIS_DATA.TITLE": "Datos SIG",
    "PROJECT.FORM.GIS_DATA.UPLOAD_ALTERNATIVE": "o elige uno existente",
    "PROJECT.FORM.GIS_DATA.UPLOAD_NEW_GIS": "Cargar nuevo SIG",
    "PROJECT.FORM.LABEL.COMPANY": "Compañía",
    "PROJECT.FORM.LABEL.COST_PER_DISTANCE": "Costo por distancia ($)",
    "PROJECT.FORM.LABEL.DEPLOYMENT_DENSITY": "Densidad de implementación",
    "PROJECT.FORM.LABEL.DEPLOYMENT_DENSITY_LEVEL": "Nivel {{level}}",
    "PROJECT.FORM.LABEL.DMA": "DMA",
    "PROJECT.FORM.LABEL.DMAS_LOADING": "Cargando DMAs...",
    "PROJECT.FORM.LABEL.EMPTY_GIS_PREVIEW ": "No se ha cargado ningún SIG",
    "PROJECT.FORM.LABEL.END_DATE": "Fecha de finalización",
    "PROJECT.FORM.LABEL.GIS_PREVIEW": "Vista previa del SIG",
    "PROJECT.FORM.LABEL.LEAK_RADIUS": "Radio de fuga",
    "PROJECT.FORM.LABEL.LEAK_RADIUS_DESCRIPTION": "Ajuste el radio de fuga para controlar la visibilidad del ODL en el mapa. Los cambios se aplican al soltar el control deslizante.",
    "PROJECT.FORM.LABEL.ODLS_GENERATING": "Generando ODLs...",
    "PROJECT.FORM.LABEL.PARTNER_OR_SELF_SERVE": "Socio o autoservicio",
    "PROJECT.FORM.LABEL.PROJECT_NAME": "Nombre del proyecto",
    "PROJECT.FORM.LABEL.SELF_SERVE_PROJECT": "Proyecto de autoservicio",
    "PROJECT.FORM.LABEL.START_DATE": "Fecha de inicio",
    "PROJECT.FORM.LABEL.TARGET_DISTANCE": "Distancia objetivo",
    "PROJECT.FORM.LABEL.TARGET_LEAKAGE": "Fuga de objetivo",
    "PROJECT.FORM.LABEL.WAITING_FOR_ODL": "Esperando la generación de ODL...",
    "PROJECT.FORM.OPTIONS.DEPLOYMENT_DENSITY_LEVEL_1": "Implementación dispersa: podría ser un área predominantemente metálica o un presupuesto bajo donde no necesita cubrir cada centímetro.",
    "PROJECT.FORM.OPTIONS.DEPLOYMENT_DENSITY_LEVEL_2": "Implementación estándar: esta es nuestra recomendación estándar para equilibrar el costo del proyecto y cubrir un área que es una mezcla de metal y plástico.",
    "PROJECT.FORM.OPTIONS.DEPLOYMENT_DENSITY_LEVEL_3": "Cobertura completa: esto se puede utilizar si tiene una red de plástico muy compleja con muchas uniones para garantizar una cobertura completa garantizada, con un alto consumo de sensores.",
    "PROJECT.FORM.OPTIONS.NO_MATCHING": "No hay DMA coincidentes",
    "PROJECT.FORM.PLACEHOLDER.DMA": "Seleccionar DMA",
    "PROJECT.FORM.PLACEHOLDER.END_DATE": "Elige una fecha",
    "PROJECT.FORM.PLACEHOLDER.START_DATE": "Elige una fecha",
    "PROJECT.REJECT_DIALOG.BUTTON_REJECT.DEFINITELY": "Rechazar el proyecto definitivamente",
    "PROJECT.REJECT_DIALOG.BUTTON_REJECT.WITH_NOTES": "Rechazar proyecto con notas",
    "PROJECT.REJECT_DIALOG.DEFINITELY.DESCRIPTION": "Esta acción eliminará el proyecto.",
    "PROJECT.REJECT_DIALOG.DEFINITELY.TITLE": "Rechazar el proyecto definitivamente",
    "PROJECT.REJECT_DIALOG.FORM.NOTES.LABEL": "Notas",
    "PROJECT.REJECT_DIALOG.FORM.NOTES.PLACEHOLDER": "Añade tus notas",
    "PROJECT.REJECT_DIALOG.OR": "o",
    "PROJECT.REJECT_DIALOG.WITH_NOTES.DESCRIPTION": "El proyecto se devolverá al usuario que lo envió. Podrá editarlo y volver a enviarlo, o bien eliminarlo.",
    "PROJECT.REJECT_DIALOG.WITH_NOTES.TITLE": "Rechazar el proyecto con notas",
    "PROJECT.TOAST.DMA.ERROR": "Error al cargar datos DMA.",
    "PROJECT.TOAST.DMA.LOADING": "Cargando datos DMA...",
    "PROJECT.TOAST.DMA.SUCCESS": "Datos DMA cargados exitosamente.",
    "PROJECT.TOAST.ODL.ERROR": "Error al generar ODL.",
    "PROJECT.TOAST.ODL.LOADING": "Generando ODLs...",
    "PROJECT.TOAST.ODL.PENDING": "Pendiente generación de ODL...",
    "PROJECT.TOAST.ODL.SUCCESS": "ODL generados exitosamente.",
    "PROJECT.VIEW_REJECTION_NOTES.BUTTON_CLOSE": "Entiendo",
    "PROJECT.VIEW_REJECTION_NOTES.FORM.LABEL.NOTES": "Notas del administrador",
    "PROJECT.VIEW_REJECTION_NOTES.FORM.PLACEHOLDER.NOTES": "Notas dejadas por el administrador",
    "PROJECT.VIEW_REJECTION_NOTES.TITLE": "El proyecto ha sido rechazado por un administrador.",
    "PROJECTS.LOADING_PROJECT_INFO": "Cargando información del proyecto...",
    "RECOVERY_EXPIRED_PAGE.SUBTITLE": "Tu enlace ya no está activo",
    "RECOVERY_EXPIRED_PAGE.TITLE": "Recuperación de contraseña",
    "RECOVERY_PASSWORD_PAGE.FORM.EMAIL.LABEL": "Correo electrónico",
    "RECOVERY_PASSWORD_PAGE.FORM.EMAIL.PLACEHOLDER": "Introduce tu correo electrónico",
    "RECOVERY_PASSWORD_PAGE.FORM.PASSWORD.LABEL": "Contraseña",
    "RECOVERY_PASSWORD_PAGE.FORM.PASSWORD.PLACEHOLDER": "Ingresa tu contraseña",
    "RECOVERY_PASSWORD_PAGE.FORM.REPEAT_PASSWORD.LABEL": "Repita la contraseña",
    "RECOVERY_PASSWORD_PAGE.FORM.REPEAT_PASSWORD.PLACEHOLDER": "Repita la contraseña",
    "RECOVERY_PASSWORD_PAGE.FORM.SUBMIT": "Recuperar",
    "RECOVERY_PASSWORD_PAGE.SUBTITLE": "Ingrese su contraseña a continuación",
    "RECOVERY_PASSWORD_PAGE.TITLE": "Recuperación de contraseña",
    "REPORT_BUILDER.APPLY": "Aplicar",
    "REPORT_BUILDER.BACK": "Atrás",
    "REPORT_BUILDER.EXPORT_TO_PDF": "Exportar a PDF",
    "REPORT_BUILDER.RUN": "Correr",
    "REPORT_BUILDER.SAVE": "Ahorrar",
    "REPORT_BUILDER.SORT_MODE": "Modo de clasificación",
    "REPORT.FILTERS.DROPDOWN.JOB_TYPE.ASSET_LEAK": "Fuga de activos",
    "REPORT.FILTERS.DROPDOWN.JOB_TYPE.CLIENT_METER_PRV_LEAK": "Fuga del medidor del cliente/PRV",
    "REPORT.FILTERS.DROPDOWN.JOB_TYPE.COMM_PIPE_LEAK": "Fuga en la tubería de comunicaciones",
    "REPORT.FILTERS.DROPDOWN.JOB_TYPE.CUSTOMER_METER_LEAK": "Fuga del medidor del cliente",
    "REPORT.FILTERS.DROPDOWN.JOB_TYPE.CUSTOMER_SIDE_LEAK": "Fuga del lado del cliente",
    "REPORT.FILTERS.DROPDOWN.JOB_TYPE.FERRULE_LEAK": "Fuga de férula",
    "REPORT.FILTERS.DROPDOWN.JOB_TYPE.MAINS_LEAK": "Fuga de red",
    "REPORT.FILTERS.DROPDOWN.JOB_TYPE.NA": "N / A",
    "REPORT.FILTERS.DROPDOWN.JOB_TYPE.NETWORK_MAINTENANCE": "Mantenimiento de red",
    "REPORT.FILTERS.DROPDOWN.JOB_TYPE.RENEW_STOP_TAP_MSM": "Renovar Stop Tap/MSM",
    "REPORT.FILTERS.DROPDOWN.JOB_TYPE.REPAIR": "Reparar",
    "REPORT.FILTERS.DROPDOWN.JOB_TYPE.RESOLVED_ONSITE": "Resuelto en el sitio",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.ASSET_LEAK": "Fuga de activos",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.CLIENT_METER_PRV_LEAK": "Fuga del medidor del cliente/PRV",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.COMMERCIAL_REPAIR": "Reparación comercial",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.COMMUNICATION_PIPE": "Tubería de comunicación",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.CSL": "CSL",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.CUSTOMER_METER_LEAK": "Fuga del medidor del cliente",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.CUSTOMER_SIDE_LEAK": "Fuga del lado del cliente",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.DECOMMISSION_FERRULE": "Desmantelamiento de la férula",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.EXCAVATE_TRIAL_HOLE_PERMIT": "Excavación de pozo de prueba (permiso)",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.EXTERNAL_LEAKING_METER_GT_40MM_INC_EXC": "Medidor de fugas externas > 40 mm Inc Exc",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.EXTERNAL_LEAKING_METER_GT_40MM_NO_EXC": "Medidor de fugas externas > 40 mm Sin excepción",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.EXTERNAL_LEAKING_METER_LT_40MM_INC_EXC": "Medidor de fugas externas <40 mm Inc Exc",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.EXTERNAL_LEAKING_METER_LT_40MM_NO_EXC": "Medidor de fugas externas <40 mm Sin excepción",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.FERRULE": "Contera",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.FERRULE_EXCHANGE_NO_5": "Cambio de casquillo n.º 5",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.FH_STOPPED_ON_SITE": "F/H se detuvo en el sitio",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.FIRE_HYDRANT": "Boca de incendio",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.FIRE_MAIN": "Tubería principal contra incendios",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.FLOW_TEST_AT_BOUNDARY_NO_EXC": "Prueba de flujo en el límite sin excepción",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.FLOW_TEST_AT_BOUNDARY_WITH_EXC": "Prueba de flujo en el límite con Exc",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.INST_MSM_TO_EXIST_COMM_PIPE_UNMTRD": "Inst MSM para existir Comm Pipe UnMtrd",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.INSTALL_FERRULE_ONLY": "Instalar solo la férula",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.INSTALL_MSM_INC_METER": "Instalar el medidor MSM Inc",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.INSTALL_SAMPLE_TAP": "Instalar Sample Tap",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.INSTALL_SLUICE_VALVE": "Instalar válvula de compuerta",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.INSTALL_WASHOUT_HYDRANT": "Instalar hidrante de lavado",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.LEAK_FIXED_ONSITE": "Fuga reparada en el sitio",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.LEAK_ON_FH": "Fuga en F/H",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.LEAK_ON_SPINDLE_OF_SV": "Fuga en el husillo del SV",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.LEAK_ON_SPINDLE_OF_SV_FLANGE": "Fuga en el husillo del SV/brida.",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.MAINS": "Red eléctrica",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.MAINS_BURST": "Ráfaga de red",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.MAINS_LEAK": "Fuga de red",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.NA_WO_STOPPED_ON_SITE": "N/A - Sin paradas en el sitio",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.NETWORK_MAINTENANCE": "Mantenimiento de red",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.OSV_EXCHANGE": "Intercambio de OSV",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.OTHER": "Otro",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.PASSING_FH": "Pasando FH",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.PASSING_HYDRANT": "Pasando hidrante",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REMEDIAL_WORK_EXTERNAL": "Trabajo de remediación externo",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REMOVE_SLUICE_VAVLE": "Retire la válvula de compuerta",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.RENEW_COMMUNICATION_PIPE_LONGSIDE": "Renovar la tubería de comunicación del lado largo",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.RENEW_COMMUNICATION_PIPE_SHORTSIDE": "Renovar la tubería de comunicación del lado corto",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.RENEW_COVER_AND_FRAME_STANDARD": "Renovar cubierta y marco (estándar)",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.RENEW_FERRULE_ONLY": "Renovar solo la férula",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.RENEW_FIRE_HYDRANT": "Renovar la boca de incendios",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.RENEW_FIRE_HYDRANT_CHAMBER": "Renovar la cámara de la boca de incendios",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.RENEW_FIRE_HYDRANT_FRAME_AND_COVER": "Renovar el marco y la cubierta de la boca de incendios",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.RENEW_LEAKING_SUPPLY_PIPE_GT_10M": "Renovar tubería de suministro con fugas >10 m",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.RENEW_LEAKING_SUPPLY_PIPE_LT_10M": "Renovar tubería de suministro con fugas <10 m",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.RENEW_MSM_STOP_TAP_ASSEMBLY": "Renovar el conjunto de MSM/grifo de parada",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.RENEW_SLUICE_VAVLE": "Renovar la válvula de compuerta",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.RENEW_WASHOUT_HYDRANT": "Renovar el hidrante de lavado",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPACK_SLUICE_VALVE": "Reempaquetado de la válvula de compuerta",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPAIR_COMMUNICATION_PIPE": "Reparar tubería de comunicación",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPAIR_EXTERNAL_LSP_NON_ELIGIBLE": "Reparación de LSP externo - No elegible",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPAIR_INTERNAL_LEAK_RECH": "Reparación de fugas internas (Rech)",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPAIR_LEAKING_SUPPLY_PIPE_RECH": "Reparación de tubería de suministro con fugas (Rech)",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPAIR_LOP": "Reparar LOP",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPAIR_LSP_ELIGIBLE": "Reparación de LSP - Elegible",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPAIR_MAIN_DOWEL_PIECE_GTE_200MM": "Reparación de la pieza de espiga principal >=200 mm",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPAIR_MAIN_DOWEL_PIECE_LT_200MM": "Reparación de la pieza de espiga principal <200 mm",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPAIR_MAIN_NOT_DOWEL_GTE_200MM": "Reparación principal [no pasador] >=200 mm",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPAIR_MAIN_NOT_DOWEL_LT_200MM": "Reparación principal [sin pasador] <200 mm",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPAIR_MAJOR_BURST": "Reparar una explosión importante",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPAIR_NON_RETURN_VALVE": "Reparación de válvula antirretorno",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPAIR_RUNNING_OVERFLOW_RECH": "Reparar desbordamiento en ejecución (Rech)",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPAIR_SLUICE_VALVE": "Reparación de válvula de compuerta",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPOSITION_MSM_STOP_TAP_ASSEMBLY": "Reposicionar el conjunto MSM/grifo de parada",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.RESET_SURFACE_BOX_STANDARD": "Restablecer Surface Box (estándar)",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.SERVICE_LEAK": "Fuga de servicio",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.SLUICE_VALVE": "Válvula de compuerta",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.SLUICE_VALVE_VL": "Válvula de compuerta (VL)",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.STOP_TAP_EXCHANGE": "Detener el intercambio de grifos",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.STOP_TAP_LEAK": "Detener la fuga del grifo",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.STOP_TAP_LEAK_NO_7": "Detener la fuga del grifo n.º 7",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.WO_FH": "WO / FH",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK.LEAK": "Filtración",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK.NO_LEAK": "Sin fugas",
    "REPORT.FILTERS.DROPDOWN.PREDICTEDSIZE": "Tamaño previsto",
    "REPORT.FILTERS.DROPDOWN.PREDICTEDSIZE.LARGE": "Grande",
    "REPORT.FILTERS.DROPDOWN.PREDICTEDSIZE.MEDIUM": "Medio",
    "REPORT.FILTERS.DROPDOWN.PREDICTEDSIZE.SMALL": "Pequeño",
    "REPORT.FILTERS.DROPDOWN.STATUS": "Estado",
    "REPORT.FILTERS.DROPDOWN.STATUS.1": "Escape",
    "REPORT.FILTERS.DROPDOWN.STATUS.10": "En progreso ST (Breakout)",
    "REPORT.FILTERS.DROPDOWN.STATUS.11": "Fuga Conocida",
    "REPORT.FILTERS.DROPDOWN.STATUS.12": "Fuga Enviada al Cliente",
    "REPORT.FILTERS.DROPDOWN.STATUS.13": "Resaltado",
    "REPORT.FILTERS.DROPDOWN.STATUS.14": "Propuesto",
    "REPORT.FILTERS.DROPDOWN.STATUS.15": "Reparación Programada",
    "REPORT.FILTERS.DROPDOWN.STATUS.16": "Reparado",
    "REPORT.FILTERS.DROPDOWN.STATUS.17": "Días Programados",
    "REPORT.FILTERS.DROPDOWN.STATUS.18": "Noches programadas",
    "REPORT.FILTERS.DROPDOWN.STATUS.19": "Fuente de Ruido No Confirmada",
    "REPORT.FILTERS.DROPDOWN.STATUS.2": "Fuente de Ruido Confirmada",
    "REPORT.FILTERS.DROPDOWN.STATUS.20": "Validado",
    "REPORT.FILTERS.DROPDOWN.STATUS.3": "Recolección de Datos",
    "REPORT.FILTERS.DROPDOWN.STATUS.4": "Eliminado",
    "REPORT.FILTERS.DROPDOWN.STATUS.5": "Excavación Seca",
    "REPORT.FILTERS.DROPDOWN.STATUS.6": "Editado",
    "REPORT.FILTERS.DROPDOWN.STATUS.7": "Solicitud de Trabajo Adicional",
    "REPORT.FILTERS.DROPDOWN.STATUS.8": "En Progreso",
    "REPORT.FILTERS.DROPDOWN.STATUS.9": "En progreso LE (Breakout)",
    "REPORT.FILTERS.DROPDOWN.STATUS.AWAITING_SCHEDULING": "En espera de programación",
    "REPORT.FILTERS.DROPDOWN.STATUS.AWAITINGSCHEDULING": "En espera de programación",
    "REPORT.FILTERS.DROPDOWN.STATUS.CLOSED": "Cerrado",
    "REPORT.FILTERS.DROPDOWN.STATUS.CONFIRMED_NOISE_SOURCE": "Fuente de ruido confirmada",
    "REPORT.FILTERS.DROPDOWN.STATUS.CONFIRMEDNOISESOURCE": "Fuente de ruido confirmada",
    "REPORT.FILTERS.DROPDOWN.STATUS.DRY_DIG": "Excavación en seco",
    "REPORT.FILTERS.DROPDOWN.STATUS.DRYDIG": "Excavación en seco",
    "REPORT.FILTERS.DROPDOWN.STATUS.EDITED": "editado",
    "REPORT.FILTERS.DROPDOWN.STATUS.FURTHER_WORK_REQUESTED": "Trabajo adicional solicitado",
    "REPORT.FILTERS.DROPDOWN.STATUS.FURTHERWORKREQUESTED": "Trabajo adicional solicitado",
    "REPORT.FILTERS.DROPDOWN.STATUS.LEAK_SUBMITTED_TO_CLIENT": "Fuga enviada al cliente",
    "REPORT.FILTERS.DROPDOWN.STATUS.LEAKSUBMITTEDTOCLIENT": "Fuga enviada al cliente",
    "REPORT.FILTERS.DROPDOWN.STATUS.MARKED_UP": "Marcado",
    "REPORT.FILTERS.DROPDOWN.STATUS.MARKEDUP": "Marcado",
    "REPORT.FILTERS.DROPDOWN.STATUS.PROPOSED": "Propuesto",
    "REPORT.FILTERS.DROPDOWN.STATUS.REPAIRED": "reparado",
    "REPORT.FILTERS.DROPDOWN.STATUS.SCHEDULED": "Programado",
    "REPORT.FILTERS.DROPDOWN.STATUS.SCHEDULING": "Planificación",
    "REPORT.FILTERS.DROPDOWN.STATUS.UNCONFIRMED": "Inconfirmado",
    "REPORT.FILTERS.DROPDOWN.STATUS.UNCONFIRMED_NOISE_SOURCE": "Fuente de ruido no confirmada",
    "REPORT.FILTERS.DROPDOWN.STATUS.UNCONFIRMEDNOISESOURCE": "Fuente de ruido no confirmada",
    "REPORT.FILTERS.FILTER.BUTTON": "filtros",
    "REPORT.FILTERS.SAVE.BUTTON": "Guardar vista",
    "REPORTS_PAGE.CREATE_REPORT.BUTTON": "Crear reporte",
    "REPORTS_PAGE.CREATE_REPORT.FORM.CHOOSE_LAYOUT.LABEL": "Elija diseño",
    "REPORTS_PAGE.CREATE_REPORT.FORM.REDIRECT_TO_EDIT": "Editar informe",
    "REPORTS_PAGE.CREATE_REPORT.FORM.REPORT_NAME.LABEL": "Reportar nombre",
    "REPORTS_PAGE.CREATE_REPORT.FORM.REPORT_NAME.PLACEHOLDER": "Introduzca el nombre del informe",
    "REPORTS_PAGE.CREATE_REPORT.FORM.SUBMIT": "Crear reporte",
    "REPORTS_PAGE.CREATE_REPORT.TITLE": "Crear nuevo informe",
    "REPORTS_PAGE.CRUMB": "Informes",
    "REPORTS_PAGE.SUBTITLE": "Informes de resultados de barrido FIDO",
    "REPORTS_PAGE.TABLE.ACTIONS": "Comportamiento",
    "REPORTS_PAGE.TABLE.CREATED": "Creado",
    "REPORTS_PAGE.TABLE.NUMBER": "#",
    "REPORTS_PAGE.TABLE.REPORT_NAME": "Reportar nombre",
    "REPORTS_PAGE.TITLE.NO_REPORTS": "no hay informes",
    "REPORTS_PAGE.TITLE.TOTAL_COUNT": "Informes totales:",
    "REQUEST.FAILED": "Fallido",
    "REQUEST.SUCCESS": "Éxito",
    "SERVER_ERRORS.-1": "Algo salió mal",
    "SERVER_ERRORS.1": "Error de conexión a la base de datos",
    "SERVER_ERRORS.10": "Error de archivo vacío",
    "SERVER_ERRORS.11": "Error de autenticación",
    "SERVER_ERRORS.12": "Error de autenticación",
    "SERVER_ERRORS.13": "Error de autenticación",
    "SERVER_ERRORS.14": "Error de autenticación",
    "SERVER_ERRORS.15": "Error de autenticación",
    "SERVER_ERRORS.16": "No se encontró el usuario con el correo electrónico proporcionado",
    "SERVER_ERRORS.17": "Correo electrónico o la contraseña son incorrectos",
    "SERVER_ERRORS.18": "El token de correo electrónico no es válido",
    "SERVER_ERRORS.19": "Permiso denegado",
    "SERVER_ERRORS.2": "Algo salió mal",
    "SERVER_ERRORS.21": "Usuario no encontrado",
    "SERVER_ERRORS.22": "Rol no encontrado",
    "SERVER_ERRORS.23": "Empresa no encontrada",
    "SERVER_ERRORS.24": "Proyecto no encontrado",
    "SERVER_ERRORS.25": "Permiso denegado",
    "SERVER_ERRORS.26": "Permiso denegado",
    "SERVER_ERRORS.27": "Datos de archivo no válidos",
    "SERVER_ERRORS.28": "Ya existe Este email",
    "SERVER_ERRORS.3": "Solicitud no válida",
    "SERVER_ERRORS.31": "Empresa no encontrada",
    "SERVER_ERRORS.32": "El nombre de la empresa no es válido o ya existe",
    "SERVER_ERRORS.4": "Formato de archivo no válido",
    "SERVER_ERRORS.41": "Empresa no encontrada",
    "SERVER_ERRORS.5": "No autorizado",
    "SERVER_ERRORS.6": "Recurso no encontrado",
    "SERVER_ERRORS.61": "Método no permitido",
    "SERVER_ERRORS.62": "La llamada a la API falló",
    "SERVER_ERRORS.63": "Tipo de geometría no válido",
    "SERVER_ERRORS.65": "El proyecto se superpone con los proyectos existentes {{ projectNames }} y las DMA {{ dmaKeys }}",
    "SERVER_ERRORS.7": "Servicio no disponible",
    "SERVER_ERRORS.8": "Error de almacenamiento de Azure",
    "SERVER_ERRORS.9": "Formato de geojson no válido",
    "SERVER_SUCCESS.ADD_COMPANY": "Empresa creada con éxito",
    "SERVER_SUCCESS.CREATE_BRANCH": "Proyecto creado con éxito",
    "SERVER_SUCCESS.CREATE_USER": "Usuario creado con éxito",
    "SERVER_SUCCESS.EDIT_COMPANY": "Empresa actualizada correctamente",
    "SERVER_SUCCESS.EDIT_USER": "Usuario actualizado correctamente",
    "SERVER_SUCCESS.FORGOT_PASSWORD": "Enlace de recuperación enviado con éxito",
    "SERVER_SUCCESS.LOGIN": "El inicio de sesión fue exitoso",
    "SERVER_SUCCESS.LOGOUT": "El cierre de sesión fue exitoso",
    "SERVER_SUCCESS.RECOVERY": "La recuperación fue exitosa",
    "SERVER_SUCCESS.UPDATE_BRANCH": "Proyecto actualizado con éxito",
    "SERVER_SUCCESS.UPDATE_REPORT": "El informe fue actualizado",
    "SESSION_PAGE.ENGINEERING_DETAILS.3D_PLOT_TOGGLE_TITLE": "Sesiones Nocturnas Separadas",
    "SESSION_PAGE.ENGINEERING_DETAILS.ADDRESS_TITLE": "Detalles de la Dirección",
    "SESSION_PAGE.ENGINEERING_DETAILS.APPLY_DATES": "Aplicar Fechas",
    "SESSION_PAGE.ENGINEERING_DETAILS.ASSET_TITLE": "Imágenes de Activos",
    "SESSION_PAGE.ENGINEERING_DETAILS.COLLECTED_ENGINEER": "Ingeniero Coleccionado",
    "SESSION_PAGE.ENGINEERING_DETAILS.COMPANY": "Empresa",
    "SESSION_PAGE.ENGINEERING_DETAILS.DATE_TITLE": "Fechas Horas",
    "SESSION_PAGE.ENGINEERING_DETAILS.DEPLOYED_ENGINEER": "Ingeniero Desplegado",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.ADDRESS": "Dirección",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.COMPANY": "Empresa",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.CREATED": "Creado",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.DMA_KEY": "Clave DMA",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.END_TIME": "Hora de finalización",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.FIDO_RESULT": "Resultado de Fido",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.LAST_UPDATE": "Última Actualización",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.LEAK_SIZE": "Tamaño de la fuga",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.LOCATION": "Ubicación",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.SENSOR_ID": "ID del sensor",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.SESSION_ID": "ID de sesión",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.SESSION_STATUS": "Estado de la sesión",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.START_TIME": "Hora de inicio",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.TYPE": "Tipo",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.WAYPOINT_NAME": "Nombre del Punto de Referencia",
    "SESSION_PAGE.ENGINEERING_DETAILS.ENGINEER_TITLE": "Ingenieros",
    "SESSION_PAGE.ENGINEERING_DETAILS.GRAPH_TITLE": "Gráfico de Polen",
    "SESSION_PAGE.ENGINEERING_DETAILS.ID_TITLE": "Lista de IDs",
    "SESSION_PAGE.ENGINEERING_DETAILS.LAST_UPDATED": "Días desde la última actualización",
    "SESSION_PAGE.ENGINEERING_DETAILS.POSTCODE": "Código postal",
    "SESSION_PAGE.ENGINEERING_DETAILS.RELAY_ERROR": "Ocurrió un error mientras se procesaban los datos del relevo",
    "SESSION_PAGE.ENGINEERING_DETAILS.RELAY_NO_DATA": "No hay datos disponibles actualmente",
    "SESSION_PAGE.ENGINEERING_DETAILS.RESET_DATES": "Restablecer Fechas",
    "SESSION_PAGE.ENGINEERING_DETAILS.SESSION_TITLE": "Detalles de la Sesión",
    "SESSION_PAGE.ENGINEERING_DETAILS.TITLE": "Detalles de Ingeniería FIDO",
    "SESSION_PAGE.ENGINEERING_DETAILS.WHAT3WORDS": "What3Words",
    "SESSION_PAGE.GET_AUDIO.BUTTON.CANCEL": "Cancelar recuperación",
    "SESSION_PAGE.GET_AUDIO.BUTTON.GET": "Recuperar audio",
    "SESSION_PAGE.GET_AUDIO.BUTTON.NA": "No hay dispositivo de retransmisión disponible",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.AVAILABLE.CONTENT": "Para recuperar audio, debe haber un dispositivo de retransmisión adjunto a esta sesión. Si no hay un dispositivo de retransmisión adjunto, no podrá recuperar ningún audio a través del portal para esta sesión y el botón estará deshabilitado.",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.AVAILABLE.HEADING": "Disponibilidad",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.FUNCTION.CONTENT1": "Independientemente de cómo se activó el dispositivo de relé, puedes activar o desactivar esto usando el botón de arriba. La posible última acción y los estados correspondientes son",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.FUNCTION.CONTENT2": "Activado POR el usuario del portal: el dispositivo de relé recuperará audio",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.FUNCTION.CONTENT3": "Desactivado por el usuario del portal: el dispositivo de relé no recuperará audio",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.FUNCTION.CONTENT4": "Activado POR proceso automatizado: el dispositivo de relé recuperará audio",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.FUNCTION.CONTENT5": "Desactivado por proceso automatizado: el dispositivo de relé no recuperará audio",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.FUNCTION.CONTENT6": "N/A- Dispositivo de relé no disponible",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.FUNCTION.TITLE": "Funcionalidad",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.PROCESS.CONTENT1": "Asumiremos que hay un dispositivo de relé adjunto para esta sección.",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.PROCESS.CONTENT2": "Puede alternar si el dispositivo de relé debe intentar recuperar datos de audio dentro de las próximas 24 horas.",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.PROCESS.CONTENT3": "Una vez que se haya completado una solicitud, los datos en esta página se actualizarán y luego la recuperación de audio se desactivará automáticamente.",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.PROCESS.CONTENT4": "También hay un proceso automatizado que recuperará automáticamente los datos de audio para todas las sesiones que tengan un dispositivo de retransmisión adjunto, dado que nuestro modelo ha detectado un problema.",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.PROCESS.HEADING": "El Proceso",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.TITLE": "Explicación de los dispositivos de relé",
    "SESSION_PAGE.GET_AUDIO.ERROR": "Ha habido un error, por favor actualice la página e intente de nuevo",
    "SESSION_PAGE.GET_AUDIO.LAST_ACTION": "Última acción tomada",
    "SESSION_PAGE.GET_AUDIO.LAST_ACTION.AUTO_OFF": "Desactivado por proceso automatizado",
    "SESSION_PAGE.GET_AUDIO.LAST_ACTION.AUTO_ON": "Activado POR proceso automatizado",
    "SESSION_PAGE.GET_AUDIO.LAST_ACTION.NA": "No aplica",
    "SESSION_PAGE.GET_AUDIO.LAST_ACTION.USER_OFF": "Desactivado por el usuario del portal",
    "SESSION_PAGE.GET_AUDIO.LAST_ACTION.USER_ON": "Activado POR el usuario del portal",
    "SESSION_PAGE.GET_AUDIO.STATUS": "Estado actual",
    "SESSION_PAGE.GET_AUDIO.STATUS.GET": "El dispositivo de retransmisión recuperará audio",
    "SESSION_PAGE.GET_AUDIO.STATUS.NA": "Dispositivo de relé no disponible",
    "SESSION_PAGE.GET_AUDIO.STATUS.NOT_GET": "El dispositivo de relé no recuperará audio",
    "SESSION_PAGE.GET_AUDIO.TITLE": "Recuperación de Audio",
    "SESSION_PAGE.RELAY_GRAPH.X": "Frecuencia",
    "SESSION_PAGE.RELAY_GRAPH.Y": "Tiempo",
    "SESSION_PAGE.RELAY_GRAPH.Z": "Poder",
    "SESSION_PAGE.SESSION_INFORMATION.FIDO_RESULT": "Resultado FIDO",
    "SESSION_PAGE.SESSION_INFORMATION.LEAK_SIZE": "Tamaño de la fuga",
    "SESSION_PAGE.SESSION_INFORMATION.TITLE": "Información de la sesión",
    "SESSION.LOADING_LEAK_MAPPER": "Cargando mapeador de fugas...",
    "SESSIONS.STATUS.DELETED": "Eliminado",
    "SESSIONS.STATUS.ON_TRACK": "En camino",
    "SESSIONS.STATUS.UPLOADED": "Subido",
    "SESSIONS.STATUS.UPLOADING": "Esperando carga",
    "SIDEBAR.ADMIN": "Administrador",
    "SIDEBAR.BROWSE": "Explorar",
    "SIDEBAR.COMPANIES": "Compañías",
    "SIDEBAR.COMPANY": "Mi empresa",
    "SIDEBAR.DASHBOARD": "Panel",
    "SIDEBAR.DELIVERY_PERFORMANCE": "Rendimiento de Entrega",
    "SIDEBAR.DELIVERY_PERFORMANCE_LE": "Ingeniero de Fugas",
    "SIDEBAR.DELIVERY_PERFORMANCE_ST": "Técnico de Sensores",
    "SIDEBAR.DMAPERFORMANCEREPORT": "Informe de rendimiento de DMA",
    "SIDEBAR.FEEDBACK": "Deja un comentario",
    "SIDEBAR.GIS": "GIS",
    "SIDEBAR.GIS_ADMIN": "Administrador de SIG",
    "SIDEBAR.GIS_UPLOAD": "Carga de GIS",
    "SIDEBAR.LOGOUT": "Cerrar sesión",
    "SIDEBAR.LOGS": "Registros de cambios",
    "SIDEBAR.PROJECT_ADMIN": "Administrador del proyecto",
    "SIDEBAR.PROJECT_STATUS": "Estado del proyecto",
    "SIDEBAR.PROJECTSTATUS": "Estado del proyecto",
    "SIDEBAR.RELAY_MANAGEMENT": "Gestión de Relevos",
    "SIDEBAR.REPORTS": "Informes",
    "SIDEBAR.SENSOR_MANAGEMENT": "Gestión de Sensores",
    "SIDEBAR.STOCK_MANAGEMENT": "Gestión de Stock",
    "SIDEBAR.TITLE": "Panel de administrador",
    "SIDEBAR.USERS": "Gestión de Usuarios",
    "SIDEBAR.VERSION": "Versión ",
    "STOCK_MANAGEMENT.DATES_BETWEEN": "Mostrar Uso Entre",
    "STOCK_MANAGEMENT.DATES_BETWEEN.AND": "y",
    "STOCK_MANAGEMENT.DISTRIBUTION.CHART_TITLE": "Distribución al Cliente",
    "STOCK_MANAGEMENT.DISTRIBUTION.DATE_ERROR": "La fecha de inicio no puede ser mayor que la fecha de finalización",
    "STOCK_MANAGEMENT.DISTRIBUTION.FAULTY": "Sensores FIDO defectuosos",
    "STOCK_MANAGEMENT.DISTRIBUTION.FILTER": "Filtrar",
    "STOCK_MANAGEMENT.DISTRIBUTION.NO_DATA": "No hay datos de distribución de stock para el rango de fechas seleccionado",
    "STOCK_MANAGEMENT.DISTRIBUTION.REFURBED": "Sensores FIDO Refurbished",
    "STOCK_MANAGEMENT.DISTRIBUTION.RETURNED": "Sensores FIDO Devueltos",
    "STOCK_MANAGEMENT.DISTRIBUTION.STOCKED": "Sensores FIDO en stock",
    "STOCK_MANAGEMENT.DISTRIBUTION.TITLE": "Distribución de acciones a los clientes",
    "STOCK_MANAGEMENT.DISTRIBUTION.TOGGLE_ALL": "Alternar Todo",
    "STOCK_MANAGEMENT.RELAY.DISTRIBUTION.FAULTY": "Relés FIDO defectuosos",
    "STOCK_MANAGEMENT.RELAY.DISTRIBUTION.REFURBED": "Relés FIDO Refurbished",
    "STOCK_MANAGEMENT.RELAY.DISTRIBUTION.RETURNED": "Relés FIDO Devueltos",
    "STOCK_MANAGEMENT.RELAY.DISTRIBUTION.STOCKED": "Relés FIDO en Stock",
    "STOCK_MANAGEMENT.RELAY.DISTRIBUTION.TITLE": "Distribución de Relevos a los Clientes",
    "STOCK_MANAGEMENT.SENSOR.DISTRIBUTION.FAULTY": "Sensores FIDO defectuosos",
    "STOCK_MANAGEMENT.SENSOR.DISTRIBUTION.REFURBED": "Sensores FIDO Refurbished",
    "STOCK_MANAGEMENT.SENSOR.DISTRIBUTION.RETURNED": "Sensores FIDO Devueltos",
    "STOCK_MANAGEMENT.SENSOR.DISTRIBUTION.STOCKED": "Sensores FIDO en stock",
    "STOCK_MANAGEMENT.SENSOR.DISTRIBUTION.TITLE": "Distribución de Sensores a Clientes",
    "STOCK_MANAGEMENT.TABLE.BUG_NAME": "Nombre del Sensor",
    "STOCK_MANAGEMENT.TABLE.BUG_OWNER": "Propietario del Sensor",
    "STOCK_MANAGEMENT.TABLE.COMMENT": "Comentario",
    "STOCK_MANAGEMENT.TABLE.CUSTOMER": "Cliente",
    "STOCK_MANAGEMENT.TABLE.DATE": "Fecha más reciente",
    "STOCK_MANAGEMENT.TABLE.DATE_FROM": "De",
    "STOCK_MANAGEMENT.TABLE.DATE_TO": "Para",
    "STOCK_MANAGEMENT.TABLE.DEVICE_ID": "ID del sensor",
    "STOCK_MANAGEMENT.TABLE.EDIT_SECTION": "Editar Stock",
    "STOCK_MANAGEMENT.TABLE.EDIT.COMMENTS": "Comentarios",
    "STOCK_MANAGEMENT.TABLE.EDIT.CUSTOMER": "Cliente",
    "STOCK_MANAGEMENT.TABLE.EDIT.DESELECT": "Deseleccionar todo el stock",
    "STOCK_MANAGEMENT.TABLE.EDIT.DISCARD": "Cancelar",
    "STOCK_MANAGEMENT.TABLE.EDIT.NO_COMMENTS": "Por favor, ingrese un comentario",
    "STOCK_MANAGEMENT.TABLE.EDIT.NO_CUSTOMER": "Por favor, seleccione un cliente",
    "STOCK_MANAGEMENT.TABLE.EDIT.NO_OWNER": "Por favor, seleccione un propietario de sensor",
    "STOCK_MANAGEMENT.TABLE.EDIT.NO_STATUS": "Por favor, seleccione un estado",
    "STOCK_MANAGEMENT.TABLE.EDIT.NO_TIMESTAMP": "Por favor, seleccione una marca de tiempo",
    "STOCK_MANAGEMENT.TABLE.EDIT.OWNER": "Propietario del Sensor",
    "STOCK_MANAGEMENT.TABLE.EDIT.PARTNER": "Socio",
    "STOCK_MANAGEMENT.TABLE.EDIT.RELAY_OWNER": "Propietario del Relevo",
    "STOCK_MANAGEMENT.TABLE.EDIT.SENSOR_OWNER": "Propietario del Sensor",
    "STOCK_MANAGEMENT.TABLE.EDIT.STATUS": "Estado",
    "STOCK_MANAGEMENT.TABLE.EDIT.SUBMIT": "Actualizar",
    "STOCK_MANAGEMENT.TABLE.EDIT.TIMESTAMP": "Marca de tiempo",
    "STOCK_MANAGEMENT.TABLE.EDIT.TITLE": "Modificar Stock Seleccionado",
    "STOCK_MANAGEMENT.TABLE.FILTER": "Filtrar",
    "STOCK_MANAGEMENT.TABLE.FILTER_SECTION": "Filtros, Ordenación y Búsqueda",
    "STOCK_MANAGEMENT.TABLE.MODIFY": "Modificar seleccionado",
    "STOCK_MANAGEMENT.TABLE.NO_DATA": "No hay datos de stock",
    "STOCK_MANAGEMENT.TABLE.PERSON": "Persona",
    "STOCK_MANAGEMENT.TABLE.RELAY.BUG_NAME": "Nombre del Relevo",
    "STOCK_MANAGEMENT.TABLE.RELAY.BUG_OWNER": "Propietario del Relevo",
    "STOCK_MANAGEMENT.TABLE.RELAY.COMMENT": "Comentario",
    "STOCK_MANAGEMENT.TABLE.RELAY.CUSTOMER": "Cliente",
    "STOCK_MANAGEMENT.TABLE.RELAY.DATE": "Fecha más reciente",
    "STOCK_MANAGEMENT.TABLE.RELAY.IMEI": "IMEI",
    "STOCK_MANAGEMENT.TABLE.RELAY.PERSON": "Persona",
    "STOCK_MANAGEMENT.TABLE.RELAY.SIM": "ID de SIM",
    "STOCK_MANAGEMENT.TABLE.RELAY.STATUS": "Estado",
    "STOCK_MANAGEMENT.TABLE.RELAY.TIMESTAMP": "Última Hora",
    "STOCK_MANAGEMENT.TABLE.SEARCH_BAR.APPLY.FILTER": "Aplica filtros, ordenamiento y búsqueda",
    "STOCK_MANAGEMENT.TABLE.SEARCH.PLACEHOLDER": "Buscar sensores...",
    "STOCK_MANAGEMENT.TABLE.SELECT_ALL": "Seleccionar todo",
    "STOCK_MANAGEMENT.TABLE.SELECT_WAYPOINT": "Seleccionar",
    "STOCK_MANAGEMENT.TABLE.SENSOR.BUG_NAME": "Nombre del Sensor",
    "STOCK_MANAGEMENT.TABLE.SENSOR.BUG_OWNER": "Propietario del Sensor",
    "STOCK_MANAGEMENT.TABLE.SENSOR.COMMENT": "Comentario",
    "STOCK_MANAGEMENT.TABLE.SENSOR.CUSTOMER": "Cliente",
    "STOCK_MANAGEMENT.TABLE.SENSOR.DATE": "Fecha más reciente",
    "STOCK_MANAGEMENT.TABLE.SENSOR.DEVICE_ID": "ID del sensor",
    "STOCK_MANAGEMENT.TABLE.SENSOR.PERSON": "Persona",
    "STOCK_MANAGEMENT.TABLE.SENSOR.STATUS": "Estado",
    "STOCK_MANAGEMENT.TABLE.SENSOR.TIMESTAMP": "Última Hora",
    "STOCK_MANAGEMENT.TABLE.SORT": "Ordenar",
    "STOCK_MANAGEMENT.TABLE.SORT.ASC": "Ascendiendo",
    "STOCK_MANAGEMENT.TABLE.SORT.DESC": "Descendiendo",
    "STOCK_MANAGEMENT.TABLE.SORT.NONE": "Ninguno",
    "STOCK_MANAGEMENT.TABLE.STATUS": "Estado",
    "STOCK_MANAGEMENT.TABLE.STATUSES.customer": "cliente",
    "STOCK_MANAGEMENT.TABLE.STATUSES.faulty": "defectuoso",
    "STOCK_MANAGEMENT.TABLE.STATUSES.new": "nuevo",
    "STOCK_MANAGEMENT.TABLE.STATUSES.refurb": "reformado",
    "STOCK_MANAGEMENT.TABLE.STATUSES.retired": "jubilado",
    "STOCK_MANAGEMENT.TABLE.STATUSES.returned": "devuelto",
    "STOCK_MANAGEMENT.TABLE.STATUSES.stock": "acciones",
    "STOCK_MANAGEMENT.TABLE.TIMESTAMP": "Última Hora",
    "STOCK_MANAGEMENT.TABLE.TITLE": "Todas las acciones",
    "SUMMARY.DIALOG.SUBTITLE.CHANGE": "¿Se eliminarán todos los filtros?",
    "SUMMARY.DIALOG.SUBTITLE.CLOSE": "¿Se eliminarán los cambios?",
    "SUMMARY.DIALOG.TITLE.CHANGE": "¿Está seguro de que desea cambiar la fuente de datos?",
    "SUMMARY.DIALOG.TITLE.CLOSE": "¿Seguro que quieres cerrar la configuración?",
    "SUMMARY.FORM.COLUMN.LABEL": "Columna",
    "SUMMARY.FORM.COLUMN.PLACEHOLDER": "Seleccionar columna",
    "SUMMARY.FORM.SOURCE.LABEL": "Fuente de datos",
    "SUMMARY.FORM.SOURCE.PLACEHOLDER": "Seleccionar fuente de datos",
    "SUMMARY.FORM.TITLE.LABEL": "Título",
    "SUMMARY.FORM.TITLE.PLACEHOLDER": "Introduce el título",
    "SUMMARY.FORM.TYPE.LABEL": "Tipo",
    "SUMMARY.FORM.TYPE.PLACEHOLDER": "Seleccione tipo",
    "SUMMARY.MODAL_TITLE": "Ajustes",
    "SYSTEM_FIELDS.CELLS_FILLED": "Celdas llenas",
    "SYSTEM_FIELDS.DROPDOWN.1.PLACEHOLDER": "Elija material",
    "SYSTEM_FIELDS.DROPDOWN.2.PLACEHOLDER": "Elija el tipo de activo",
    "SYSTEM_FIELDS.DROPDOWN.3.PLACEHOLDER": "Elija el tipo de tubería",
    "SYSTEM_FIELDS.DROPDOWN.4.PLACEHOLDER": "Elegir estado",
    "SYSTEM_FIELDS.DROPDOWN.5.PLACEHOLDER": "Elegir unidades",
    "SYSTEM_FIELDS.ERROR.NUMERIC_UNIQUE_FIELD": "El campo único ingresado es numérico y debería ser una cadena",
    "SYSTEM_FIELDS.ROW_1": "Campos de fila",
    "SYSTEM_FIELDS.ROW_2": "Campos del Sistema",
    "SYSTEM_FIELDS.TITLE": "Mapear celdas con campos del sistema",
    "SYSTEM_FIELDS.UNIQUE_VALUES_NOT_FOUND": "No hay valores únicos para mapear",
    "TABLE_OF_RESULTS.DIALOG.SUBTITLE.CHANGE": "¿Se eliminarán todos los filtros?",
    "TABLE_OF_RESULTS.DIALOG.SUBTITLE.CLOSE": "¿Se eliminarán los cambios?",
    "TABLE_OF_RESULTS.DIALOG.TITLE.CHANGE": "¿Está seguro de que desea cambiar la fuente de datos?",
    "TABLE_OF_RESULTS.DIALOG.TITLE.CLOSE": "¿Seguro que quieres cerrar la configuración?",
    "TABLE_OF_RESULTS.FORM.COLUMNS_TO_SHOW.LABEL": "columna para mostrar",
    "TABLE_OF_RESULTS.FORM.COLUMNS_TO_SHOW.PLACEHOLDER": "Seleccionar columnas",
    "TABLE_OF_RESULTS.FORM.SOURCE.LABEL": "Fuente de datos",
    "TABLE_OF_RESULTS.FORM.SOURCE.PLACEHOLDER": "Seleccionar fuente de datos",
    "TABLE_OF_RESULTS.MODAL_TITLE": "Ajustes",
    "TOOLTIP.ADDRESS": "Dirección",
    "TOOLTIP.ASSET_KEY": "Clave de Activo",
    "TOOLTIP.COMPANY": "Compañía",
    "TOOLTIP.CONSUMPTION_PROFILE_ID": "ID del perfil de consumo",
    "TOOLTIP.DAYS_SINCE_LAST": "Días desde la última actualización",
    "TOOLTIP.DEPLOYED_BY": "Desplegado por",
    "TOOLTIP.DEPLOYMENT_ORDER": "Orden de Despliegue",
    "TOOLTIP.DIAMETER": "Diámetro",
    "TOOLTIP.DMA_ID": "Id de DMA",
    "TOOLTIP.DMA_KEY": "Clave DMA",
    "TOOLTIP.DMA_NAME": "Nombre DMA",
    "TOOLTIP.ENGINEER": "Ingeniero",
    "TOOLTIP.FIDO_RESULT": "Resultado de Fido",
    "TOOLTIP.LATITUDE": "Latitud",
    "TOOLTIP.LEAK_SIZE": "Tamaño de la fuga",
    "TOOLTIP.LONGITUDE": "Longitud",
    "TOOLTIP.MATERIAL": "Material",
    "TOOLTIP.PIPE_TYPE": "Tipo de tubería",
    "TOOLTIP.RECORDINGS_CNT": "Recuento de grabaciones",
    "TOOLTIP.SESSION_ID": "Id de sesión",
    "TOOLTIP.STANDARDISED_MATERIAL": "Material Estandarizado",
    "TOOLTIP.STANDARISED_ASSET_TYPE": "Tipo de Activo Estandarizado",
    "TOOLTIP.TOP_SOUND_ID": "Identificación de sonido superior",
    "TOOLTIP.WAYPOINT_ID": "Id de Punto de Referencia",
    "TOOLTIP.WAYPOINT_NAME": "Nombre del Punto de Referencia",
    "TOOLTIP.WHAT_3_WORDS": "Qué 3 Palabras",
    "TOP_SOUND_PAGE.AUDIO_INFORMATION": "Información de audio",
    "TOP_SOUND_PAGE.COMPANY": "Compañía",
    "TOP_SOUND_PAGE.DISTANCE_GRAPH_TITLE": "Gráficos de distancia",
    "TOP_SOUND_PAGE.ENGINEER": "Ingeniero",
    "TOP_SOUND_PAGE.HIGH_FREQUENCY": "Corte de alta frecuencia",
    "TOP_SOUND_PAGE.LOCATION": "Ubicación",
    "TOP_SOUND_PAGE.LOCATION_DETAILS": "Detalles de ubicación",
    "TOP_SOUND_PAGE.LOW_FREQUENCY": "Corte de baja frecuencia",
    "TOP_SOUND_PAGE.NUMBER_PATHS": "Número de caminos",
    "TOP_SOUND_PAGE.POSTCODE": "Código postal",
    "TOP_SOUND_PAGE.PSDS_TITLE": "Perfil espectral",
    "TOP_SOUND_PAGE.SPACING": "Espaciado",
    "TOP_SOUND_PAGE.STARTING_DISTANCE": "Distancia inicial",
    "TOP_SOUND_PAGE.TIME_TOP_SOUNDING": "Hora del sondeo máximo",
    "TOP_SOUND_PAGE.TITLE": "Sonido superior",
    "TOP_SOUND_PAGE.WHAT3WORDS": "Qué3Palabras",
    "TOP_SOUNDING.GRAPH_ALT": "gráfico de distancia de sondeo superior",
    "TOP_SOUNDING.PSD_GRAPH_ALT": "gráfico psd",
    "UNIT.GALLONS_DAY": "Galones/día",
    "UNIT.ML_DAY": "ML/Día",
    "UPLOAD_HEALTH_CHECK.BTN": "Subir Verificación de Salud",
    "UPLOAD_HEALTH_CHECK.MODAL.BTN.SUBMIT": "Enviar",
    "UPLOAD_HEALTH_CHECK.MODAL.DESC": "Por favor, introduzca la URL en el campo de abajo",
    "UPLOAD_HEALTH_CHECK.MODAL.ERROR.DESC": "Por favor, inténtelo de nuevo, la URL no se ha actualizado",
    "UPLOAD_HEALTH_CHECK.MODAL.ERROR.TITLE": "¡Inténtalo de nuevo!",
    "UPLOAD_HEALTH_CHECK.MODAL.INPUT.LABEL": "URL de Verificación de Salud",
    "UPLOAD_HEALTH_CHECK.MODAL.SUCCESS.DESC": "La URL de verificación de salud ha sido actualizada",
    "UPLOAD_HEALTH_CHECK.MODAL.SUCCESS.TITLE": "¡Genial!",
    "UPLOAD_HEALTH_CHECK.MODAL.TITLE": "Subir informe de chequeo de salud",
    "USER_DETAILS_PAGE.CRUMB": "Administrar usuario",
    "USER_DETAILS_PAGE.DISCARD": "Desechar",
    "USER_DETAILS_PAGE.FORM.BRANCH.LABEL": "Proyecto",
    "USER_DETAILS_PAGE.FORM.BRANCH.PLACEHOLDER": "Elegir Proyecto",
    "USER_DETAILS_PAGE.FORM.COMPANY.LABEL": "Compañía",
    "USER_DETAILS_PAGE.FORM.COMPANY.PLACEHOLDER": "Elija empresa",
    "USER_DETAILS_PAGE.FORM.EMAIL.LABEL": "Dirección de correo electrónico",
    "USER_DETAILS_PAGE.FORM.EMAIL.PLACEHOLDER": "Ingrese correo electrónico",
    "USER_DETAILS_PAGE.FORM.FIRST_NAME.LABEL": "Nombre de pila",
    "USER_DETAILS_PAGE.FORM.FIRST_NAME.PLACEHOLDER": "Ingrese el nombre",
    "USER_DETAILS_PAGE.FORM.LAST_NAME.LABEL": "Apellido",
    "USER_DETAILS_PAGE.FORM.LAST_NAME.PLACEHOLDER": "Introduzca el apellido",
    "USER_DETAILS_PAGE.FORM.ROLE.LABEL": "Role",
    "USER_DETAILS_PAGE.FORM.ROLE.PLACEHOLDER": "Elija Rol",
    "USER_DETAILS_PAGE.SUBMIT": "Ahorrar",
    "USER_MANAGEMENT.DROP_DOWN.TITLE": "Grupos",
    "USER_MANAGEMENT.ROUTE_TITLES.ADD_COMPANY": "Agregar Empresa",
    "USER_MANAGEMENT.ROUTE_TITLES.ADD_PARTNER": "Agregar Socio",
    "USER_MANAGEMENT.ROUTE_TITLES.ADD_PROJECT": "Añadir Proyecto",
    "USER_MANAGEMENT.ROUTE_TITLES.ADD_USER": "Agregar Usuario",
    "USER_MANAGEMENT.ROUTE_TITLES.COMPANY": "Compañía",
    "USER_MANAGEMENT.ROUTE_TITLES.PARTNER": "Socio",
    "USER_MANAGEMENT.ROUTE_TITLES.PROJECT": "Proyecto",
    "USER_MANAGEMENT.ROUTE_TITLES.PROJECT_ARCHIVES": "Proyecto archivado",
    "USER_MANAGEMENT.ROUTE_TITLES.RESOURCES": "Recursos",
    "USER_MANAGEMENT.ROUTE_TITLES.USER": "Usuario",
    "USER_MANAGEMENT.ROUTE_TITLES.VIEW_COMPANIES": "Ver Empresas",
    "USER_MANAGEMENT.ROUTE_TITLES.VIEW_GIS_UPLOADS": "Ver cargas SIG",
    "USER_MANAGEMENT.ROUTE_TITLES.VIEW_PARTNERS": "Ver Socios",
    "USER_MANAGEMENT.ROUTE_TITLES.VIEW_PROJECT_ARCHIVES": "Ver archivo",
    "USER_MANAGEMENT.ROUTE_TITLES.VIEW_PROJECTS": "Ver Proyectos",
    "USER_MANAGEMENT.ROUTE_TITLES.VIEW_USERS": "Ver Usuarios",
    "USER_ROLE.COMPANY_ADMIN": "Administrador de la empresa",
    "USER_ROLE.COMPANY_BUG_DEPLOYMENT_ENGINEER": "Técnico de Sensores de la Compañía",
    "USER_ROLE.COMPANY_LEAK_ENGINEER": "Ingeniero de Fugas de la Compañía",
    "USER_ROLE.COMPANY_USER": "Usuario de la Empresa",
    "USER_ROLE.PARTNER_ADMIN": "Administrador de Socio",
    "USER_ROLE.PARTNER_BUG_DEPLOYMENT_ENGINEER": "Técnico de Sensores Asociado",
    "USER_ROLE.PARTNER_LEAK_ENGINEER": "Ingeniero de Fugas de Socio",
    "USER_ROLE.PARTNER_USER": "Usuario Asociado",
    "USER_ROLE.SUPER_ADMIN": "Superadministrador",
    "USERS_PAGE.ADD_USER.ACTIONS": "Comportamiento",
    "USERS_PAGE.ADD_USER.BUTTON": "Nuevo Usuario",
    "USERS_PAGE.ADD_USER.FORM.BRANCH.LABEL": "Proyecto",
    "USERS_PAGE.ADD_USER.FORM.BRANCH.PLACEHOLDER": "Elegir Proyecto",
    "USERS_PAGE.ADD_USER.FORM.COMPANY.LABEL": "Compañía",
    "USERS_PAGE.ADD_USER.FORM.COMPANY.PLACEHOLDER": "Elija empresa",
    "USERS_PAGE.ADD_USER.FORM.EMAIL.LABEL": "Dirección de correo electrónico",
    "USERS_PAGE.ADD_USER.FORM.EMAIL.PLACEHOLDER": "Ingrese correo electrónico",
    "USERS_PAGE.ADD_USER.FORM.FIRST_NAME.LABEL": "Nombre de pila",
    "USERS_PAGE.ADD_USER.FORM.FIRST_NAME.PLACEHOLDER": "Ingrese el nombre",
    "USERS_PAGE.ADD_USER.FORM.LAST_NAME.LABEL": "Apellido",
    "USERS_PAGE.ADD_USER.FORM.LAST_NAME.PLACEHOLDER": "Introduzca el apellido",
    "USERS_PAGE.ADD_USER.FORM.ROLE.LABEL": "Role",
    "USERS_PAGE.ADD_USER.FORM.ROLE.PLACEHOLDER": "Elija Rol",
    "USERS_PAGE.ADD_USER.FORM.SUBMIT": "Agregar usuario",
    "USERS_PAGE.ADD_USER.STATUS": "Estado",
    "USERS_PAGE.CRUMB": "Usuarios",
    "USERS_PAGE.DELETE_USER.TITLE": "¿Está seguro de que desea eliminar este usuario?",
    "USERS_PAGE.SUBTITLE": "Alguna otra información importante va aquí",
    "USERS_PAGE.TABLE.ACTIONS": "Comportamiento",
    "USERS_PAGE.TABLE.COMPANY": "Compañía",
    "USERS_PAGE.TABLE.EMAIL": "Correo electrónico",
    "USERS_PAGE.TABLE.ID": "IDENTIFICACIÓN",
    "USERS_PAGE.TABLE.NAME": "Nombre",
    "USERS_PAGE.TABLE.ROLE": "Role",
    "USERS_PAGE.TABLE.STATUS": "Estado",
    "USERS_PAGE.TITLE.NO_USERS": "no hay usuarios",
    "USERS_PAGE.TITLE.TOTAL_COUNT": "Usuarios totales:",
    "VALIDATION.BRANCHES.UNIQUE": "El nombre del proyecto debe ser único",
    "VALIDATION.EMAIL": "Email inválido",
    "VALIDATION.MAX": "Debe tener menos de %1$s caracteres",
    "VALIDATION.PASSWORD.CONFIRM": "La contraseña y la repetición de la contraseña deben ser las mismas",
    "VALIDATION.PASSWORD.LONG": "La contraseña debe tener menos de 128 caracteres",
    "VALIDATION.PASSWORD.SHORT": "La contraseña debe tener más de 8 caracteres",
    "VALIDATION.PASSWORD.SPECIAL": "La contraseña debe contener al menos un carácter especial",
    "VALIDATION.PHONE": "El teléfono no es válido",
    "VALIDATION.REQUIRED": "Requerido",
    "VIEW_COMPANIES.BUTTON.ADD": "Agregar Compañía",
    "VIEW_COMPANIES.DELETE_ICON": "Icono de eliminar",
    "VIEW_COMPANIES.EDIT_ICON": "Icono de edición",
    "VIEW_COMPANIES.TITLE.ACTION": "Acción",
    "VIEW_COMPANIES.TITLE.COMPANY_CODE": "Código de la Empresa",
    "VIEW_COMPANIES.TITLE.COUNTRY": "Código de País",
    "VIEW_COMPANIES.TITLE.CURRENCY": "Moneda",
    "VIEW_COMPANIES.TITLE.LIST": "Listar Empresas",
    "VIEW_COMPANIES.TITLE.NAME": "Nombre",
    "VIEW_COMPANIES.TITLE.PAGE": "Ver Empresas",
    "VIEW_COMPANIES.TITLE.PARTNER": "Socio",
    "VIEW_COMPANIES.TITLE.UNIT": "Unidad",
    "VIEW_DRAFTS.DIALOG.DELETE.CANCEL": "Indiferencia",
    "VIEW_DRAFTS.DIALOG.DELETE.CONFIRM": "Borrar",
    "VIEW_DRAFTS.DIALOG.DELETE.TITLE": "¿Estás seguro que deseas eliminar este borrador?",
    "VIEW_DRAFTS.TITLE.PAGE": "Ver borradores",
    "VIEW_PARTNERS.BUTTON.ADD": "Agregar Socio",
    "VIEW_PARTNERS.TITLE.ACTION": "Acción",
    "VIEW_PARTNERS.TITLE.COUNTRY": "Código de país",
    "VIEW_PARTNERS.TITLE.LIST": "Lista de Socios",
    "VIEW_PARTNERS.TITLE.NAME": "Nombre",
    "VIEW_PARTNERS.TITLE.PAGE": "Ver Socios",
    "VIEW_PARTNERS.TITLE.PARTNER_CODE": "Código de Socio",
    "VIEW_PROJECT_ARCHIVES.DESCRIPTION": "Para reactivar un proyecto, comuníquese con el soporte.",
    "VIEW_PROJECTS.ACTION.APPROVE": "Aprobar",
    "VIEW_PROJECTS.ACTION.ARCHIVE": "Archivo",
    "VIEW_PROJECTS.ACTION.DECLINE": "Rechazar",
    "VIEW_PROJECTS.ACTION.DELETE": "Borrar",
    "VIEW_PROJECTS.ACTION.EDIT": "Editar",
    "VIEW_PROJECTS.ACTION.REJECT": "Rechazar",
    "VIEW_PROJECTS.ACTION.VIEW": "Vista",
    "VIEW_PROJECTS.ACTION.VIEW_REJECTION_NOTES": "Ver notas de rechazo",
    "VIEW_PROJECTS.BUTTON.ADD": "Añadir Proyecto",
    "VIEW_PROJECTS.DIALOG.APPROVE.CANCEL": "Indiferencia",
    "VIEW_PROJECTS.DIALOG.APPROVE.CONFIRM": "Aprobar",
    "VIEW_PROJECTS.DIALOG.APPROVE.TITLE": "¿Estás seguro que deseas aprobar este proyecto?",
    "VIEW_PROJECTS.DIALOG.ARCHIVE.CANCEL": "Indiferencia",
    "VIEW_PROJECTS.DIALOG.ARCHIVE.CONFIRM": "Confirmar",
    "VIEW_PROJECTS.DIALOG.ARCHIVE.DESCRIPTION": "Al mover el proyecto al archivo, los archivos, puntos de referencia y sesiones asociados estarán inactivos y no se podrá acceder a ellos. Para reactivarlo, puede abrir un ticket de soporte.",
    "VIEW_PROJECTS.DIALOG.ARCHIVE.TITLE": "¿Estás seguro de que deseas archivar este proyecto?",
    "VIEW_PROJECTS.DIALOG.DELETE.CANCEL": "Indiferencia",
    "VIEW_PROJECTS.DIALOG.DELETE.CONFIRM": "Borrar",
    "VIEW_PROJECTS.DIALOG.DELETE.TITLE": "¿Estás seguro que deseas eliminar este proyecto?",
    "VIEW_PROJECTS.DIALOG.REJECT.CANCEL": "Indiferencia",
    "VIEW_PROJECTS.DIALOG.REJECT.CONFIRM": "Rechazar",
    "VIEW_PROJECTS.DIALOG.REJECT.TITLE": "¿Estás seguro que deseas rechazar este proyecto?",
    "VIEW_PROJECTS.FORM.FILTER.ALL": "Todo",
    "VIEW_PROJECTS.FORM.FILTER.APPROVED": "Aprobado",
    "VIEW_PROJECTS.FORM.FILTER.SUBMITTED": "Enviado",
    "VIEW_PROJECTS.NOT_FOUND": "No se encontraron proyectos",
    "VIEW_PROJECTS.TITLE.ACTION": "Acción",
    "VIEW_PROJECTS.TITLE.AUTHOR": "Creado por",
    "VIEW_PROJECTS.TITLE.COMPANY": "Empresa",
    "VIEW_PROJECTS.TITLE.DMAS": "Ver DMAs",
    "VIEW_PROJECTS.TITLE.DMAS_SUBLIST_TITLE": "Lista de DMAs",
    "VIEW_PROJECTS.TITLE.END_DATE": "Fecha de finalización",
    "VIEW_PROJECTS.TITLE.LIST": "Lista de Proyectos",
    "VIEW_PROJECTS.TITLE.NAME": "Nombre",
    "VIEW_PROJECTS.TITLE.NO_DMAS": "No hay DMAs",
    "VIEW_PROJECTS.TITLE.PAGE": "Ver Proyectos",
    "VIEW_PROJECTS.TITLE.START_DATE": "Fecha de inicio",
    "VIEW_PROJECTS.TITLE.STATUS": "Estado",
    "VIEW_USERS.ACTION.DELETE": "Borrar",
    "VIEW_USERS.ACTION.EDIT": "Editar",
    "VIEW_USERS.ACTION.FORGOT_PASSWORD": "Restablecer contraseña",
    "VIEW_USERS.BUTTON.ADD": "Agregar usuario",
    "VIEW_USERS.BUTTON.INVITE": "Invitar usuario",
    "VIEW_USERS.PAGINATION.TITLE": "Filas por página",
    "VIEW_USERS.ROW.ICON.DELETE.ALT": "Icono de eliminar",
    "VIEW_USERS.ROW.ICON.EDIT.ALT": "Icono de editar",
    "VIEW_USERS.TITLE.LIST": "Lista de Usuarios",
    "VIEW_USERS.TITLE.PAGE": "Ver Usuarios",
    "VIEW_USERS.TITLE.ROW_FIVE": "Acción",
    "VIEW_USERS.TITLE.ROW_FOUR": "Rol",
    "VIEW_USERS.TITLE.ROW_ONE": "Nombre",
    "VIEW_USERS.TITLE.ROW_THREE": "Empresa",
    "VIEW_USERS.TITLE.ROW_TWO": "Socio",
    "WAYPOINT_PAGE.ADD_JOB.ADDRESS": "Dirección",
    "WAYPOINT_PAGE.ADD_JOB.DATE_EXTERNALLY": "Fecha Elevada Externamente",
    "WAYPOINT_PAGE.ADD_JOB.DATE_INTERNALLY": "Fecha Elevada Internamente",
    "WAYPOINT_PAGE.ADD_JOB.DESCRIPTION": "Agregar un trabajo al punto de referencia",
    "WAYPOINT_PAGE.ADD_JOB.DISCARD": "Descartar",
    "WAYPOINT_PAGE.ADD_JOB.ENGINEERING_NOTE": "Nota de Ingeniería",
    "WAYPOINT_PAGE.ADD_JOB.ENVIRONMENTAL_NOTE": "Nota Ambiental",
    "WAYPOINT_PAGE.ADD_JOB.ERROR.DESC": "Por favor, actualiza e intenta de nuevo",
    "WAYPOINT_PAGE.ADD_JOB.ERROR.TITLE": "Algo salió mal",
    "WAYPOINT_PAGE.ADD_JOB.ESTIMATED_SIZE": "Tamaño estimado de la fuga",
    "WAYPOINT_PAGE.ADD_JOB.ESTIMATED_SIZE_UNIT": "Unidad de tamaño de fuga",
    "WAYPOINT_PAGE.ADD_JOB.FLOW_REDUCTION": "Reducción de Flujo Acordada (m3/hr)",
    "WAYPOINT_PAGE.ADD_JOB.IMAGE_ALT": "Imagen cargada %1$s",
    "WAYPOINT_PAGE.ADD_JOB.IMAGES": "Medios de comunicación",
    "WAYPOINT_PAGE.ADD_JOB.JOB_COMMENT": "Notas",
    "WAYPOINT_PAGE.ADD_JOB.JOB_STATUS": "Estado del trabajo",
    "WAYPOINT_PAGE.ADD_JOB.JOB_STATUS.CANCELLED": "Cancelado",
    "WAYPOINT_PAGE.ADD_JOB.JOB_STATUS.DRY_DIG": "Excavación Seca",
    "WAYPOINT_PAGE.ADD_JOB.JOB_STATUS.DRY_DIG_APPEALED": "Apelación de Excavación Seca",
    "WAYPOINT_PAGE.ADD_JOB.JOB_STATUS.NFA": "NFA (No se requiere más acción)",
    "WAYPOINT_PAGE.ADD_JOB.JOB_STATUS.PLACEHOLDER": "Seleccione un estado de trabajo",
    "WAYPOINT_PAGE.ADD_JOB.JOB_STATUS.RAISED_EXTERNALLY": "Elevado externamente",
    "WAYPOINT_PAGE.ADD_JOB.JOB_STATUS.RAISED_INTERNALLY": "Elevado internamente",
    "WAYPOINT_PAGE.ADD_JOB.JOB_STATUS.REPAIRED": "Reparado",
    "WAYPOINT_PAGE.ADD_JOB.JOB_STATUS.RFA": "RFA (Solicitar más acciones)",
    "WAYPOINT_PAGE.ADD_JOB.JOB_STATUS.VALIDATION": "Por favor, proporciona un estado de trabajo",
    "WAYPOINT_PAGE.ADD_JOB.JOB_TYPE": "Tipo de trabajo",
    "WAYPOINT_PAGE.ADD_JOB.JOB_TYPE.ASSET_VALVE_HYDRANT_LEAK": "Fuga de Activo (Válvula/ Hidrante)",
    "WAYPOINT_PAGE.ADD_JOB.JOB_TYPE.CLIENT_METER_PRV_LEAK": "Fuga en el Medidor/PRV del Cliente",
    "WAYPOINT_PAGE.ADD_JOB.JOB_TYPE.COMM_PIPE_LEAK": "Fuga en la tubería de comunicación",
    "WAYPOINT_PAGE.ADD_JOB.JOB_TYPE.CUSTOMER_METER_LEAK": "Fuga en el Medidor del Cliente",
    "WAYPOINT_PAGE.ADD_JOB.JOB_TYPE.CUSTOMER_SIDE_LEAK": "Fuga del Lado del Cliente",
    "WAYPOINT_PAGE.ADD_JOB.JOB_TYPE.FERRULE_LEAK": "Fuga en la virola",
    "WAYPOINT_PAGE.ADD_JOB.JOB_TYPE.MAINS_LEAK": "Fuga de agua principal",
    "WAYPOINT_PAGE.ADD_JOB.JOB_TYPE.NETWORK_MAINTENANCE": "Mantenimiento de la Red",
    "WAYPOINT_PAGE.ADD_JOB.JOB_TYPE.PLACEHOLDER": "Seleccione un tipo de trabajo",
    "WAYPOINT_PAGE.ADD_JOB.JOB_TYPE.RENEW_STOP_TAP_MSM": "Renovar Grifo de Parada/MSM",
    "WAYPOINT_PAGE.ADD_JOB.JOB_TYPE.RESOLVED_ONSITE": "Resuelto en el Sitio",
    "WAYPOINT_PAGE.ADD_JOB.JOB_TYPE.VALIDATION": "Por favor, proporciona un tipo de trabajo",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_ESTIMATE": "Estimación del Tamaño de la Fuga del Cliente",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE": "Tipo de fuga",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.ASSET_LEAK": "Fuga de Activos",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.CLIENT_METER_PRV_LEAK": "Fuga en el Medidor/ Válvula Reductora de Presión del Cliente",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.COMMERCIAL_REPAIR": "Reparación Comercial",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.COMMUNICATION_PIPE": "Tubo de Comunicación",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.CSL": "CSL",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.CUSTOMER_METER_LEAK": "Fuga en el Medidor del Cliente",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.CUSTOMER_SIDE_LEAK": "Fuga del Lado del Cliente",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.DECOMMISSION_FERRULE": "Desmantelar Ferrule",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.EXCAVATE_TRIAL_HOLE_PERMIT": "Excavar Pozo de Prueba (Permiso)",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.EXTERNAL_LEAKING_METER_GT_40MM_INC_EXC": "Medidor de Fugas Externo>40mm Inc Exc",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.EXTERNAL_LEAKING_METER_GT_40MM_NO_EXC": "Medidor de Fugas Externo>40mm Sin Exc",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.EXTERNAL_LEAKING_METER_LT_40MM_INC_EXC": "Medidor de Fugas Externo<40mm Inc Exc",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.EXTERNAL_LEAKING_METER_LT_40MM_NO_EXC": "Medidor Externo de Fugas<40mm Sin Exc",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.FERRULE": "Férula",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.FH_STOPPED_ON_SITE": "F/H se detuvo en el sitio",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.FIRE_HYDRANT": "Extintor de Incendios",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.FIRE_MAIN": "Red de Incendios",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.FLOW_TEST_AT_BOUNDARY_NO_EXC": "Prueba de Flujo en el Límite Sin Exc",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.FLOW_TEST_AT_BOUNDARY_WITH_EXC": "Prueba de Flujo en el Límite con Exc",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.INST_MSM_TO_EXIST_COMM_PIPE_UNMTRD": "Instalar MSM en tubería de comunicación existente sin medidor",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.INSTALL_FERRULE_ONLY": "Instalar solo el casquillo",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.INSTALL_MSM_INC_METER": "Instalar Medidor de MSM Inc",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.INSTALL_SAMPLE_TAP": "Instalar Sample Tap",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.INSTALL_SLUICE_VALVE": "Instalar Válvula de Compuerta",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.INSTALL_WASHOUT_HYDRANT": "Instalar Hidrante de Lavado",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.LEAK_FIXED_ONSITE": "Fuga Reparada en el Sitio",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.LEAK_ON_FH": "Fuga en F/H",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.LEAK_ON_SPINDLE_OF_SV": "Fuga en el husillo de SV",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.LEAK_ON_SPINDLE_OF_SV_FLANGE": "Fuga en el husillo de SV / brida.",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.MAINS": "Platos principales",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.MAINS_BURST": "Ruptura de la tubería principal",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.MAINS_LEAK": "Fuga de agua principal",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.NA_WO_STOPPED_ON_SITE": "N/D - Trabajo detenido en el sitio ",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.NETWORK_MAINTENANCE": "Mantenimiento de la Red",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.NO_LEAK": "Sin Fugas",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.OSV_EXCHANGE": "Intercambio OSV",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.OTHER": "Otro",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.PASSING_FH": "Aprobando FH",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.PASSING_HYDRANT": "Hydrante Pasando",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.PLACEHOLDER": "Seleccione un tipo de fuga",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REMEDIAL_WORK_EXTERNAL": "Trabajo Remedio Externo",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REMOVE_SLUICE_VAVLE": "Eliminar Válvula de Compuerta",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.RENEW_COMMUNICATION_PIPE_LONGSIDE": "Renovar Tubo de Comunicación Longside",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.RENEW_COMMUNICATION_PIPE_SHORTSIDE": "Renovar Tubo de Comunicación Lado Corto",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.RENEW_COVER_FRAME_STANDARD": "Renovar Cubierta & Marco (Estándar)",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.RENEW_FERRULE_ONLY": "Renovar solo el casquillo",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.RENEW_FIRE_HYDRANT": "Renovar Hidrante de Incendios",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.RENEW_FIRE_HYDRANT_CHAMBER": "Renovar Cámara de Hidrante de Incendios",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.RENEW_FIRE_HYDRANT_FRAME_COVER": "Renovar Marco y Cubierta de Hidrante de Incendios",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.RENEW_LEAKING_SUPPLY_PIPE_GT_10M": "Renovar tubería de suministro con fugas >10m",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.RENEW_LEAKING_SUPPLY_PIPE_LT_10M": "Renovar tubería de suministro con fugas <10m ",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.RENEW_MSM_STOP_TAP_ASSEMBLY": "Renovar el Ensamblaje de la Válvula de Parada/MSM",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.RENEW_SLUICE_VAVLE": "Renovar Válvula de Compuerta",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.RENEW_WASHOUT_HYDRANT": "Renovar Hidrante de Lavado",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPACK_SLUICE_VALVE": "Reempaque la Válvula de Compuerta",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPAIR_COMMUNICATION_PIPE": "Reparar Tubo de Comunicación",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPAIR_EXTERNAL_LSP_NON_ELIGIBLE": "Reparar LSP Externo - No Elegible",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPAIR_INTERNAL_LEAK_RECH": "Reparar Fuga Interna (Rech)",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPAIR_LEAKING_SUPPLY_PIPE_RECH": "Reparar Tubería de Suministro con Fugas (Rech)",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPAIR_LOP": "Reparar LOP",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPAIR_LSP_ELIGIBLE": "Reparar LSP - Elegible",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPAIR_MAIN_DOWEL_PIECE_GTE_200MM": "Reparar Pieza Principal de Espiga >=200mm",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPAIR_MAIN_DOWEL_PIECE_LT_200MM": "Reparar Pieza Principal de Espiga <200mm",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPAIR_MAIN_NOT_DOWEL_GTE_200MM": "Reparar Principal [No Clavija] >=200mm",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPAIR_MAIN_NOT_DOWEL_LT_200MM": "Reparar Principal [No Clavija] <200mm",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPAIR_MAJOR_BURST": "Reparar Gran Rotura",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPAIR_NON_RETURN_VALVE": "Reparar Válvula de No Retorno",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPAIR_RUNNING_OVERFLOW_RECH": "Reparación de Desbordamiento en Ejecución (Rech)",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPAIR_SLUICE_VALVE": "Reparar Válvula de Compuerta",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPOSITION_MSM_STOP_TAP_ASSEMBLY": "Reposicione el conjunto de grifo/MSM",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.RESET_SURFACE_BOX_STANDARD": "Restablecer Caja de Superficie (Estándar)",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.SERVICE_LEAK": "Fuga de Servicio",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.SLUICE_VALVE": "Válvula de Compuerta",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.SLUICE_VALVE_VL": "Válvula de Compuerta (VL)",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.STOP_TAP_EXCHANGE": "Intercambio de Grifo de Parada",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.STOP_TAP_LEAK": "Detén la Fuga del Grifo",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.STOP_TAP_LEAK_NO_7_FERRULE_EXCHANGE_NO_5": "Detener la fuga del grifo No.7\\n\\nCambio de virola No.5",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.VALIDATION": "Por favor, proporciona un tipo de fuga",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.WO_FH": "WO / FH",
    "WAYPOINT_PAGE.ADD_JOB.PIPE_DIAMETER": "Diámetro de la tubería",
    "WAYPOINT_PAGE.ADD_JOB.PIPE_DIAMETER_UNIT": "Unidad de diámetro",
    "WAYPOINT_PAGE.ADD_JOB.PIPE_MATERIAL": "Material de tubería",
    "WAYPOINT_PAGE.ADD_JOB.REMOVE_IMAGE_ARIA": "Eliminar imagen %1$s",
    "WAYPOINT_PAGE.ADD_JOB.REPAIR_DATE": "Fecha de Reparación",
    "WAYPOINT_PAGE.ADD_JOB.ROAD_SPEED": "Velocidad de la Carretera",
    "WAYPOINT_PAGE.ADD_JOB.SELECT_UNIT.PLACEHOLDER": "Seleccionar unidad",
    "WAYPOINT_PAGE.ADD_JOB.SUBMIT": "Agregar Nuevo Trabajo",
    "WAYPOINT_PAGE.ADD_JOB.SUBMIT.VALIDATION": "La validación falló, por favor revise las entradas.",
    "WAYPOINT_PAGE.ADD_JOB.SUCCESS": "Trabajo agregado con éxito",
    "WAYPOINT_PAGE.ADD_JOB.SURFACE_TYPE": "Tipo de superficie",
    "WAYPOINT_PAGE.ADD_JOB.TITLE": "Agregar trabajo a punto de referencia",
    "WAYPOINT_PAGE.ADD_JOB.W3W": "What3Words",
    "WAYPOINT_PAGE.ADD_JOB.WORK_ORDER": "Referencia de la Orden de Trabajo del Cliente/Utilidad",
    "WAYPOINT_PAGE.ADD_JOB.WORK_ORDER.VALIDATION": "Por favor, proporcione una referencia de orden de trabajo del cliente/utilidad",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.ACTION": "Acción",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.DATE": "Fecha",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.address": "Dirección",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.agreed_flow_reduction": "Reducción de Flujo",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.comment": "Comentario",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.date_raised_externally": "Fecha Elevada Externamente",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.date_raised_internally": "Fecha Elevada Internamente",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.environmental_notes": "Notas Ambientales",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.estimate_leak_size": "Tamaño estimado de la fuga",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.id": "ID",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.job_status": "Estado del trabajo",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.job_type": "Tipo de trabajo",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.leak_type_id": "ID de Tipo de Fuga",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.material": "Material",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.pipe_diameter": "Diámetro de la tubería",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.repair_date": "Fecha de Reparación",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.road_speed": "Velocidad de la Carretera",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.surface_type": "Tipo de superficie",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.urls": "URLs",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.w3w": "W3W",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.waypoint_id": "ID de punto de referencia",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.work_order": "Referencia de la Orden de Trabajo del Cliente/Utilidad",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.NEW": "Nuevo Valor",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.NOTES": "Notas Adicionales",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.OLD": "Valor Anterior",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.STATUS": "Estado",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.TITLE": "Registros de Trabajo",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.USER": "Usuario",
    "WAYPOINT_PAGE.JOB_TABLE.CREATED_DATE": "Fecha de creación",
    "WAYPOINT_PAGE.JOB_TABLE.DATE_ERROR": "La fecha de inicio debe ser anterior a la fecha de finalización",
    "WAYPOINT_PAGE.JOB_TABLE.DATE_TYPE": "Tipo de Fecha",
    "WAYPOINT_PAGE.JOB_TABLE.DATE_TYPE.PLACEHOLDER": "Seleccione el tipo de fecha",
    "WAYPOINT_PAGE.JOB_TABLE.END_DATE": "Fecha de finalización",
    "WAYPOINT_PAGE.JOB_TABLE.FILTER.Asset (Valve/Hydrant) Leak": "Fuga de Activo (Válvula/Hidrante)",
    "WAYPOINT_PAGE.JOB_TABLE.FILTER.Cancelled": "Cancelado",
    "WAYPOINT_PAGE.JOB_TABLE.FILTER.Client Meter/PRV Leak": "Fuga en el Medidor/PRV del Cliente",
    "WAYPOINT_PAGE.JOB_TABLE.FILTER.Comm Pipe Leak": "Fuga en la tubería de comunicación",
    "WAYPOINT_PAGE.JOB_TABLE.FILTER.Customer Meter Leak": "Fuga en el Medidor del Cliente",
    "WAYPOINT_PAGE.JOB_TABLE.FILTER.Ferrule Leak": "Fuga en la virola",
    "WAYPOINT_PAGE.JOB_TABLE.FILTER.Leak Repair": "Reparación de Fugas",
    "WAYPOINT_PAGE.JOB_TABLE.FILTER.Mains Leak": "Fuga de agua principal",
    "WAYPOINT_PAGE.JOB_TABLE.FILTER.Raised externally": "Elevado externamente",
    "WAYPOINT_PAGE.JOB_TABLE.FILTER.Raised internally": "Elevado internamente",
    "WAYPOINT_PAGE.JOB_TABLE.FILTER.Repaired": "Reparado",
    "WAYPOINT_PAGE.JOB_TABLE.FILTER.Scheduled": "Programado",
    "WAYPOINT_PAGE.JOB_TABLE.FILTERS": "Filtros, Ordenación y Búsqueda",
    "WAYPOINT_PAGE.JOB_TABLE.HEADER.CREATED": "Fecha de Creación",
    "WAYPOINT_PAGE.JOB_TABLE.HEADER.FLOW_REDUCTION": "Reducción de Flujo Acordada",
    "WAYPOINT_PAGE.JOB_TABLE.HEADER.JOB_COMMENTS": "Notas",
    "WAYPOINT_PAGE.JOB_TABLE.HEADER.JOB_STATUS": "Estado del trabajo",
    "WAYPOINT_PAGE.JOB_TABLE.HEADER.JOB_TYPE": "Tipo de trabajo",
    "WAYPOINT_PAGE.JOB_TABLE.HEADER.LEAK_SIZE": "Tamaño de la fuga",
    "WAYPOINT_PAGE.JOB_TABLE.HEADER.LEAK_TYPE": "Tipo de fuga",
    "WAYPOINT_PAGE.JOB_TABLE.HEADER.REPAIR_DATE": "Fecha de Reparación",
    "WAYPOINT_PAGE.JOB_TABLE.HEADER.UPDATED_DATE": "Fecha Actualizada",
    "WAYPOINT_PAGE.JOB_TABLE.HEADER.WORK_ORDER": "Referencia de la Orden de Trabajo del Cliente/Utilidad",
    "WAYPOINT_PAGE.JOB_TABLE.NO_DATA": "No hay trabajos que coincidan",
    "WAYPOINT_PAGE.JOB_TABLE.NO_DATA_EXISTS": "No existen trabajos para este punto de ruta",
    "WAYPOINT_PAGE.JOB_TABLE.REPAIR_DATE": "Fecha de reparación",
    "WAYPOINT_PAGE.JOB_TABLE.SEARCH.BUTTON": "Aplica filtros, ordenamiento y búsqueda",
    "WAYPOINT_PAGE.JOB_TABLE.SEARCH.PLACEHOLDER": "Buscar trabajos...",
    "WAYPOINT_PAGE.JOB_TABLE.START_DATE": "Fecha de inicio",
    "WAYPOINT_PAGE.JOB_TABLE.TITLE": "Trabajos para Waypoint",
    "WAYPOINT_PAGE.JOB_TABLE.UPDATED_DATE": "Fecha actualizada",
    "WAYPOINT_PAGE.WAYPOINT_INFO.ACTUAL_LEAK_TYPE": "Tipo de Fuga Actual",
    "WAYPOINT_PAGE.WAYPOINT_INFO.ADD_JOB": "Agregar trabajo",
    "WAYPOINT_PAGE.WAYPOINT_INFO.ADDRESS": "Dirección",
    "WAYPOINT_PAGE.WAYPOINT_INFO.AI_PREDICTED_LEAK_SIZE": "La IA predijo el tamaño de la fuga",
    "WAYPOINT_PAGE.WAYPOINT_INFO.ASSIGNED_ENGINEER": "Ingeniero Asignado",
    "WAYPOINT_PAGE.WAYPOINT_INFO.BTN_MERGE": "Fusionar Punto de Referencia",
    "WAYPOINT_PAGE.WAYPOINT_INFO.CANCEL": "Cancelar",
    "WAYPOINT_PAGE.WAYPOINT_INFO.CNS": "CNS",
    "WAYPOINT_PAGE.WAYPOINT_INFO.COMMENT": "Nota de Ingeniería",
    "WAYPOINT_PAGE.WAYPOINT_INFO.CURRENT_STATUS": "Estado",
    "WAYPOINT_PAGE.WAYPOINT_INFO.DIAMETER": "Diámetro",
    "WAYPOINT_PAGE.WAYPOINT_INFO.DIAMETER_UNIT": "Unidad de diámetro",
    "WAYPOINT_PAGE.WAYPOINT_INFO.DMA_NAME": "Nombre de DMA",
    "WAYPOINT_PAGE.WAYPOINT_INFO.DMA_REFERENCE": "Referencia DMA",
    "WAYPOINT_PAGE.WAYPOINT_INFO.EDIT_FIELDS": "Editar Campos",
    "WAYPOINT_PAGE.WAYPOINT_INFO.ENVIRONMENTAL_NOTES": "Notas Ambientales",
    "WAYPOINT_PAGE.WAYPOINT_INFO.ESTIMATED_SIZE": "Reducción de Flujo Acordada",
    "WAYPOINT_PAGE.WAYPOINT_INFO.ESTIMATED_SIZE_CLIENT": "Estimación del Tamaño de la Fuga del Cliente",
    "WAYPOINT_PAGE.WAYPOINT_INFO.ESTIMATED_SIZE_CLIENT_UNIT": "Unidad de estimación del tamaño de fuga del cliente",
    "WAYPOINT_PAGE.WAYPOINT_INFO.ESTIMATED_SIZE_ENGINEER": "Estimación del Tamaño de la Fuga en el Sitio",
    "WAYPOINT_PAGE.WAYPOINT_INFO.ESTIMATED_SIZE_ENGINEER_UNIT": "Unidad de Estimación del Tamaño de Fugas en el Sitio",
    "WAYPOINT_PAGE.WAYPOINT_INFO.ESTIMATED_SIZE_UNIT": "Unidad de Reducción de Flujo Acordada",
    "WAYPOINT_PAGE.WAYPOINT_INFO.JOB_TYPE_CODE": "Código de trabajo",
    "WAYPOINT_PAGE.WAYPOINT_INFO.LAST_SCHEDULED_ENGINEER": "Ingeniero Asignado",
    "WAYPOINT_PAGE.WAYPOINT_INFO.LAST_UPDATE": "Días desde la última actualización",
    "WAYPOINT_PAGE.WAYPOINT_INFO.LEAK_TYPE": "Tipo de Fuga",
    "WAYPOINT_PAGE.WAYPOINT_INFO.PIPE_MATERIAL": "Material de tubería",
    "WAYPOINT_PAGE.WAYPOINT_INFO.PLACEHOLDER.DATE": "Seleccionar fecha",
    "WAYPOINT_PAGE.WAYPOINT_INFO.PLACEHOLDER.ENGINEER": "Asignar Ingeniero",
    "WAYPOINT_PAGE.WAYPOINT_INFO.PLACEHOLDER.JOB_TYPE_CODE": "Seleccionar código de trabajo",
    "WAYPOINT_PAGE.WAYPOINT_INFO.PLACEHOLDER.LEAK_TYPE": "Seleccione el Tipo de Fuga",
    "WAYPOINT_PAGE.WAYPOINT_INFO.PLACEHOLDER.MATERIAL": "Material de tubería",
    "WAYPOINT_PAGE.WAYPOINT_INFO.PLACEHOLDER.STATUS": "Seleccionar estado",
    "WAYPOINT_PAGE.WAYPOINT_INFO.PREDICTED_LEAK_SIZE": "Estimación del Tipo de Fuga en el Sitio",
    "WAYPOINT_PAGE.WAYPOINT_INFO.PREDICTED_SIZE": "Tamaño previsto",
    "WAYPOINT_PAGE.WAYPOINT_INFO.REPAIR_TIME": "Fecha de excavación",
    "WAYPOINT_PAGE.WAYPOINT_INFO.SUBMIT": "Guardar",
    "WAYPOINT_PAGE.WAYPOINT_INFO.SURFACE_TYPE": "Tipo de superficie",
    "WAYPOINT_PAGE.WAYPOINT_INFO.TITLE": "Información del Punto de Referencia",
    "WAYPOINT_PAGE.WAYPOINT_INFO.WAYPOINT_NAME": "Nombre del punto de referencia",
    "WAYPOINT_PAGE.WAYPOINT_INFO.WHAT_3_WORDS": "¿Qué 3 palabras?",
    "WAYPOINT_PAGE.WAYPOINT_INFO.WHAT3WORDS": "What3Words",
    "WAYPOINT_SIZE_WIDGET.DAY": "Día",
    "WAYPOINT_SIZE_WIDGET.DAY_other": "Días",
    "WAYPOINT_SIZE_WIDGET.NO_NAME": "Ninguno",
    "WAYPOINT_SIZE_WIDGET.SUBTITLE_A": "Última Fuga",
    "WAYPOINT_SIZE_WIDGET.SUBTITLE_B": "Fuga más larga",
    "WAYPOINT_SIZE_WIDGET.SUBTITLE_C": "La fuga más grande",
    "WAYPOINT_SIZE_WIDGET.TITLE": "Puntos de referencia",
    "WIDGET_LAYOUT.CANCEL_TEXT": "No",
    "WIDGET_LAYOUT.CONFIRM_TEXT": "Sí",
    "WIDGET_LAYOUT.FILTERS": "filtros",
    "WIDGET_LAYOUT.MAP_VIEW": "Vista del mapa",
    "WIDGET_LAYOUT.REMOVE_WIDGET": "Eliminar widget",
    "WIDGET_LAYOUT.SETTINGS": "Ajustes",
    "WIDGET_LAYOUT.SUBTITLE": "Se eliminarán todos los ajustes.",
    "WIDGET_LAYOUT.SUMMARY": "Resumen",
    "WIDGET_LAYOUT.TABLE_OF_RESULTS": "Tabla de resultados",
    "WIDGET_LAYOUT.TITLE": "¿Está seguro de que desea eliminar este widget?",
    "BROWSE_VIEW.RELAY.UPTIME": "Tiempo de actividad del relé",
    "BROWSE_VIEW.WAYPOINT.EDIT": "editar",
    "BROWSE_VIEW.WAYPOINT.MERGE_W": "Fusionar punto de referencia",
    "BROWSE_VIEW.WAYPOINT.SECTION.MEDIA": "Medios de comunicación",
    "BROWSE_VIEW.WAYPOINT.SECTION.MEDIA_EMPTY": "No hay medios para este punto de referencia",
    "BROWSE_VIEW.WAYPOINT.SHARE": "compartir",
    "BROWSE.FILTERS.PREDICTED_SIZE.NO_PREDICTION": "Sin predicción",
    "BROWSE.FILTERS.UPTIME": "Tiempo de actividad",
    "BROWSE.FILTERS.UPTIME_PLACEHOLDER": "Seleccionar tiempos de actividad",
    "BROWSE.FILTERS.UPTIME.AVERAGE": "Promedio",
    "BROWSE.FILTERS.UPTIME.GOOD": "Bien",
    "BROWSE.FILTERS.UPTIME.HIGH": "Alto",
    "BROWSE.FILTERS.UPTIME.LOW": "Bajo",
    "BROWSE.FILTERS.UPTIME.MEDIUM": "Medio",
    "BROWSE.FILTERS.UPTIME.POOR": "Pobre",
    "BROWSE.TABLE.COLUMNS.UPTIME": "Tiempo de actividad"
  }
}
